var Xc = Object.defineProperty, Yc = Object.defineProperties;
var Qc = Object.getOwnPropertyDescriptors;
var cs = Object.getOwnPropertySymbols;
var Jc = Object.prototype.hasOwnProperty, Zc = Object.prototype.propertyIsEnumerable;
var hr = (e, t, n) => t in e ? Xc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, It = (e, t) => {
  for (var n in t || (t = {}))
    Jc.call(t, n) && hr(e, n, t[n]);
  if (cs)
    for (var n of cs(t))
      Zc.call(t, n) && hr(e, n, t[n]);
  return e;
}, mr = (e, t) => Yc(e, Qc(t));
var _ = (e, t, n) => (hr(e, typeof t != "symbol" ? t + "" : t, n), n);
var tn = (e, t, n) => new Promise((r, i) => {
  var s = (c) => {
    try {
      a(n.next(c));
    } catch (u) {
      i(u);
    }
  }, o = (c) => {
    try {
      a(n.throw(c));
    } catch (u) {
      i(u);
    }
  }, a = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(s, o);
  a((n = n.apply(e, t)).next());
});
const ab = () => {
  const e = (t) => !(t.name.indexOf("#t=") >= 0 || t.name.indexOf("?t=") >= 0);
  window.performance._getEntriesByName || (window.performance._getEntriesByName = window.performance.getEntriesByName, window.performance.getEntriesByName = (...t) => window.performance._getEntriesByName(...t).filter(e)), window.performance._getEntries || (window.performance._getEntries = window.performance.getEntries, window.performance.getEntries = () => window.performance._getEntries().filter(e)), window.performance._getEntriesByType || (window.performance._getEntriesByType = window.performance.getEntriesByType, window.performance.getEntriesByType = (...t) => window.performance._getEntriesByType(...t).filter(e));
}, cb = (e, t = "") => {
  if (window.location.hash.indexOf(`${e}=`) >= 0) {
    const n = window.location.hash.substr(1), r = n.indexOf(`${e}=`);
    if (r >= 0) {
      const i = r + e.length + 1, s = n.indexOf("&", i);
      return (s > 0 ? n.substring(i, s) : n.substring(i)) || t;
    }
  }
  return window.location.search.indexOf(`${e}=`) >= 0 && new URLSearchParams(window.location.search).get(e) || t;
}, ub = () => window.location.hash.includes("t=");
var eu = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function tu(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var To = {}, nu = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
To.validate = function(e) {
  if (!e || e.length > 254)
    return !1;
  var t = nu.test(e);
  if (!t)
    return !1;
  var n = e.split("@");
  if (n[0].length > 64)
    return !1;
  var r = n[1].split(".");
  return !r.some(function(i) {
    return i.length > 63;
  });
};
const lb = (e, t) => t === "email" ? !To.validate(e.trim()) : e.trim().length === 0;
var yo = { exports: {} }, C = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var us = Object.getOwnPropertySymbols, ru = Object.prototype.hasOwnProperty, iu = Object.prototype.propertyIsEnumerable;
function su(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function ou() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var t = {}, n = 0; n < 10; n++)
      t["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(t).map(function(s) {
      return t[s];
    });
    if (r.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(s) {
      i[s] = s;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch (s) {
    return !1;
  }
}
var au = ou() ? Object.assign : function(e, t) {
  for (var n, r = su(e), i, s = 1; s < arguments.length; s++) {
    n = Object(arguments[s]);
    for (var o in n)
      ru.call(n, o) && (r[o] = n[o]);
    if (us) {
      i = us(n);
      for (var a = 0; a < i.length; a++)
        iu.call(n, i[a]) && (r[i[a]] = n[i[a]]);
    }
  }
  return r;
};
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gi = au, ht = 60103, wo = 60106;
C.Fragment = 60107;
C.StrictMode = 60108;
C.Profiler = 60114;
var Ao = 60109, Oo = 60110, Ro = 60112;
C.Suspense = 60113;
var Po = 60115, Io = 60116;
if (typeof Symbol == "function" && Symbol.for) {
  var ae = Symbol.for;
  ht = ae("react.element"), wo = ae("react.portal"), C.Fragment = ae("react.fragment"), C.StrictMode = ae("react.strict_mode"), C.Profiler = ae("react.profiler"), Ao = ae("react.provider"), Oo = ae("react.context"), Ro = ae("react.forward_ref"), C.Suspense = ae("react.suspense"), Po = ae("react.memo"), Io = ae("react.lazy");
}
var ls = typeof Symbol == "function" && Symbol.iterator;
function cu(e) {
  return e === null || typeof e != "object" ? null : (e = ls && e[ls] || e["@@iterator"], typeof e == "function" ? e : null);
}
function Vt(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Co = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, No = {};
function mt(e, t, n) {
  this.props = e, this.context = t, this.refs = No, this.updater = n || Co;
}
mt.prototype.isReactComponent = {};
mt.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error(Vt(85));
  this.updater.enqueueSetState(this, e, t, "setState");
};
mt.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function xo() {
}
xo.prototype = mt.prototype;
function _i(e, t, n) {
  this.props = e, this.context = t, this.refs = No, this.updater = n || Co;
}
var bi = _i.prototype = new xo();
bi.constructor = _i;
gi(bi, mt.prototype);
bi.isPureReactComponent = !0;
var vi = { current: null }, Lo = Object.prototype.hasOwnProperty, Mo = { key: !0, ref: !0, __self: !0, __source: !0 };
function ko(e, t, n) {
  var r, i = {}, s = null, o = null;
  if (t != null)
    for (r in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (s = "" + t.key), t)
      Lo.call(t, r) && !Mo.hasOwnProperty(r) && (i[r] = t[r]);
  var a = arguments.length - 2;
  if (a === 1)
    i.children = n;
  else if (1 < a) {
    for (var c = Array(a), u = 0; u < a; u++)
      c[u] = arguments[u + 2];
    i.children = c;
  }
  if (e && e.defaultProps)
    for (r in a = e.defaultProps, a)
      i[r] === void 0 && (i[r] = a[r]);
  return { $$typeof: ht, type: e, key: s, ref: o, props: i, _owner: vi.current };
}
function uu(e, t) {
  return { $$typeof: ht, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function Ei(e) {
  return typeof e == "object" && e !== null && e.$$typeof === ht;
}
function lu(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var ds = /\/+/g;
function gr(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? lu("" + e.key) : t.toString(36);
}
function _n(e, t, n, r, i) {
  var s = typeof e;
  (s === "undefined" || s === "boolean") && (e = null);
  var o = !1;
  if (e === null)
    o = !0;
  else
    switch (s) {
      case "string":
      case "number":
        o = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case ht:
          case wo:
            o = !0;
        }
    }
  if (o)
    return o = e, i = i(o), e = r === "" ? "." + gr(o, 0) : r, Array.isArray(i) ? (n = "", e != null && (n = e.replace(ds, "$&/") + "/"), _n(i, t, n, "", function(u) {
      return u;
    })) : i != null && (Ei(i) && (i = uu(i, n + (!i.key || o && o.key === i.key ? "" : ("" + i.key).replace(ds, "$&/") + "/") + e)), t.push(i)), 1;
  if (o = 0, r = r === "" ? "." : r + ":", Array.isArray(e))
    for (var a = 0; a < e.length; a++) {
      s = e[a];
      var c = r + gr(s, a);
      o += _n(s, t, n, c, i);
    }
  else if (c = cu(e), typeof c == "function")
    for (e = c.call(e), a = 0; !(s = e.next()).done; )
      s = s.value, c = r + gr(s, a++), o += _n(s, t, n, c, i);
  else if (s === "object")
    throw t = "" + e, Error(Vt(31, t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
  return o;
}
function nn(e, t, n) {
  if (e == null)
    return e;
  var r = [], i = 0;
  return _n(e, r, "", "", function(s) {
    return t.call(n, s, i++);
  }), r;
}
function du(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), e._status = 0, e._result = t, t.then(function(n) {
      e._status === 0 && (n = n.default, e._status = 1, e._result = n);
    }, function(n) {
      e._status === 0 && (e._status = 2, e._result = n);
    });
  }
  if (e._status === 1)
    return e._result;
  throw e._result;
}
var Do = { current: null };
function Ce() {
  var e = Do.current;
  if (e === null)
    throw Error(Vt(321));
  return e;
}
var fu = { ReactCurrentDispatcher: Do, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: vi, IsSomeRendererActing: { current: !1 }, assign: gi };
C.Children = { map: nn, forEach: function(e, t, n) {
  nn(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return nn(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return nn(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!Ei(e))
    throw Error(Vt(143));
  return e;
} };
C.Component = mt;
C.PureComponent = _i;
C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fu;
C.cloneElement = function(e, t, n) {
  if (e == null)
    throw Error(Vt(267, e));
  var r = gi({}, e.props), i = e.key, s = e.ref, o = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (s = t.ref, o = vi.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps)
      var a = e.type.defaultProps;
    for (c in t)
      Lo.call(t, c) && !Mo.hasOwnProperty(c) && (r[c] = t[c] === void 0 && a !== void 0 ? a[c] : t[c]);
  }
  var c = arguments.length - 2;
  if (c === 1)
    r.children = n;
  else if (1 < c) {
    a = Array(c);
    for (var u = 0; u < c; u++)
      a[u] = arguments[u + 2];
    r.children = a;
  }
  return {
    $$typeof: ht,
    type: e.type,
    key: i,
    ref: s,
    props: r,
    _owner: o
  };
};
C.createContext = function(e, t) {
  return t === void 0 && (t = null), e = { $$typeof: Oo, _calculateChangedBits: t, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null }, e.Provider = { $$typeof: Ao, _context: e }, e.Consumer = e;
};
C.createElement = ko;
C.createFactory = function(e) {
  var t = ko.bind(null, e);
  return t.type = e, t;
};
C.createRef = function() {
  return { current: null };
};
C.forwardRef = function(e) {
  return { $$typeof: Ro, render: e };
};
C.isValidElement = Ei;
C.lazy = function(e) {
  return { $$typeof: Io, _payload: { _status: -1, _result: e }, _init: du };
};
C.memo = function(e, t) {
  return { $$typeof: Po, type: e, compare: t === void 0 ? null : t };
};
C.useCallback = function(e, t) {
  return Ce().useCallback(e, t);
};
C.useContext = function(e, t) {
  return Ce().useContext(e, t);
};
C.useDebugValue = function() {
};
C.useEffect = function(e, t) {
  return Ce().useEffect(e, t);
};
C.useImperativeHandle = function(e, t, n) {
  return Ce().useImperativeHandle(e, t, n);
};
C.useLayoutEffect = function(e, t) {
  return Ce().useLayoutEffect(e, t);
};
C.useMemo = function(e, t) {
  return Ce().useMemo(e, t);
};
C.useReducer = function(e, t, n) {
  return Ce().useReducer(e, t, n);
};
C.useRef = function(e) {
  return Ce().useRef(e);
};
C.useState = function(e) {
  return Ce().useState(e);
};
C.version = "17.0.2";
yo.exports = C;
var pu = yo.exports;
const hu = 250, mu = 50;
class gu {
  constructor(t, n) {
    var r, i;
    this.signalBuffer = [], this.itemLimit = (r = n == null ? void 0 : n.itemLimit) !== null && r !== void 0 ? r : mu, this.sendTimeout = (i = n == null ? void 0 : n.sendTimeout) !== null && i !== void 0 ? i : hu, this.paused = (n == null ? void 0 : n.paused) || !1, this.sendFn = t, this.flushInterval = -1, this.paused || this.start(), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && this.flush();
    });
  }
  addItem(t) {
    this.paused || (this.signalBuffer.push(t), this.signalBuffer.length >= this.itemLimit && this.flush());
  }
  start() {
    this.paused = !1, this.sendTimeout > 0 && (this.flushInterval = window.setInterval(() => this.flush(), this.sendTimeout));
  }
  pause() {
    this.paused = !0, clearInterval(this.flushInterval);
  }
  groupItems(t) {
    const n = /* @__PURE__ */ new Map();
    return t.forEach((r) => {
      const i = JSON.stringify(r.meta);
      let s = n.get(i);
      s === void 0 ? s = [r] : s = [...s, r], n.set(i, s);
    }), Array.from(n.values());
  }
  flush() {
    if (this.paused || this.signalBuffer.length === 0)
      return;
    this.groupItems(this.signalBuffer).forEach(this.sendFn), this.signalBuffer = [];
  }
}
var H;
(function(e) {
  e.EXCEPTION = "exception", e.LOG = "log", e.MEASUREMENT = "measurement", e.TRACE = "trace", e.EVENT = "event";
})(H || (H = {}));
const _u = {
  [H.EXCEPTION]: "exceptions",
  [H.LOG]: "logs",
  [H.MEASUREMENT]: "measurements",
  [H.TRACE]: "traces",
  [H.EVENT]: "events"
};
function bu(e, t, n, r) {
  var i;
  t.debug("Initializing transports");
  const s = [];
  let o = n.paused, a = [];
  const c = (...w) => {
    t.debug("Adding transports"), w.forEach((E) => {
      if (t.debug(`Adding "${E.name}" transport`), s.some((I) => I === E)) {
        t.warn(`Transport ${E.name} is already added`);
        return;
      }
      E.unpatchedConsole = e, E.internalLogger = t, E.config = n, E.metas = r, s.push(E);
    });
  }, u = (...w) => {
    t.debug(`Adding beforeSendHooks
`, a), w.forEach((E) => {
      E && a.push(E);
    });
  }, f = (w) => {
    let E = w;
    for (const T of a) {
      const I = E.map(T).filter(Boolean);
      if (I.length === 0)
        return [];
      E = vu(I, n);
    }
    return E;
  }, m = (w) => {
    const E = f(w);
    if (E.length !== 0)
      for (const T of s)
        t.debug(`Transporting item using ${T.name}
`, E), T.isBatched() && T.send(E);
  }, l = (w) => {
    var E, T;
    if (!((E = n.batching) === null || E === void 0) && E.enabled && s.every((q) => q.isBatched()))
      return;
    const [I] = f([w]);
    if (I !== void 0)
      for (const q of s)
        t.debug(`Transporting item using ${q.name}
`, I), q.isBatched() ? !((T = n.batching) === null || T === void 0) && T.enabled || q.send([I]) : q.send(I);
  };
  let d;
  return !((i = n.batching) === null || i === void 0) && i.enabled && (d = new gu(m, {
    sendTimeout: n.batching.sendTimeout,
    itemLimit: n.batching.itemLimit,
    paused: o
  })), {
    add: c,
    addBeforeSendHooks: u,
    getBeforeSendHooks: () => [...a],
    execute: (w) => {
      var E;
      o || (!((E = n.batching) === null || E === void 0) && E.enabled && (d == null || d.addItem(w)), l(w));
    },
    isPaused: () => o,
    pause: () => {
      t.debug("Pausing transports"), d == null || d.pause(), o = !0;
    },
    remove: (...w) => {
      t.debug("Removing transports"), w.forEach((E) => {
        t.debug(`Removing "${E.name}" transport`);
        const T = s.indexOf(E);
        if (T === -1) {
          t.warn(`Transport "${E.name}" is not added`);
          return;
        }
        s.splice(T, 1);
      });
    },
    removeBeforeSendHooks: (...w) => {
      a.filter((E) => !w.includes(E));
    },
    get transports() {
      return [...s];
    },
    unpause: () => {
      t.debug("Unpausing transports"), d == null || d.start(), o = !1;
    }
  };
}
function vu(e, t) {
  if (t.preserveOriginalError)
    for (const n of e)
      n.type === H.EXCEPTION && delete n.payload.originalError;
  return e;
}
function Eu(e) {
  return Math.min(1, Math.max(0, e));
}
function Pe(e, t) {
  return typeof e === t;
}
function Bn(e, t) {
  return Object.prototype.toString.call(e) === `[object ${t}]`;
}
function Uo(e, t) {
  try {
    return e instanceof t;
  } catch (n) {
    return !1;
  }
}
const Ht = (e) => Pe(e, "null"), Gt = (e) => Pe(e, "string"), Su = (e) => Pe(e, "number") && !isNaN(e) || Pe(e, "bigint"), Tu = (e) => Pe(e, "boolean"), me = (e) => !Ht(e) && Pe(e, "object"), zt = (e) => Pe(e, "function"), at = (e) => Bn(e, "Array"), yu = (e) => !me(e) && !zt(e), wu = typeof Event != "undefined", Au = (e) => wu && Uo(e, Event), Ou = typeof Error != "undefined", Si = (e) => Ou && Uo(e, Error), Ru = (e) => Bn(e, "ErrorEvent"), Pu = (e) => Bn(e, "DOMError"), Iu = (e) => Bn(e, "DOMException");
function je(e) {
  return e == null ? !0 : at(e) || Gt(e) ? e.length === 0 : me(e) ? Object.keys(e).length === 0 : !1;
}
function $e(e, t) {
  if (e === t)
    return !0;
  if (Pe(e, "number") && isNaN(e))
    return Pe(t, "number") && isNaN(t);
  const n = at(e), r = at(t);
  if (n !== r)
    return !1;
  if (n && r) {
    const o = e.length;
    if (o !== t.length)
      return !1;
    for (let a = o; a-- !== 0; )
      if (!$e(e[a], t[a]))
        return !1;
    return !0;
  }
  const i = me(e), s = me(t);
  if (i !== s)
    return !1;
  if (e && t && i && s) {
    const o = Object.keys(e), a = Object.keys(t), c = o.length, u = a.length;
    if (c !== u)
      return !1;
    for (let f of o)
      if (!a.includes(f))
        return !1;
    for (let f of o)
      if (!$e(e[f], t[f]))
        return !1;
    return !0;
  }
  return !1;
}
function ct() {
  return Date.now();
}
function Fn() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function Vn(e) {
  return new Date(e).toISOString();
}
var W;
(function(e) {
  e.TRACE = "trace", e.DEBUG = "debug", e.INFO = "info", e.LOG = "log", e.WARN = "warn", e.ERROR = "error";
})(W || (W = {}));
const Cu = W.LOG, Nu = [
  W.TRACE,
  W.DEBUG,
  W.INFO,
  W.LOG,
  W.WARN,
  W.ERROR
];
function Ae() {
}
function xu(e) {
  const { size: t, concurrency: n } = e, r = [];
  let i = 0;
  const s = () => {
    if (i < n && r.length) {
      const { producer: a, resolve: c, reject: u } = r.shift();
      i++, a().then((f) => {
        i--, s(), c(f);
      }, (f) => {
        i--, s(), u(f);
      });
    }
  };
  return {
    add: (a) => {
      if (r.length + i >= t)
        throw new Error("Task buffer full");
      return new Promise((c, u) => {
        r.push({
          producer: a,
          resolve: c,
          reject: u
        }), s();
      });
    }
  };
}
const fs = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789";
function Ke(e = 10) {
  return Array.from(Array(e)).map(() => fs[Math.floor(Math.random() * fs.length)]).join("");
}
const Ge = typeof globalThis != "undefined" ? globalThis : typeof global != "undefined" ? global : typeof self != "undefined" ? self : void 0;
function Lu(e) {
  return Ge == null ? void 0 : Ge[`__faroBundleId_${e}`];
}
function Mu() {
  const e = /* @__PURE__ */ new WeakSet();
  return function(t, n) {
    if (me(n) && n !== null) {
      if (e.has(n))
        return null;
      e.add(n);
    }
    return n;
  };
}
function qt(e = {}) {
  return JSON.stringify(e != null ? e : {}, Mu());
}
function gt(e = {}) {
  const t = {};
  for (const [n, r] of Object.entries(e))
    t[n] = me(r) && r !== null ? qt(r) : String(r);
  return t;
}
class z {
  constructor() {
    this.subscribers = [];
  }
  subscribe(t) {
    return this.subscribers.push(t), {
      unsubscribe: () => this.unsubscribe(t)
    };
  }
  unsubscribe(t) {
    this.subscribers = this.subscribers.filter((n) => n !== t);
  }
  notify(t) {
    this.subscribers.forEach((n) => n(t));
  }
  first() {
    const t = new z(), n = (s) => {
      t.notify(s), r.unsubscribe();
    }, r = this.subscribe(n), i = t.unsubscribe.bind(t);
    return this.withUnsubscribeOverride(t, i, n);
  }
  takeWhile(t) {
    const n = new z(), r = (s) => {
      t(s) ? n.notify(s) : n.unsubscribe(r);
    };
    this.subscribe(r);
    const i = n.unsubscribe.bind(n);
    return this.withUnsubscribeOverride(n, i, r);
  }
  filter(t) {
    const n = new z(), r = (s) => {
      t(s) && n.notify(s);
    };
    this.subscribe(r);
    const i = n.unsubscribe.bind(n);
    return this.withUnsubscribeOverride(n, i, r);
  }
  merge(...t) {
    const n = new z(), r = [];
    t.forEach((s) => {
      const o = s.subscribe((a) => {
        n.notify(a);
      });
      r.push(o);
    });
    const i = n.unsubscribeAll.bind(n);
    return n.unsubscribe = () => {
      r.forEach((s) => s.unsubscribe()), i();
    }, n;
  }
  withUnsubscribeOverride(t, n, r) {
    return t.unsubscribe = (i) => {
      n(i), this.unsubscribe(r);
    }, t;
  }
  unsubscribeAll() {
    this.subscribers = [];
  }
}
var De;
(function(e) {
  e[e.OFF = 0] = "OFF", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.VERBOSE = 4] = "VERBOSE";
})(De || (De = {}));
const ku = "Faro", Ti = {
  debug: Ae,
  error: Ae,
  info: Ae,
  prefix: ku,
  warn: Ae
}, $o = De.ERROR, Kt = Object.assign({}, console);
let _r = Kt;
function Du(e) {
  var t;
  return _r = (t = e.unpatchedConsole) !== null && t !== void 0 ? t : _r, _r;
}
function jo(e = Kt, t = $o) {
  const n = Ti;
  return t > De.OFF && (n.error = t >= De.ERROR ? function(...r) {
    e.error(`${n.prefix}
`, ...r);
  } : Ae, n.warn = t >= De.WARN ? function(...r) {
    e.warn(`${n.prefix}
`, ...r);
  } : Ae, n.info = t >= De.INFO ? function(...r) {
    e.info(`${n.prefix}
`, ...r);
  } : Ae, n.debug = t >= De.VERBOSE ? function(...r) {
    e.debug(`${n.prefix}
`, ...r);
  } : Ae), n;
}
let ps = Ti;
function Uu(e, t) {
  return ps = jo(e, t.internalLoggerLevel), ps;
}
class Bo {
  constructor() {
    this.unpatchedConsole = Kt, this.internalLogger = Ti, this.config = {}, this.metas = {};
  }
  logDebug(...t) {
    this.internalLogger.debug(`${this.name}
`, ...t);
  }
  logInfo(...t) {
    this.internalLogger.info(`${this.name}
`, ...t);
  }
  logWarn(...t) {
    this.internalLogger.warn(`${this.name}
`, ...t);
  }
  logError(...t) {
    this.internalLogger.error(`${this.name}
`, ...t);
  }
}
class $u extends Bo {
  isBatched() {
    return !1;
  }
  getIgnoreUrls() {
    return [];
  }
}
function ju(e) {
  e.transports.add(...e.config.transports), e.transports.addBeforeSendHooks(e.config.beforeSend);
}
function Bu(e, t) {
  var n, r;
  if (t === void 0)
    return e;
  if (e === void 0)
    return {
      resourceSpans: t
    };
  const i = (n = e.resourceSpans) === null || n === void 0 ? void 0 : n[0];
  if (i === void 0)
    return e;
  const s = (i == null ? void 0 : i.scopeSpans) || [], o = ((r = t == null ? void 0 : t[0]) === null || r === void 0 ? void 0 : r.scopeSpans) || [];
  return Object.assign(Object.assign({}, e), { resourceSpans: [
    Object.assign(Object.assign({}, i), { scopeSpans: [...s, ...o] })
  ] });
}
function Fu(e) {
  let t = {
    meta: {}
  };
  return e[0] !== void 0 && (t.meta = e[0].meta), e.forEach((n) => {
    switch (n.type) {
      case H.LOG:
      case H.EVENT:
      case H.EXCEPTION:
      case H.MEASUREMENT: {
        const r = _u[n.type], i = t[r];
        t = Object.assign(Object.assign({}, t), { [r]: i === void 0 ? [n.payload] : [...i, n.payload] });
        break;
      }
      case H.TRACE: {
        t = Object.assign(Object.assign({}, t), { traces: Bu(t.traces, n.payload.resourceSpans) });
        break;
      }
    }
  }), t;
}
const Vu = "faroApiCall", Hu = "user_action_start", Fo = {
  Normal: "normal",
  Critical: "critical"
}, Gu = "faro.user.action";
var k;
(function(e) {
  e[e.Started = 0] = "Started", e[e.Halted = 1] = "Halted", e[e.Cancelled = 2] = "Cancelled", e[e.Ended = 3] = "Ended";
})(k || (k = {}));
class zu {
  constructor() {
    this.buffer = [];
  }
  addItem(t) {
    this.buffer.push(t);
  }
  flushBuffer(t) {
    if (zt(t))
      for (const n of this.buffer)
        t(n);
    this.buffer.length = 0;
  }
  size() {
    return this.buffer.length;
  }
}
class qu extends z {
  constructor({ name: t, parentId: n, trigger: r, transports: i, attributes: s, trackUserActionsExcludeItem: o, importance: a = Fo.Normal, pushEvent: c }) {
    super(), this.name = t, this.attributes = s, this.id = Ke(), this.trigger = r, this.parentId = n != null ? n : this.id, this.trackUserActionsExcludeItem = o, this.importance = a, this._pushEvent = c, this._itemBuffer = new zu(), this._transports = i, this._state = k.Started, this._start();
  }
  addItem(t) {
    return this._state === k.Started ? (this._itemBuffer.addItem(t), !0) : !1;
  }
  _start() {
    this._state = k.Started, this._state === k.Started && (this.startTime = ct());
  }
  halt() {
    this._state === k.Started && (this._state = k.Halted, this.notify(this._state));
  }
  cancel() {
    this._state === k.Started && this._itemBuffer.flushBuffer((t) => {
      this._transports.execute(t);
    }), this._state = k.Cancelled, this.notify(this._state);
  }
  end() {
    if (this._state === k.Cancelled)
      return;
    const t = ct(), n = t - this.startTime;
    this._state = k.Ended, this._itemBuffer.flushBuffer((r) => {
      if (Ku(r, this.trackUserActionsExcludeItem)) {
        this._transports.execute(r);
        return;
      }
      const i = Object.assign(Object.assign({}, r), { payload: Object.assign(Object.assign({}, r.payload), { action: {
        parentId: this.id,
        name: this.name
      } }) });
      this._transports.execute(i);
    }), this._state = k.Ended, this.notify(this._state), this._pushEvent(Gu, Object.assign({ userActionName: this.name, userActionStartTime: this.startTime.toString(), userActionEndTime: t.toString(), userActionDuration: n.toString(), userActionTrigger: this.trigger, userActionImportance: this.importance }, gt(this.attributes)), void 0, {
      timestampOverwriteMs: this.startTime,
      customPayloadTransformer: (r) => (r.action = {
        id: this.id,
        name: this.name
      }, r)
    });
  }
  getState() {
    return this._state;
  }
}
function Ku(e, t) {
  return (t == null ? void 0 : t(e)) || e.type === H.MEASUREMENT && e.payload.type === "web-vitals";
}
const Vo = new z();
function Wu({ transports: e, internalLogger: t, config: n, pushEvent: r }) {
  var i;
  const s = (i = n.userActionsInstrumentation) === null || i === void 0 ? void 0 : i.excludeItem;
  let o;
  const a = (f, m, l) => {
    if (c() === void 0) {
      const p = new qu({
        name: f,
        transports: e,
        attributes: m,
        trigger: (l == null ? void 0 : l.triggerName) || Vu,
        importance: (l == null ? void 0 : l.importance) || Fo.Normal,
        trackUserActionsExcludeItem: s,
        pushEvent: r
      });
      return p.filter((h) => [k.Ended, k.Cancelled].includes(h)).first().subscribe(() => {
        o = void 0;
      }), Vo.notify({
        type: Hu,
        userAction: p
      }), o = p, o;
    } else {
      t.error("Attempted to create a new user action while one is already running. This is not possible.");
      return;
    }
  }, c = () => o;
  return {
    startUserAction: a,
    getActiveUserAction: c
  };
}
function Hn(e, t) {
  return !e || (e == null ? void 0 : e.getState()) !== k.Started ? !1 : (e.addItem(t), !0);
}
function Xu({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  let o = null;
  return {
    pushEvent: (c, u, f, { skipDedupe: m, spanContext: l, timestampOverwriteMs: d, customPayloadTransformer: p = (h) => h } = {}) => {
      try {
        const h = gt(u), g = {
          meta: n.value,
          payload: p({
            name: c,
            domain: f != null ? f : t.eventDomain,
            attributes: je(h) ? void 0 : h,
            timestamp: d ? Vn(d) : Fn(),
            trace: l ? {
              trace_id: l.traceId,
              span_id: l.spanId
            } : i.getTraceContext()
          }),
          type: H.EVENT
        }, S = {
          name: g.payload.name,
          attributes: g.payload.attributes,
          domain: g.payload.domain
        };
        if (!m && t.dedupe && !Ht(o) && $e(S, o)) {
          e.debug(`Skipping event push because it is the same as the last one
`, g.payload);
          return;
        }
        o = S, e.debug(`Pushing event
`, g), Hn(s.getActiveUserAction(), g) || r.execute(g);
      } catch (h) {
        e.error("Error pushing event", h);
      }
    }
  };
}
const Ho = "Error", hs = (e) => e.map((t) => me(t) ? qt(t) : String(t)).join(" ");
function Yu(e, t) {
  return e.some((n) => Gt(n) ? t.includes(n) : !!t.match(n));
}
let ke;
function Qu({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  var o;
  e.debug("Initializing exceptions API");
  let a = null;
  ke = (o = t.parseStacktrace) !== null && o !== void 0 ? o : ke;
  const c = (d) => {
    e.debug("Changing stacktrace parser"), ke = d != null ? d : ke;
  }, u = () => ke, { ignoreErrors: f = [], preserveOriginalError: m } = t, l = (d, { skipDedupe: p, stackFrames: h, type: g, context: S, spanContext: y, timestampOverwriteMs: v, originalError: b, fingerprint: w } = {}) => {
    if (!Zu(f, b != null ? b : d))
      try {
        const E = gt(Object.assign(Object.assign({}, Ju(b != null ? b : d)), S != null ? S : {})), T = {
          meta: n.value,
          payload: Object.assign(Object.assign(Object.assign({ type: g || d.name || Ho, value: d.message, timestamp: v ? Vn(v) : Fn(), trace: y ? {
            trace_id: y.traceId,
            span_id: y.spanId
          } : i.getTraceContext() }, je(E) ? {} : { context: E }), m ? { originalError: b } : {}), w ? { fingerprint: w } : {}),
          type: H.EXCEPTION
        };
        h = h != null ? h : d.stack ? ke == null ? void 0 : ke(d).frames : void 0, h != null && h.length && (T.payload.stacktrace = {
          frames: h
        });
        const I = {
          type: T.payload.type,
          value: T.payload.value,
          stackTrace: T.payload.stacktrace,
          context: T.payload.context,
          fingerprint: T.payload.fingerprint
        };
        if (!p && t.dedupe && !Ht(a) && $e(I, a)) {
          e.debug(`Skipping error push because it is the same as the last one
`, T.payload);
          return;
        }
        a = I, e.debug(`Pushing exception
`, T), Hn(s.getActiveUserAction(), T) || r.execute(T);
      } catch (E) {
        e.error("Error pushing event", E);
      }
  };
  return c(t.parseStacktrace), {
    changeStacktraceParser: c,
    getStacktraceParser: u,
    pushError: l
  };
}
function Ju(e) {
  let t = e.cause;
  return Si(t) ? t = e.cause.toString() : t !== null && (me(e.cause) || at(e.cause)) ? t = qt(e.cause) : t != null && (t = e.cause.toString()), t == null ? {} : { cause: t };
}
function Zu(e, t) {
  const { message: n, name: r, stack: i } = t;
  return Yu(e, n + " " + r + " " + i);
}
const Tn = (e) => e.map((t) => {
  try {
    return String(t);
  } catch (n) {
    return "";
  }
}).join(" ");
function el({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  var o;
  e.debug("Initializing logs API");
  let a = null;
  const c = (o = t.logArgsSerializer) !== null && o !== void 0 ? o : Tn;
  return {
    pushLog: (f, { context: m, level: l, skipDedupe: d, spanContext: p, timestampOverwriteMs: h } = {}) => {
      try {
        const g = gt(m), S = {
          type: H.LOG,
          payload: {
            message: c(f),
            level: l != null ? l : Cu,
            context: je(g) ? void 0 : g,
            timestamp: h ? Vn(h) : Fn(),
            trace: p ? {
              trace_id: p.traceId,
              span_id: p.spanId
            } : i.getTraceContext()
          },
          meta: n.value
        }, y = {
          message: S.payload.message,
          level: S.payload.level,
          context: S.payload.context
        };
        if (!d && t.dedupe && !Ht(a) && $e(y, a)) {
          e.debug(`Skipping log push because it is the same as the last one
`, S.payload);
          return;
        }
        a = y, e.debug(`Pushing log
`, S), Hn(s.getActiveUserAction(), S) || r.execute(S);
      } catch (g) {
        e.error(`Error pushing log
`, g);
      }
    }
  };
}
function tl({ internalLogger: e, config: t, metas: n, transports: r, tracesApi: i, userActionsApi: s }) {
  e.debug("Initializing measurements API");
  let o = null;
  return {
    pushMeasurement: (c, { skipDedupe: u, context: f, spanContext: m, timestampOverwriteMs: l } = {}) => {
      try {
        const d = gt(f), p = {
          type: H.MEASUREMENT,
          payload: Object.assign(Object.assign({}, c), { trace: m ? {
            trace_id: m.traceId,
            span_id: m.spanId
          } : i.getTraceContext(), timestamp: l ? Vn(l) : Fn(), context: je(d) ? void 0 : d }),
          meta: n.value
        }, h = {
          type: p.payload.type,
          values: p.payload.values,
          context: p.payload.context
        };
        if (!u && t.dedupe && !Ht(o) && $e(h, o)) {
          e.debug(`Skipping measurement push because it is the same as the last one
`, p.payload);
          return;
        }
        o = h, e.debug(`Pushing measurement
`, p), Hn(s.getActiveUserAction(), p) || r.execute(p);
      } catch (d) {
        e.error(`Error pushing measurement
`, d);
      }
    }
  };
}
function nl({ internalLogger: e, metas: t }) {
  e.debug("Initializing meta API");
  let n, r, i, s;
  const o = (d) => {
    r && t.remove(r), r = {
      user: d
    }, t.add(r);
  }, a = (d, p) => {
    var h;
    const g = p == null ? void 0 : p.overrides, S = g ? {
      overrides: Object.assign(Object.assign({}, (h = n == null ? void 0 : n.session) === null || h === void 0 ? void 0 : h.overrides), g)
    } : {};
    n && t.remove(n), n = {
      session: Object.assign(Object.assign({}, je(d) ? void 0 : d), S)
    }, t.add(n);
  }, c = () => t.value.session, u = (d, p) => {
    var h;
    if (p != null && p.overrides && a(c(), { overrides: p.overrides }), ((h = i == null ? void 0 : i.view) === null || h === void 0 ? void 0 : h.name) === (d == null ? void 0 : d.name))
      return;
    const g = i;
    i = {
      view: d
    }, t.add(i), g && t.remove(g);
  }, f = () => t.value.view, m = (d) => {
    var p;
    const h = Gt(d) ? Object.assign(Object.assign({}, (p = s == null ? void 0 : s.page) !== null && p !== void 0 ? p : l()), { id: d }) : d;
    s && t.remove(s), s = {
      page: h
    }, t.add(s);
  }, l = () => t.value.page;
  return {
    setUser: o,
    resetUser: o,
    setSession: a,
    resetSession: a,
    getSession: c,
    setView: u,
    getView: f,
    setPage: m,
    getPage: l
  };
}
function rl(e, t, n, r, i) {
  t.debug("Initializing traces API");
  let s;
  return {
    getOTEL: () => s,
    getTraceContext: () => {
      const m = s == null ? void 0 : s.trace.getSpanContext(s.context.active());
      return m ? {
        trace_id: m.traceId,
        span_id: m.spanId
      } : void 0;
    },
    initOTEL: (m, l) => {
      t.debug("Initializing OpenTelemetry"), s = {
        trace: m,
        context: l
      };
    },
    isOTELInitialized: () => !!s,
    pushTraces: (m) => {
      try {
        const l = {
          type: H.TRACE,
          payload: m,
          meta: r.value
        };
        t.debug(`Pushing trace
`, l), i.execute(l);
      } catch (l) {
        t.error(`Error pushing trace
`, l);
      }
    }
  };
}
function il(e, t, n, r, i) {
  t.debug("Initializing API");
  let s = null;
  const a = Wu({
    transports: i,
    config: n,
    internalLogger: t,
    pushEvent: (m, l, d, p) => {
      s ? s(m, l, d, p) : t.warn("pushEventImpl is not initialized. Event dropped:", { name: m, attributes: l, domain: d, options: p });
    }
  }), c = rl(e, t, n, r, i), u = {
    unpatchedConsole: e,
    internalLogger: t,
    userActionsApi: a,
    config: n,
    metas: r,
    transports: i,
    tracesApi: c
  }, f = Xu(u);
  return s = f.pushEvent, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, c), Qu(u)), nl(u)), el(u)), tl(u)), f), a);
}
class ve extends Bo {
  constructor() {
    super(...arguments), this.api = {}, this.transports = {};
  }
}
function sl(e, t, n, r, i, s) {
  t.debug("Initializing instrumentations");
  const o = [];
  return {
    add: (...u) => {
      t.debug("Adding instrumentations"), u.forEach((f) => {
        if (t.debug(`Adding "${f.name}" instrumentation`), o.some((l) => l.name === f.name)) {
          t.warn(`Instrumentation ${f.name} is already added`);
          return;
        }
        f.unpatchedConsole = e, f.internalLogger = t, f.config = n, f.metas = r, f.transports = i, f.api = s, o.push(f), f.initialize();
      });
    },
    get instrumentations() {
      return [...o];
    },
    remove: (...u) => {
      t.debug("Removing instrumentations"), u.forEach((f) => {
        var m, l;
        t.debug(`Removing "${f.name}" instrumentation`);
        const d = o.reduce((p, h, g) => p === null && h.name === f.name ? g : null, null);
        if (d === null) {
          t.warn(`Instrumentation "${f.name}" is not added`);
          return;
        }
        (l = (m = o[d]).destroy) === null || l === void 0 || l.call(m), o.splice(d, 1);
      });
    }
  };
}
function ol(e) {
  e.instrumentations.add(...e.config.instrumentations);
}
function al(e, t, n) {
  let r = [], i = [];
  const s = () => r.reduce((m, l) => Object.assign(m, zt(l) ? l() : l), {}), o = () => {
    if (i.length) {
      const m = s();
      i.forEach((l) => l(m));
    }
  };
  return {
    add: (...m) => {
      t.debug(`Adding metas
`, m), r.push(...m), o();
    },
    remove: (...m) => {
      t.debug(`Removing metas
`, m), r = r.filter((l) => !m.includes(l)), o();
    },
    addListener: (m) => {
      t.debug(`Adding metas listener
`, m), i.push(m);
    },
    removeListener: (m) => {
      t.debug(`Removing metas listener
`, m), i = i.filter((l) => l !== m);
    },
    get value() {
      return s();
    }
  };
}
const X = "2.3.1";
function cl(e) {
  var t, n;
  const r = {
    sdk: {
      version: X,
      name: "faro"
    },
    app: {
      bundleId: e.config.app.name && Lu(e.config.app.name)
    }
  }, i = (t = e.config.sessionTracking) === null || t === void 0 ? void 0 : t.session;
  i && e.api.setSession(i), e.config.app && (r.app = Object.assign(Object.assign({}, e.config.app), r.app)), e.config.user && (r.user = e.config.user), e.config.view && (r.view = e.config.view), e.metas.add(r, ...(n = e.config.metas) !== null && n !== void 0 ? n : []);
}
const Go = "_faroInternal";
function ul(e) {
  if (e.config.preventGlobalExposure)
    e.internalLogger.debug("Skipping registering public Faro instance in the global scope");
  else {
    if (e.internalLogger.debug(`Registering public faro reference in the global scope using "${e.config.globalObjectKey}" key`), e.config.globalObjectKey in Ge) {
      e.internalLogger.warn(`Skipping global registration due to key "${e.config.globalObjectKey}" being used already. Please set "globalObjectKey" to something else or set "preventGlobalExposure" to "true"`);
      return;
    }
    Object.defineProperty(Ge, e.config.globalObjectKey, {
      configurable: !1,
      writable: !1,
      value: e
    });
  }
}
function ll(e) {
  e.config.isolate ? e.internalLogger.debug("Skipping registering internal Faro instance on global object") : (e.internalLogger.debug("Registering internal Faro instance on global object"), Object.defineProperty(Ge, Go, {
    configurable: !1,
    enumerable: !1,
    writable: !1,
    value: e
  }));
}
function dl() {
  return Go in Ge;
}
let U = {};
function fl(e, t, n, r, i, s, o) {
  return t.debug("Initializing Faro"), U = {
    api: s,
    config: n,
    instrumentations: o,
    internalLogger: t,
    metas: r,
    pause: i.pause,
    transports: i,
    unpatchedConsole: e,
    unpause: i.unpause
  }, ll(U), ul(U), U;
}
function pl(e) {
  const t = Du(e), n = Uu(t, e);
  if (dl() && !e.isolate) {
    n.error('Faro is already registered. Either add instrumentations, transports etc. to the global faro instance or use the "isolate" property');
    return;
  }
  n.debug("Initializing");
  const r = al(t, n), i = bu(t, n, e, r), s = il(t, n, e, r, i), o = sl(t, n, e, r, i, s), a = fl(t, n, e, r, i, s, o);
  return cl(a), ju(a), ol(a), a;
}
const hl = "faro", ml = {
  enabled: !0,
  sendTimeout: 250,
  itemLimit: 50
}, gl = "view_changed", rn = "session_start", br = "session_resume", _l = "session_extend", bl = "service_name_override", Y = "unknown";
var Yr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    var i = "1.0.41", s = "", o = "?", a = "function", c = "undefined", u = "object", f = "string", m = "major", l = "model", d = "name", p = "type", h = "vendor", g = "version", S = "architecture", y = "console", v = "mobile", b = "tablet", w = "smarttv", E = "wearable", T = "embedded", I = 500, q = "Amazon", se = "Apple", Ne = "ASUS", Ee = "BlackBerry", te = "Browser", ue = "Chrome", Et = "Edge", xe = "Firefox", Le = "Google", St = "Honor", Tt = "Huawei", We = "Lenovo", K = "LG", Xe = "Microsoft", Me = "Motorola", Ye = "Nvidia", Ji = "OnePlus", yt = "Opera", ur = "OPPO", wt = "Samsung", Zi = "Sharp", At = "Sony", lr = "Xiaomi", dr = "Zebra", es = "Facebook", ts = "Chromium OS", ns = "Mac OS", rs = " Browser", qc = function(P, N) {
      var O = {};
      for (var D in P)
        N[D] && N[D].length % 2 === 0 ? O[D] = N[D].concat(P[D]) : O[D] = P[D];
      return O;
    }, Zt = function(P) {
      for (var N = {}, O = 0; O < P.length; O++)
        N[P[O].toUpperCase()] = P[O];
      return N;
    }, is = function(P, N) {
      return typeof P === f ? Ot(N).indexOf(Ot(P)) !== -1 : !1;
    }, Ot = function(P) {
      return P.toLowerCase();
    }, Kc = function(P) {
      return typeof P === f ? P.replace(/[^\d\.]/g, s).split(".")[0] : r;
    }, fr = function(P, N) {
      if (typeof P === f)
        return P = P.replace(/^\s\s*/, s), typeof N === c ? P : P.substring(0, I);
    }, Rt = function(P, N) {
      for (var O = 0, D, Se, le, x, A, de; O < N.length && !A; ) {
        var pr = N[O], as = N[O + 1];
        for (D = Se = 0; D < pr.length && !A && pr[D]; )
          if (A = pr[D++].exec(P), A)
            for (le = 0; le < as.length; le++)
              de = A[++Se], x = as[le], typeof x === u && x.length > 0 ? x.length === 2 ? typeof x[1] == a ? this[x[0]] = x[1].call(this, de) : this[x[0]] = x[1] : x.length === 3 ? typeof x[1] === a && !(x[1].exec && x[1].test) ? this[x[0]] = de ? x[1].call(this, de, x[2]) : r : this[x[0]] = de ? de.replace(x[1], x[2]) : r : x.length === 4 && (this[x[0]] = de ? x[3].call(this, de.replace(x[1], x[2])) : r) : this[x] = de || r;
        O += 2;
      }
    }, Pt = function(P, N) {
      for (var O in N)
        if (typeof N[O] === u && N[O].length > 0) {
          for (var D = 0; D < N[O].length; D++)
            if (is(N[O][D], P))
              return O === o ? r : O;
        } else if (is(N[O], P))
          return O === o ? r : O;
      return N.hasOwnProperty("*") ? N["*"] : P;
    }, Wc = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, ss = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, os = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [d, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [d, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [d, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [d, yt + " Mini"]],
        [
          /\bop(?:rg)?x\/([\w\.]+)/i
          // Opera GX
        ],
        [g, [d, yt + " GX"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [d, yt]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [g, [d, "Baidu"]],
        [
          /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
          // Maxthon
        ],
        [g, [d, "Maxthon"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
          // Trident based
          /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
          // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
          /(heytap|ovi|115)browser\/([\d\.]+)/i,
          // HeyTap/Ovi/115
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [d, g],
        [
          /quark(?:pc)?\/([-\w\.]+)/i
          // Quark
        ],
        [g, [d, "Quark"]],
        [
          /\bddg\/([\w\.]+)/i
          // DuckDuckGo
        ],
        [g, [d, "DuckDuckGo"]],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [d, "UC" + te]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [d, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [d, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [d, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [d, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [g, [d, "Smart Lenovo " + te]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[d, /(.+)/, "$1 Secure " + te], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [d, xe + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [d, yt + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [d, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [d, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [d, yt + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [d, "MIUI" + rs]],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [g, [d, xe]],
        [
          /\bqihoobrowser\/?([\w\.]*)/i
          // 360
        ],
        [g, [d, "360"]],
        [
          /\b(qq)\/([\w\.]+)/i
          // QQ
        ],
        [[d, /(.+)/, "$1Browser"], g],
        [
          /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
        ],
        [[d, /(.+)/, "$1" + rs], g],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [g, [d, wt + " Internet"]],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [g, [d, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[d, "Sogou Mobile"], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
          // QQ/2345
        ],
        [d, g],
        [
          /(lbbrowser|rekonq)/i,
          // LieBao Browser/Rekonq
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [d],
        [
          /ome\/([\w\.]+) \w* ?(iron) saf/i,
          // Iron
          /ome\/([\w\.]+).+qihu (360)[es]e/i
          // 360
        ],
        [g, d],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[d, es], g],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /(daum)apps[\/ ]([\w\.]+)/i,
          // Daum App
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          // Twitter
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [d, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [d, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [g, [d, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [d, ue + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[d, ue + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [d, "Android " + te]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [d, g],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [d, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, d],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [d, [g, Pt, Wc]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [d, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[d, "Netscape"], g],
        [
          /(wolvic|librewolf)\/([\w\.]+)/i
          // Wolvic/LibreWolf
        ],
        [d, g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [d, xe + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
          /\b(links) \(([\w\.]+)/i
          // Links
        ],
        [d, [g, /_/g, "."]],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [d, [g, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /\b((amd|x|x86[-_]?|wow|win)64)\b/i
          // AMD64 (x64)
        ],
        [[S, "amd64"]],
        [
          /(ia32(?=;))/i,
          // IA32 (quicktime)
          /\b((i[346]|x)86)(pc)?\b/i
          // IA32 (x86)
        ],
        [[S, "ia32"]],
        [
          /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
          // ARM64
        ],
        [[S, "arm64"]],
        [
          /\b(arm(v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[S, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
        ],
        [[S, "arm"]],
        [
          /((ppc|powerpc)(64)?)( mac|;|\))/i
          // PowerPC
        ],
        [[S, /ower/, s, Ot]],
        [
          / sun4\w[;\)]/i
          // SPARC
        ],
        [[S, "sparc"]],
        [
          /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[S, Ot]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [l, [h, wt], [p, b]],
        [
          /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]((?!sm-[lr])[-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [l, [h, wt], [p, v]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [l, [h, se], [p, v]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [l, [h, se], [p, b]],
        [
          /(macintosh);/i
        ],
        [l, [h, se]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [l, [h, Zi], [p, v]],
        [
          // Honor
          /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
        ],
        [l, [h, St], [p, b]],
        [
          /honor([-\w ]+)[;\)]/i
        ],
        [l, [h, St], [p, v]],
        [
          // Huawei
          /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
        ],
        [l, [h, Tt], [p, b]],
        [
          /(?:huawei)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [l, [h, Tt], [p, v]],
        [
          // Xiaomi
          /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
          /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[l, /_/g, " "], [h, lr], [p, b]],
        [
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
          // Xiaomi Mi
          / ([\w ]+) miui\/v?\d/i
        ],
        [[l, /_/g, " "], [h, lr], [p, v]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [l, [h, ur], [p, v]],
        [
          /\b(opd2(\d{3}a?))(?: bui|\))/i
        ],
        [l, [h, Pt, { OnePlus: ["304", "403", "203"], "*": ur }], [p, b]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [l, [h, "Vivo"], [p, v]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [l, [h, "Realme"], [p, v]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [l, [h, Me], [p, v]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [l, [h, Me], [p, b]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [l, [h, K], [p, b]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [l, [h, K], [p, v]],
        [
          // Lenovo
          /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
          /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
        ],
        [l, [h, We], [p, b]],
        [
          // Nokia
          /(nokia) (t[12][01])/i
        ],
        [h, l, [p, b]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
          /nokia[-_ ]?(([-\w\. ]*))/i
        ],
        [[l, /_/g, " "], [p, v], [h, "Nokia"]],
        [
          // Google
          /(pixel (c|tablet))\b/i
          // Google Pixel C/Tablet
        ],
        [l, [h, Le], [p, b]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [l, [h, Le], [p, v]],
        [
          // Sony
          /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [l, [h, At], [p, v]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[l, "Xperia Tablet"], [h, At], [p, b]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [l, [h, Ji], [p, v]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [l, [h, q], [p, b]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[l, /(.+)/g, "Fire Phone $1"], [h, q], [p, v]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [l, h, [p, b]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [l, [h, Ee], [p, v]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [l, [h, Ne], [p, b]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [l, [h, Ne], [p, v]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [l, [h, "HTC"], [p, b]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [h, [l, /_/g, " "], [p, v]],
        [
          // TCL
          /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
        ],
        [l, [h, "TCL"], [p, b]],
        [
          // itel
          /(itel) ((\w+))/i
        ],
        [[h, Ot], l, [p, Pt, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [l, [h, "Acer"], [p, b]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [l, [h, "Meizu"], [p, v]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [l, [h, "Ulefone"], [p, v]],
        [
          // Energizer
          /; (energy ?\w+)(?: bui|\))/i,
          /; energizer ([\w ]+)(?: bui|\))/i
        ],
        [l, [h, "Energizer"], [p, v]],
        [
          // Cat
          /; cat (b35);/i,
          /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
        ],
        [l, [h, "Cat"], [p, v]],
        [
          // Smartfren
          /((?:new )?andromax[\w- ]+)(?: bui|\))/i
        ],
        [l, [h, "Smartfren"], [p, v]],
        [
          // Nothing
          /droid.+; (a(?:015|06[35]|142p?))/i
        ],
        [l, [h, "Nothing"], [p, v]],
        [
          // Archos
          /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
          /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
        ],
        [l, [h, "Archos"], [p, b]],
        [
          /archos ([\w ]+)( b|\))/i,
          /; (ac[3-6]\d\w{2,8})( b|\))/i
        ],
        [l, [h, "Archos"], [p, v]],
        [
          // MIXED
          /(imo) (tab \w+)/i,
          // IMO
          /(infinix) (x1101b?)/i
          // Infinix XPad
        ],
        [h, l, [p, b]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
          /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
          // HMD/IMO
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
          // Lenovo
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [h, l, [p, v]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [h, l, [p, b]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [l, [h, Xe], [p, b]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [l, [h, "Fairphone"], [p, v]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [l, [h, "AT&T"], [p, v]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [l, [h, "Siemens"], [p, v]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [l, [h, "RCA"], [p, b]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [l, [h, "Dell"], [p, b]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [l, [h, "Verizon"], [p, b]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [l, [h, "Barnes & Noble"], [p, b]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [l, [h, "NuVision"], [p, b]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [l, [h, "ZTE"], [p, b]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [l, [h, "ZTE"], [p, v]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [l, [h, "Swiss"], [p, v]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [l, [h, "Swiss"], [p, b]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [l, [h, "Zeki"], [p, b]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[h, "Dragon Touch"], l, [p, b]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [l, [h, "Insignia"], [p, b]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [l, [h, "NextBook"], [p, b]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[h, "Voice"], l, [p, v]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[h, "LvTel"], l, [p, v]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [l, [h, "Essential"], [p, v]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [l, [h, "Envizen"], [p, b]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [l, [h, "MachSpeed"], [p, b]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [l, [h, "Rotor"], [p, b]],
        [
          /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
          // Nvidia Tablets
        ],
        [l, [h, Ye], [p, b]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [h, l, [p, v]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[l, /\./g, " "], [h, Xe], [p, v]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [l, [h, dr], [p, b]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [l, [h, dr], [p, v]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [h, [p, w]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[l, /^/, "SmartTV"], [h, wt], [p, w]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[h, K], [p, w]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [h, [l, se + " TV"], [p, w]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[l, ue + "cast"], [h, Le], [p, w]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [l, [h, q], [p, w]],
        [
          /(shield \w+ tv)/i
          // Nvidia Shield TV
        ],
        [l, [h, Ye], [p, w]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [l, [h, Zi], [p, w]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [l, [h, At], [p, w]],
        [
          /(mi(tv|box)-?\w+) bui/i
          // Xiaomi
        ],
        [l, [h, lr], [p, w]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [h, l, [p, w]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[h, fr], [l, fr], [p, w]],
        [
          // SmartTV from Unidentified Vendors
          /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
        ],
        [l, [p, w]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[p, w]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [h, l, [p, y]],
        [
          /droid.+; (shield)( bui|\))/i
          // Nvidia Portable
        ],
        [l, [h, Ye], [p, y]],
        [
          /(playstation \w+)/i
          // Playstation
        ],
        [l, [h, At], [p, y]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [l, [h, Xe], [p, y]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
          // Samsung Galaxy Watch
        ],
        [l, [h, wt], [p, E]],
        [
          /((pebble))app/i,
          // Pebble
          /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
          // Asus ZenWatch / LG Watch / Pixel Watch
        ],
        [h, l, [p, E]],
        [
          /(ow(?:19|20)?we?[1-3]{1,3})/i
          // Oppo Watch
        ],
        [l, [h, ur], [p, E]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [l, [h, se], [p, E]],
        [
          /(opwwe\d{3})/i
          // OnePlus Watch
        ],
        [l, [h, Ji], [p, E]],
        [
          /(moto 360)/i
          // Motorola 360
        ],
        [l, [h, Me], [p, E]],
        [
          /(smartwatch 3)/i
          // Sony SmartWatch
        ],
        [l, [h, At], [p, E]],
        [
          /(g watch r)/i
          // LG G Watch R
        ],
        [l, [h, K], [p, E]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [l, [h, dr], [p, E]],
        [
          ///////////////////
          // XR
          ///////////////////
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [l, [h, Le], [p, E]],
        [
          /(pico) (4|neo3(?: link|pro)?)/i
          // Pico
        ],
        [h, l, [p, E]],
        [
          /; (quest( \d| pro)?)/i
          // Oculus Quest
        ],
        [l, [h, es], [p, E]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [h, [p, T]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [l, [h, q], [p, T]],
        [
          /(homepod).+mac os/i
          // Apple HomePod
        ],
        [l, [h, se], [p, T]],
        [
          /windows iot/i
        ],
        [[p, T]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [l, [p, v]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [l, [p, b]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[p, b]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[p, v]],
        [
          /droid .+?; ([\w\. -]+)( bui|\))/i
          // Generic Android Device
        ],
        [l, [h, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [d, Et + "HTML"]],
        [
          /(arkweb)\/([\w\.]+)/i
          // ArkWeb
        ],
        [d, g],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [d, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
          // LibWeb
        ],
        [d, g],
        [
          /ladybird\//i
        ],
        [[d, "LibWeb"]],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, d]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [d, g],
        [
          /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [d, [g, Pt, ss]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[g, Pt, ss], [d, "Windows"]],
        [
          // iOS/macOS
          /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [d, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[d, ns], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [g, d],
        [
          /(ubuntu) ([\w\.]+) like android/i
          // Ubuntu Touch
        ],
        [[d, /(.+)/, "$1 Touch"], g],
        [
          // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
          /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
        ],
        [d, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [d, Ee]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [d, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [d, xe + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [d, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [g, [d, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [d, ue + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[d, ts], g],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [d, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[d, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [d, g]
      ]
    }, oe = function(P, N) {
      if (typeof P === u && (N = P, P = r), !(this instanceof oe))
        return new oe(P, N).getResult();
      var O = typeof n !== c && n.navigator ? n.navigator : r, D = P || (O && O.userAgent ? O.userAgent : s), Se = O && O.userAgentData ? O.userAgentData : r, le = N ? qc(os, N) : os, x = O && O.userAgent == D;
      return this.getBrowser = function() {
        var A = {};
        return A[d] = r, A[g] = r, Rt.call(A, D, le.browser), A[m] = Kc(A[g]), x && O && O.brave && typeof O.brave.isBrave == a && (A[d] = "Brave"), A;
      }, this.getCPU = function() {
        var A = {};
        return A[S] = r, Rt.call(A, D, le.cpu), A;
      }, this.getDevice = function() {
        var A = {};
        return A[h] = r, A[l] = r, A[p] = r, Rt.call(A, D, le.device), x && !A[p] && Se && Se.mobile && (A[p] = v), x && A[l] == "Macintosh" && O && typeof O.standalone !== c && O.maxTouchPoints && O.maxTouchPoints > 2 && (A[l] = "iPad", A[p] = b), A;
      }, this.getEngine = function() {
        var A = {};
        return A[d] = r, A[g] = r, Rt.call(A, D, le.engine), A;
      }, this.getOS = function() {
        var A = {};
        return A[d] = r, A[g] = r, Rt.call(A, D, le.os), x && !A[d] && Se && Se.platform && Se.platform != "Unknown" && (A[d] = Se.platform.replace(/chrome os/i, ts).replace(/macos/i, ns)), A;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return D;
      }, this.setUA = function(A) {
        return D = typeof A === f && A.length > I ? fr(A, I) : A, this;
      }, this.setUA(D), this;
    };
    oe.VERSION = i, oe.BROWSER = Zt([d, g, m]), oe.CPU = Zt([S]), oe.DEVICE = Zt([l, h, p, y, v, w, b, E, T]), oe.ENGINE = oe.OS = Zt([d, g]), e.exports && (t = e.exports = oe), t.UAParser = oe;
    var Qe = typeof n !== c && (n.jQuery || n.Zepto);
    if (Qe && !Qe.ua) {
      var en = new oe();
      Qe.ua = en.getResult(), Qe.ua.get = function() {
        return en.getUA();
      }, Qe.ua.set = function(P) {
        en.setUA(P);
        var N = en.getResult();
        for (var O in N)
          Qe.ua[O] = N[O];
      };
    }
  })(typeof window == "object" ? window : eu);
})(Yr, Yr.exports);
var vl = Yr.exports;
const El = () => {
  const e = new vl.UAParser(), { name: t, version: n } = e.getBrowser(), { name: r, version: i } = e.getOS(), s = e.getUA(), o = navigator.language, a = navigator.userAgent.includes("Mobi"), c = u();
  return {
    browser: {
      name: t != null ? t : Y,
      version: n != null ? n : Y,
      os: `${r != null ? r : Y} ${i != null ? i : Y}`,
      userAgent: s != null ? s : Y,
      language: o != null ? o : Y,
      mobile: a,
      brands: c != null ? c : Y,
      viewportWidth: `${window.innerWidth}`,
      viewportHeight: `${window.innerHeight}`
    }
  };
  function u() {
    if (!(!t || !n) && "userAgentData" in navigator && navigator.userAgentData)
      return navigator.userAgentData.brands;
  }
};
function Sl(e) {
  var t, n, r, i;
  return {
    id: (i = (r = (n = (t = U.config) === null || t === void 0 ? void 0 : t.sessionTracking) === null || n === void 0 ? void 0 : n.generateSessionId) === null || r === void 0 ? void 0 : r.call(n)) !== null && i !== void 0 ? i : Ke(),
    attributes: e
  };
}
const Tl = () => ({
  sdk: {
    name: "faro-web",
    version: X
  }
}), Ie = {
  session: "sessionStorage",
  local: "localStorage"
};
function zo(e) {
  var t;
  try {
    let n;
    n = window[e];
    const r = "__faro_storage_test__";
    return n.setItem(r, r), n.removeItem(r), !0;
  } catch (n) {
    return (t = U.internalLogger) === null || t === void 0 || t.info(`Web storage of type ${e} is not available. Reason: ${n}`), !1;
  }
}
function Gn(e, t) {
  return wi(t) ? window[t].getItem(e) : null;
}
function yi(e, t, n) {
  if (wi(n))
    try {
      window[n].setItem(e, t);
    } catch (r) {
    }
}
function qo(e, t) {
  wi(t) && window[t].removeItem(e);
}
const Ko = zo(Ie.local), Wo = zo(Ie.session);
function wi(e) {
  return e === Ie.local ? Ko : e === Ie.session ? Wo : !1;
}
function Xo(e, t) {
  let n = !1, r;
  const i = () => {
    if (r == null) {
      n = !1;
      return;
    }
    e(...r), r = null, setTimeout(i, t);
  };
  return (...s) => {
    if (n) {
      r = s;
      return;
    }
    e(...s), n = !0, setTimeout(i, t);
  };
}
function yl() {
  return U.transports.transports.flatMap((e) => e.getIgnoreUrls());
}
function zn(e = "") {
  return yl().some((t) => e && e.match(t) != null);
}
function Yo(e) {
  if (Gt(e))
    return e;
  if (e instanceof URL)
    return e.href;
  if (!je(e) && zt(e == null ? void 0 : e.toString))
    return e.toString();
}
const it = "com.grafana.faro.session", wl = 4 * 60 * 60 * 1e3, Qo = 15 * 60 * 1e3, Jo = 1 * 1e3, Al = Qo, Ol = {
  enabled: !0,
  persistent: !1,
  maxSessionPersistenceTime: Al
};
function Ai() {
  var e, t, n;
  const i = U.config.sessionTracking, s = (n = (t = (e = i == null ? void 0 : i.sampler) === null || e === void 0 ? void 0 : e.call(i, { metas: U.metas.value })) !== null && t !== void 0 ? t : i == null ? void 0 : i.samplingRate) !== null && n !== void 0 ? n : 1, o = typeof s == "number" ? Eu(s) : 0;
  return Math.random() < o;
}
function yn({ sessionId: e, started: t, lastActivity: n, isSampled: r = !0 } = {}) {
  var i, s;
  const o = ct(), a = (s = (i = U.config) === null || i === void 0 ? void 0 : i.sessionTracking) === null || s === void 0 ? void 0 : s.generateSessionId;
  return e == null && (e = typeof a == "function" ? a() : Ke()), {
    sessionId: e,
    lastActivity: n != null ? n : o,
    started: t != null ? t : o,
    isSampled: r
  };
}
function Zo(e) {
  if (e == null)
    return !1;
  const t = ct();
  return t - e.started < wl ? t - e.lastActivity < Qo : !1;
}
function Oi({ fetchUserSession: e, storeUserSession: t }) {
  return function({ forceSessionExtend: r } = { forceSessionExtend: !1 }) {
    var i, s, o;
    if (!e || !t)
      return;
    const a = U.config.sessionTracking, c = a == null ? void 0 : a.persistent;
    if (c && !Ko || !c && !Wo)
      return;
    const u = e();
    if (r === !1 && Zo(u))
      t(Object.assign(Object.assign({}, u), { lastActivity: ct() }));
    else {
      let f = ea(yn({ isSampled: Ai() }), u);
      t(f), (i = U.api) === null || i === void 0 || i.setSession(f.sessionMeta), (s = a == null ? void 0 : a.onSessionChange) === null || s === void 0 || s.call(a, (o = u == null ? void 0 : u.sessionMeta) !== null && o !== void 0 ? o : null, f.sessionMeta);
    }
  };
}
function ea(e, t) {
  var n, r, i, s, o, a, c;
  const u = Object.assign(Object.assign({}, e), { sessionMeta: {
    id: e.sessionId,
    attributes: Rl(Object.assign(Object.assign(Object.assign({}, (r = (n = U.config.sessionTracking) === null || n === void 0 ? void 0 : n.session) === null || r === void 0 ? void 0 : r.attributes), (s = (i = U.metas.value.session) === null || i === void 0 ? void 0 : i.attributes) !== null && s !== void 0 ? s : {}), { isSampled: e.isSampled.toString() }))
  } }), f = (a = (o = U.metas.value.session) === null || o === void 0 ? void 0 : o.overrides) !== null && a !== void 0 ? a : (c = t == null ? void 0 : t.sessionMeta) === null || c === void 0 ? void 0 : c.overrides;
  je(f) || (u.sessionMeta.overrides = f);
  const m = t == null ? void 0 : t.sessionId;
  return m != null && (u.sessionMeta.attributes.previousSession = m), u;
}
function ta({ fetchUserSession: e, storeUserSession: t }) {
  let n = !1;
  return function(i) {
    if (n)
      return;
    const s = i.session, o = e();
    let a = s == null ? void 0 : s.id;
    const c = s == null ? void 0 : s.attributes, u = s == null ? void 0 : s.overrides, f = o == null ? void 0 : o.sessionMeta, m = f == null ? void 0 : f.overrides, l = !!u && !$e(u, m), d = !!c && !$e(c, f == null ? void 0 : f.attributes);
    if (!!s && a !== (o == null ? void 0 : o.sessionId) || d || l) {
      const h = ea(yn({ sessionId: a, isSampled: Ai() }), o);
      t(h), Pl(l, u, m), n = !0;
      try {
        U.api.setSession(h.sessionMeta);
      } finally {
        n = !1;
      }
    }
  };
}
function Rl(e) {
  const t = {};
  for (const n of Object.keys(e)) {
    const r = e[n];
    r !== void 0 && (t[n] = r);
  }
  return t;
}
function Pl(e, t = {}, n = {}) {
  var r, i, s;
  if (!e)
    return;
  const o = t.serviceName, a = (s = (r = n.serviceName) !== null && r !== void 0 ? r : (i = U.metas.value.app) === null || i === void 0 ? void 0 : i.name) !== null && s !== void 0 ? s : "";
  o && o !== a && U.api.pushEvent(bl, {
    serviceName: o,
    previousServiceName: a
  });
}
class ce {
  constructor() {
    this.updateSession = Xo(() => this.updateUserSession(), Jo), this.updateUserSession = Oi({
      fetchUserSession: ce.fetchUserSession,
      storeUserSession: ce.storeUserSession
    }), this.init();
  }
  static removeUserSession() {
    qo(it, ce.storageTypeLocal);
  }
  static storeUserSession(t) {
    yi(it, qt(t), ce.storageTypeLocal);
  }
  static fetchUserSession() {
    const t = Gn(it, ce.storageTypeLocal);
    return t ? JSON.parse(t) : null;
  }
  init() {
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible" && this.updateSession();
    }), U.metas.addListener(ta({
      fetchUserSession: ce.fetchUserSession,
      storeUserSession: ce.storeUserSession
    }));
  }
}
ce.storageTypeLocal = Ie.local;
class pe {
  constructor() {
    this.updateSession = Xo(() => this.updateUserSession(), Jo), this.updateUserSession = Oi({
      fetchUserSession: pe.fetchUserSession,
      storeUserSession: pe.storeUserSession
    }), this.init();
  }
  static removeUserSession() {
    qo(it, pe.storageTypeSession);
  }
  static storeUserSession(t) {
    yi(it, qt(t), pe.storageTypeSession);
  }
  static fetchUserSession() {
    const t = Gn(it, pe.storageTypeSession);
    return t ? JSON.parse(t) : null;
  }
  init() {
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible" && this.updateSession();
    }), U.metas.addListener(ta({
      fetchUserSession: pe.fetchUserSession,
      storeUserSession: pe.storeUserSession
    }));
  }
}
pe.storageTypeSession = Ie.session;
function na(e) {
  return e != null && e.persistent ? ce : pe;
}
class Il extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-session", this.version = X;
  }
  sendSessionStartEvent(t) {
    var n, r;
    const i = t.session;
    if (i && i.id !== ((n = this.notifiedSession) === null || n === void 0 ? void 0 : n.id)) {
      if (this.notifiedSession && this.notifiedSession.id === ((r = i.attributes) === null || r === void 0 ? void 0 : r.previousSession)) {
        this.api.pushEvent(_l, {}, void 0, { skipDedupe: !0 }), this.notifiedSession = i;
        return;
      }
      this.notifiedSession = i, this.api.pushEvent(rn, {}, void 0, { skipDedupe: !0 });
    }
  }
  createInitialSession(t, n) {
    var r, i, s, o, a, c;
    let u = t.fetchUserSession();
    if (n.persistent && n.maxSessionPersistenceTime && u) {
      const l = ct();
      u.lastActivity < l - n.maxSessionPersistenceTime && (ce.removeUserSession(), u = null);
    }
    let f, m;
    if (Zo(u)) {
      const l = u == null ? void 0 : u.sessionId;
      m = yn({
        sessionId: l,
        isSampled: u.isSampled || !1,
        started: u == null ? void 0 : u.started
      });
      const d = u == null ? void 0 : u.sessionMeta, p = Object.assign(Object.assign({}, (r = n.session) === null || r === void 0 ? void 0 : r.overrides), d == null ? void 0 : d.overrides);
      m.sessionMeta = Object.assign(Object.assign({}, n.session), { id: l, attributes: Object.assign(Object.assign(Object.assign({}, (i = n.session) === null || i === void 0 ? void 0 : i.attributes), d == null ? void 0 : d.attributes), {
        // For valid resumed sessions we do not want to recalculate the sampling decision on each init phase.
        isSampled: m.isSampled.toString()
      }), overrides: p }), f = br;
    } else {
      const l = (o = (s = n.session) === null || s === void 0 ? void 0 : s.id) !== null && o !== void 0 ? o : Sl().id;
      m = yn({
        sessionId: l,
        isSampled: Ai()
      });
      const d = (a = n.session) === null || a === void 0 ? void 0 : a.overrides;
      m.sessionMeta = Object.assign({ id: l, attributes: Object.assign({ isSampled: m.isSampled.toString() }, (c = n.session) === null || c === void 0 ? void 0 : c.attributes) }, d ? { overrides: d } : {}), f = rn;
    }
    return { initialSession: m, lifecycleType: f };
  }
  registerBeforeSendHook(t) {
    var n;
    const { updateSession: r } = new t();
    (n = this.transports) === null || n === void 0 || n.addBeforeSendHooks((i) => {
      var s, o, a;
      r();
      const c = (s = i.meta.session) === null || s === void 0 ? void 0 : s.attributes;
      if (c && (c == null ? void 0 : c.isSampled) === "true") {
        let u = JSON.parse(JSON.stringify(i));
        const f = (o = u.meta.session) === null || o === void 0 ? void 0 : o.attributes;
        return f == null || delete f.isSampled, Object.keys(f != null ? f : {}).length === 0 && ((a = u.meta.session) === null || a === void 0 || delete a.attributes), u;
      }
      return null;
    });
  }
  initialize() {
    this.logDebug("init session instrumentation");
    const t = this.config.sessionTracking;
    if (t != null && t.enabled) {
      const n = na(t);
      this.registerBeforeSendHook(n);
      const { initialSession: r, lifecycleType: i } = this.createInitialSession(n, t);
      n.storeUserSession(r);
      const s = r.sessionMeta;
      this.notifiedSession = s, this.api.setSession(s), i === rn && this.api.pushEvent(rn, {}, void 0, { skipDedupe: !0 }), i === br && this.api.pushEvent(br, {}, void 0, { skipDedupe: !0 });
    }
    this.metas.addListener(this.sendSessionStartEvent.bind(this));
  }
}
const Cl = "resource-entry", Ri = "http-request-start", Pi = "http-request-end", Nl = "dom-mutation", xl = "console";
let sn, ms = !1;
function Ll(e) {
  if (sn || (sn = new z()), !ms) {
    const t = e != null ? e : Kt;
    Nu.forEach((n) => {
      console[n] = (...r) => {
        var i;
        sn.notify({
          type: xl,
          level: n,
          args: r
        }), (i = t[n]) === null || i === void 0 || i.apply(console, r);
      };
    }), ms = !0;
  }
  return sn;
}
const Ml = "Non-Error promise rejection captured with value:", kl = "UnhandledRejection", Dl = "DOMError", Ul = "DOMException", $l = "Non-Error exception captured with keys:", jl = "?", Bl = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function Fl(e) {
  var t, n;
  const r = e.match(Bl), i = (t = r == null ? void 0 : r[1]) !== null && t !== void 0 ? t : Ho;
  return [(n = r == null ? void 0 : r[2]) !== null && n !== void 0 ? n : e, i];
}
const gs = `
`, Vl = "eval", Hl = "?", _s = "@", Gl = /^\s*at (?:(?![a-z]+:\/\/)([^(]+?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, zl = /\((\S*)(?::(\d+))(?::(\d+))\)/, ql = "eval", ra = "address at ", Kl = ra.length, Wl = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Xl = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Yl = " > eval", bs = "safari-extension", vs = "safari-web-extension", Ql = /Minified React error #\d+;/i;
function ia(e, t, n, r) {
  const i = {
    filename: e || document.location.href,
    function: t || Hl
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
function Es(e, t) {
  const n = e == null ? void 0 : e.includes(bs), r = !n && (e == null ? void 0 : e.includes(vs));
  return !n && !r ? [e, t] : [
    e != null && e.includes(_s) ? e.split(_s)[0] : e,
    n ? `${bs}:${t}` : `${vs}:${t}`
  ];
}
function Qr(e) {
  let t = [];
  e.stacktrace ? t = e.stacktrace.split(gs).filter((r, i) => i % 2 === 0) : e.stack && (t = e.stack.split(gs));
  const n = t.reduce((r, i, s) => {
    let o, a, c, u, f;
    if (o = Gl.exec(i)) {
      if (a = o[1], c = o[2], u = o[3], f = o[4], c != null && c.startsWith(ql)) {
        const m = zl.exec(c);
        m && (c = m[1], u = m[2], f = m[3]);
      }
      c = c != null && c.startsWith(ra) ? c.substring(Kl) : c, [a, c] = Es(a, c);
    } else if (o = Wl.exec(i)) {
      if (a = o[1], c = o[3], u = o[4], f = o[5], c && c.includes(Yl)) {
        const m = Xl.exec(c);
        m && (a = a || Vl, c = m[1], u = m[2]);
      } else
        s === 0 && !f && Su(e.columnNumber) && (f = String(e.columnNumber + 1));
      [a, c] = Es(a, c);
    }
    return (c || a) && r.push(ia(c, a, u ? Number(u) : void 0, f ? Number(f) : void 0)), r;
  }, []);
  return Ql.test(e.message) ? n.slice(1) : n;
}
function Jl(e) {
  return {
    frames: Qr(e)
  };
}
function sa(e) {
  let t, n, r = [], i, s;
  if (Ru(e) && e.error)
    t = e.error.message, n = e.error.name, r = Qr(e.error);
  else if ((i = Pu(e)) || Iu(e)) {
    const { name: o, message: a } = e;
    n = o != null ? o : i ? Dl : Ul, t = a ? `${n}: ${a}` : n;
  } else
    Si(e) ? (t = e.message, r = Qr(e)) : (me(e) || (s = Au(e))) && (n = s ? e.constructor.name : void 0, t = `${$l} ${Object.keys(e)}`);
  return [t, n, r];
}
function oa(e) {
  const [t, n, r, i, s] = e;
  let o, a, c = [];
  const u = Gt(t), f = ia(n, jl, r, i);
  return s || !u ? ([o, a, c] = sa(s != null ? s : t), c.length === 0 && (c = [f])) : u && ([o, a] = Fl(t), c = [f]), { value: o, type: a, stackFrames: c };
}
function Ss(e, t) {
  return Si(e[0]) ? oa(e) : { value: t(e) };
}
class Ue extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-console", this.version = X, this.errorSerializer = Tn;
  }
  initialize() {
    var t, n;
    const r = this.config.consoleInstrumentation, i = (r == null ? void 0 : r.serializeErrors) || !!(r != null && r.errorSerializer);
    this.errorSerializer = i ? (t = r == null ? void 0 : r.errorSerializer) !== null && t !== void 0 ? t : hs : Tn;
    const s = (n = r == null ? void 0 : r.disabledLevels) !== null && n !== void 0 ? n : Ue.defaultDisabledLevels, o = Ll(this.unpatchedConsole);
    this.subscription = o.subscribe(({ level: a, args: c }) => {
      if (!s.includes(a))
        try {
          if (a === W.ERROR && !(r != null && r.consoleErrorAsLog)) {
            const { value: u, type: f, stackFrames: m } = Ss(c, this.errorSerializer);
            if (u && !f && !m) {
              this.api.pushError(new Error(Ue.consoleErrorPrefix + u));
              return;
            }
            this.api.pushError(new Error(Ue.consoleErrorPrefix + u), { type: f, stackFrames: m });
          } else if (a === W.ERROR && (r != null && r.consoleErrorAsLog)) {
            const { value: u, type: f, stackFrames: m } = Ss(c, this.errorSerializer);
            this.api.pushLog(u ? [Ue.consoleErrorPrefix + u] : c, {
              level: a,
              context: {
                value: u != null ? u : "",
                type: f != null ? f : "",
                stackFrames: m != null && m.length ? hs(m) : ""
              }
            });
          } else
            this.api.pushLog(c, { level: a });
        } catch (u) {
          this.logError(u);
        }
    });
  }
  // Clean up subscription when instrumentation is destroyed
  destroy() {
    var t;
    (t = this.subscription) === null || t === void 0 || t.unsubscribe(), this.subscription = void 0;
  }
}
Ue.defaultDisabledLevels = [W.DEBUG, W.TRACE, W.LOG];
Ue.consoleErrorPrefix = "console.error: ";
function Zl(e) {
  const t = window.onerror;
  window.onerror = (...n) => {
    try {
      const { value: r, type: i, stackFrames: s } = oa(n), o = n[4];
      if (r) {
        const a = { type: i, stackFrames: s };
        o != null && (a.originalError = o), e.pushError(new Error(r), a);
      }
    } finally {
      t == null || t.apply(window, n);
    }
  };
}
function ed(e) {
  const t = (n) => {
    var r, i;
    let s = n;
    s.reason ? s = n.reason : !((r = n.detail) === null || r === void 0) && r.reason && (s = (i = n.detail) === null || i === void 0 ? void 0 : i.reason);
    let o, a, c = [];
    yu(s) ? (o = `${Ml} ${String(s)}`, a = kl) : [o, a, c] = sa(s), o && e.pushError(new Error(o), { type: a, stackFrames: c });
  };
  window.addEventListener("unhandledrejection", t);
}
class td extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-errors", this.version = X;
  }
  initialize() {
    this.logDebug("Initializing"), Zl(this.api), ed(this.api);
  }
}
class nd extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-view", this.version = X;
  }
  sendViewChangedEvent(t) {
    var n, r, i, s;
    const o = t.view;
    o && o.name !== ((n = this.notifiedView) === null || n === void 0 ? void 0 : n.name) && (this.api.pushEvent(gl, {
      fromView: (i = (r = this.notifiedView) === null || r === void 0 ? void 0 : r.name) !== null && i !== void 0 ? i : Y,
      toView: (s = o.name) !== null && s !== void 0 ? s : Y
    }, void 0, { skipDedupe: !0 }), this.notifiedView = o);
  }
  initialize() {
    this.metas.addListener(this.sendViewChangedEvent.bind(this));
  }
}
let Ts = class {
  constructor() {
    _(this, "t");
    _(this, "o", 0);
    _(this, "i", []);
  }
  u(t) {
    var i;
    if (t.hadRecentInput)
      return;
    const n = this.i[0], r = this.i.at(-1);
    this.o && n && r && t.startTime - r.startTime < 1e3 && t.startTime - n.startTime < 5e3 ? (this.o += t.value, this.i.push(t)) : (this.o = t.value, this.i = [t]), (i = this.t) == null || i.call(this, t);
  }
};
const _t = () => {
  const e = performance.getEntriesByType("navigation")[0];
  if (e && e.responseStart > 0 && e.responseStart < performance.now())
    return e;
}, wn = (e) => {
  if (document.readyState === "loading")
    return "loading";
  const t = _t();
  if (t) {
    if (e < t.domInteractive)
      return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart)
      return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, rd = (e) => {
  const t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, Ii = (e) => {
  let t = "";
  try {
    for (; (e == null ? void 0 : e.nodeType) !== 9; ) {
      const n = e, r = n.id ? "#" + n.id : [rd(n), ...Array.from(n.classList).sort()].join(".");
      if (t.length + r.length > 99)
        return t || r;
      if (t = t ? r + ">" + t : r, n.id)
        break;
      e = n.parentNode;
    }
  } catch (n) {
  }
  return t;
}, vr = /* @__PURE__ */ new WeakMap();
function ut(e, t) {
  return vr.get(e) || vr.set(e, new t()), vr.get(e);
}
let aa = -1;
const ca = () => aa, bt = (e) => {
  addEventListener("pageshow", (t) => {
    t.persisted && (aa = t.timeStamp, e(t));
  }, !0);
}, ge = (e, t, n, r) => {
  let i, s;
  return (o) => {
    t.value >= 0 && (o || r) && (s = t.value - (i != null ? i : 0), (s || i === void 0) && (i = t.value, t.delta = s, t.rating = ((a, c) => a > c[1] ? "poor" : a > c[0] ? "needs-improvement" : "good")(t.value, n), e(t)));
  };
}, Ci = (e) => {
  requestAnimationFrame(() => requestAnimationFrame(e));
}, Wt = () => {
  var e, t;
  return (t = (e = _t()) == null ? void 0 : e.activationStart) != null ? t : 0;
}, _e = (e, t = -1) => {
  const n = _t();
  let r = "navigate";
  return ca() >= 0 ? r = "back-forward-cache" : n && (document.prerendering || Wt() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: e, value: t, rating: "good", delta: 0, entries: [], id: `v5-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`, navigationType: r };
}, lt = (e, t, n = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((i) => {
        queueMicrotask(() => {
          t(i.getEntries());
        });
      });
      return r.observe(It({ type: e, buffered: !0 }, n)), r;
    }
  } catch (r) {
  }
}, Ni = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let et = -1;
const ua = /* @__PURE__ */ new Set(), ys = () => document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0, Jr = (e) => {
  if (document.visibilityState === "hidden") {
    if (e.type === "visibilitychange")
      for (const t of ua)
        t();
    isFinite(et) || (et = e.type === "visibilitychange" ? e.timeStamp : 0, removeEventListener("prerenderingchange", Jr, !0));
  }
}, qn = () => {
  var e;
  if (et < 0) {
    const t = Wt(), n = document.prerendering || (e = globalThis.performance.getEntriesByType("visibility-state").find((r) => r.name === "hidden" && r.startTime >= t)) == null ? void 0 : e.startTime;
    et = n != null ? n : ys(), addEventListener("visibilitychange", Jr, !0), addEventListener("prerenderingchange", Jr, !0), bt(() => {
      setTimeout(() => {
        et = ys();
      });
    });
  }
  return { get firstHiddenTime() {
    return et;
  }, onHidden(t) {
    ua.add(t);
  } };
}, Kn = (e) => {
  document.prerendering ? addEventListener("prerenderingchange", e, !0) : e();
}, ws = [1800, 3e3], la = (e, t = {}) => {
  Kn(() => {
    const n = qn();
    let r, i = _e("FCP");
    const s = lt("paint", (o) => {
      for (const a of o)
        a.name === "first-contentful-paint" && (s.disconnect(), a.startTime < n.firstHiddenTime && (i.value = Math.max(a.startTime - Wt(), 0), i.entries.push(a), r(!0)));
    });
    s && (r = ge(e, i, ws, t.reportAllChanges), bt((o) => {
      i = _e("FCP"), r = ge(e, i, ws, t.reportAllChanges), Ci(() => {
        i.value = performance.now() - o.timeStamp, r(!0);
      });
    }));
  });
}, As = [0.1, 0.25], Os = (e) => e.find((t) => {
  var n;
  return ((n = t.node) == null ? void 0 : n.nodeType) === 1;
}) || e[0], id = (e, t = {}) => {
  const n = ut(t = Object.assign({}, t), Ts), r = /* @__PURE__ */ new WeakMap();
  n.t = (i) => {
    var s, o, a;
    if ((s = i == null ? void 0 : i.sources) != null && s.length) {
      const c = Os(i.sources), u = c == null ? void 0 : c.node;
      if (u) {
        const f = (a = (o = t.generateTarget) == null ? void 0 : o.call(t, u)) != null ? a : Ii(u);
        r.set(c, f);
      }
    }
  }, ((i, s = {}) => {
    const o = qn();
    la(Ni(() => {
      let a, c = _e("CLS", 0);
      const u = ut(s, Ts), f = (l) => {
        for (const d of l)
          u.u(d);
        u.o > c.value && (c.value = u.o, c.entries = u.i, a());
      }, m = lt("layout-shift", f);
      m && (a = ge(i, c, As, s.reportAllChanges), o.onHidden(() => {
        f(m.takeRecords()), a(!0);
      }), bt(() => {
        u.o = 0, c = _e("CLS", 0), a = ge(i, c, As, s.reportAllChanges), Ci(a);
      }), setTimeout(a));
    }));
  })((i) => {
    e(((s) => {
      var a;
      let o = {};
      if (s.entries.length) {
        const c = s.entries.reduce((u, f) => u.value > f.value ? u : f);
        if ((a = c == null ? void 0 : c.sources) != null && a.length) {
          const u = Os(c.sources);
          u && (o = { largestShiftTarget: r.get(u), largestShiftTime: c.startTime, largestShiftValue: c.value, largestShiftSource: u, largestShiftEntry: c, loadState: wn(c.startTime) });
        }
      }
      return Object.assign(s, { attribution: o });
    })(i));
  }, t);
}, sd = (e, t = {}) => {
  la((n) => {
    e(((r) => {
      let i = { timeToFirstByte: 0, firstByteToFCP: r.value, loadState: wn(ca()) };
      if (r.entries.length) {
        const s = _t(), o = r.entries.at(-1);
        if (s) {
          const a = s.activationStart || 0, c = Math.max(0, s.responseStart - a);
          i = { timeToFirstByte: c, firstByteToFCP: r.value - c, loadState: wn(r.entries[0].startTime), navigationEntry: s, fcpEntry: o };
        }
      }
      return Object.assign(r, { attribution: i });
    })(n));
  }, t);
};
let da = 0, Er = 1 / 0, on = 0;
const od = (e) => {
  for (const t of e)
    t.interactionId && (Er = Math.min(Er, t.interactionId), on = Math.max(on, t.interactionId), da = on ? (on - Er) / 7 + 1 : 0);
};
let Zr;
const Rs = () => {
  var e;
  return Zr ? da : (e = performance.interactionCount) != null ? e : 0;
}, ad = () => {
  "interactionCount" in performance || Zr || (Zr = lt("event", od, { durationThreshold: 0 }));
};
let Ps = 0, Is = class {
  constructor() {
    _(this, "l", []);
    _(this, "h", /* @__PURE__ */ new Map());
    _(this, "m");
    _(this, "p");
  }
  v() {
    Ps = Rs(), this.l.length = 0, this.h.clear();
  }
  M() {
    const t = Math.min(this.l.length - 1, Math.floor((Rs() - Ps) / 50));
    return this.l[t];
  }
  u(t) {
    var i, s;
    if ((i = this.m) == null || i.call(this, t), !t.interactionId && t.entryType !== "first-input")
      return;
    const n = this.l.at(-1);
    let r = this.h.get(t.interactionId);
    if (r || this.l.length < 10 || t.duration > n.T) {
      if (r ? t.duration > r.T ? (r.entries = [t], r.T = t.duration) : t.duration === r.T && t.startTime === r.entries[0].startTime && r.entries.push(t) : (r = { id: t.interactionId, entries: [t], T: t.duration }, this.h.set(r.id, r), this.l.push(r)), this.l.sort((o, a) => a.T - o.T), this.l.length > 10) {
        const o = this.l.splice(10);
        for (const a of o)
          this.h.delete(a.id);
      }
      (s = this.p) == null || s.call(this, r);
    }
  }
};
const ei = (e) => {
  const t = globalThis.requestIdleCallback || setTimeout, n = globalThis.cancelIdleCallback || clearTimeout;
  if (document.visibilityState === "hidden")
    e();
  else {
    const r = Ni(e);
    let i = -1;
    const s = () => {
      n(i), r();
    };
    addEventListener("visibilitychange", s, { once: !0, capture: !0 }), i = t(() => {
      removeEventListener("visibilitychange", s, { capture: !0 }), r();
    });
  }
}, Cs = [200, 500], cd = (e, t = {}) => {
  const n = ut(t = Object.assign({}, t), Is);
  let r = [], i = [], s = 0;
  const o = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
  let c = !1;
  const u = () => {
    c || (ei(f), c = !0);
  }, f = () => {
    const d = new Set(n.l.map((g) => o.get(g.entries[0]))), p = i.length - 10;
    i = i.filter((g, S) => S >= p || d.has(g));
    const h = /* @__PURE__ */ new Set();
    for (const g of i) {
      const S = m(g.startTime, g.processingEnd);
      for (const y of S)
        h.add(y);
    }
    r = r.filter((g) => g.startTime > s || h.has(g)), c = !1;
  };
  n.m = (d) => {
    const p = d.startTime + d.duration;
    let h;
    s = Math.max(s, d.processingEnd);
    for (let g = i.length - 1; g >= 0; g--) {
      const S = i[g];
      if (Math.abs(p - S.renderTime) <= 8) {
        h = S, h.startTime = Math.min(d.startTime, h.startTime), h.processingStart = Math.min(d.processingStart, h.processingStart), h.processingEnd = Math.max(d.processingEnd, h.processingEnd), t.includeProcessedEventEntries !== !1 && h.entries.push(d);
        break;
      }
    }
    h || (h = { startTime: d.startTime, processingStart: d.processingStart, processingEnd: d.processingEnd, renderTime: p, entries: t.includeProcessedEventEntries !== !1 ? [d] : [] }, i.push(h)), (d.interactionId || d.entryType === "first-input") && o.set(d, h), u();
  }, n.p = (d) => {
    var p, h;
    if (!a.get(d)) {
      const g = d.entries[0].target;
      if (g) {
        const S = (h = (p = t.generateTarget) == null ? void 0 : p.call(t, g)) != null ? h : Ii(g);
        a.set(d, S);
      }
    }
  };
  const m = (d, p) => {
    const h = [];
    for (const g of r)
      if (!(g.startTime + g.duration < d)) {
        if (g.startTime > p)
          break;
        h.push(g);
      }
    return h;
  }, l = (d) => {
    const p = d.entries[0], h = o.get(p), g = p.processingStart, S = Math.max(p.startTime + p.duration, g), y = Math.min(h.processingEnd, S), v = h.entries.sort((T, I) => T.processingStart - I.processingStart), b = m(p.startTime, y), w = n.h.get(p.interactionId), E = { interactionTarget: a.get(w), interactionType: p.name.startsWith("key") ? "keyboard" : "pointer", interactionTime: p.startTime, nextPaintTime: S, processedEventEntries: v, longAnimationFrameEntries: b, inputDelay: g - p.startTime, processingDuration: y - g, presentationDelay: S - y, loadState: wn(p.startTime), longestScript: void 0, totalScriptDuration: void 0, totalStyleAndLayoutDuration: void 0, totalPaintDuration: void 0, totalUnattributedDuration: void 0 };
    return ((T) => {
      var Tt;
      if (!((Tt = T.longAnimationFrameEntries) != null && Tt.length))
        return;
      const I = T.interactionTime, q = T.inputDelay, se = T.processingDuration;
      let Ne, Ee, te = 0, ue = 0, Et = 0, xe = 0;
      for (const We of T.longAnimationFrameEntries) {
        ue = ue + We.startTime + We.duration - We.styleAndLayoutStart;
        for (const K of We.scripts) {
          const Xe = K.startTime + K.duration;
          if (Xe < I)
            continue;
          const Me = Xe - Math.max(I, K.startTime), Ye = K.duration ? Me / K.duration * K.forcedStyleAndLayoutDuration : 0;
          te += Me - Ye, ue += Ye, Me > xe && (Ee = K.startTime < I + q ? "input-delay" : K.startTime >= I + q + se ? "presentation-delay" : "processing-duration", Ne = K, xe = Me);
        }
      }
      const Le = T.longAnimationFrameEntries.at(-1), St = Le ? Le.startTime + Le.duration : 0;
      St >= I + q + se && (Et = T.nextPaintTime - St), Ne && Ee && (T.longestScript = { entry: Ne, subpart: Ee, intersectingDuration: xe }), T.totalScriptDuration = te, T.totalStyleAndLayoutDuration = ue, T.totalPaintDuration = Et, T.totalUnattributedDuration = T.nextPaintTime - I - te - ue - Et;
    })(E), Object.assign(d, { attribution: E });
  };
  lt("long-animation-frame", (d) => {
    r = r.concat(d), u();
  }), ((d, p = {}) => {
    if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype))
      return;
    const h = qn();
    Kn(() => {
      var w;
      ad();
      let g, S = _e("INP");
      const y = ut(p, Is), v = (E) => {
        ei(() => {
          for (const I of E)
            y.u(I);
          const T = y.M();
          T && T.T !== S.value && (S.value = T.T, S.entries = T.entries, g());
        });
      }, b = lt("event", v, { durationThreshold: (w = p.durationThreshold) != null ? w : 40 });
      g = ge(d, S, Cs, p.reportAllChanges), b && (b.observe({ type: "first-input", buffered: !0 }), h.onHidden(() => {
        v(b.takeRecords()), g(!0);
      }), bt(() => {
        y.v(), S = _e("INP"), g = ge(d, S, Cs, p.reportAllChanges);
      }));
    });
  })((d) => {
    e(l(d));
  }, t);
};
class Ns {
  constructor() {
    _(this, "m");
  }
  u(t) {
    var n;
    (n = this.m) == null || n.call(this, t);
  }
}
const xs = [2500, 4e3], ud = (e, t = {}) => {
  const n = ut(t = Object.assign({}, t), Ns), r = /* @__PURE__ */ new WeakMap();
  n.m = (i) => {
    var o, a;
    const s = i.element;
    if (s) {
      const c = (a = (o = t.generateTarget) == null ? void 0 : o.call(t, s)) != null ? a : Ii(s);
      r.set(i, c);
    } else
      i.id && r.set(i, `#${i.id}`);
  }, ((i, s = {}) => {
    Kn(() => {
      const o = qn();
      let a, c = _e("LCP");
      const u = ut(s, Ns), f = (l) => {
        s.reportAllChanges || (l = l.slice(-1));
        for (const d of l)
          u.u(d), d.startTime < o.firstHiddenTime && (c.value = Math.max(d.startTime - Wt(), 0), c.entries = [d], a());
      }, m = lt("largest-contentful-paint", f);
      if (m) {
        a = ge(i, c, xs, s.reportAllChanges);
        const l = Ni(() => {
          f(m.takeRecords()), m.disconnect(), a(!0);
        }), d = (p) => {
          p.isTrusted && (ei(l), removeEventListener(p.type, d, { capture: !0 }));
        };
        for (const p of ["keydown", "click", "visibilitychange"])
          addEventListener(p, d, { capture: !0 });
        bt((p) => {
          c = _e("LCP"), a = ge(i, c, xs, s.reportAllChanges), Ci(() => {
            c.value = performance.now() - p.timeStamp, a(!0);
          });
        });
      }
    });
  })((i) => {
    e(((s) => {
      let o = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadDuration: 0, elementRenderDelay: s.value };
      if (s.entries.length) {
        const a = s.entries.at(-1), c = a.url && performance.getEntriesByType("resource").find((f) => f.name === a.url);
        o.target = r.get(a), o.lcpEntry = a, a.url && (o.url = a.url), c && (o.lcpResourceEntry = c);
        const u = _t();
        if (u) {
          const f = u.activationStart || 0, m = Math.max(0, u.responseStart - f), l = Math.max(m, c ? (c.requestStart || c.startTime) - f : 0), d = Math.min(s.value, Math.max(l, c ? c.responseEnd - f : 0));
          o = mr(It({}, o), { timeToFirstByte: m, resourceLoadDelay: l - m, resourceLoadDuration: d - l, elementRenderDelay: s.value - d, navigationEntry: u });
        }
      }
      return Object.assign(s, { attribution: o });
    })(i));
  }, t);
}, Ls = [800, 1800], ti = (e) => {
  document.prerendering ? Kn(() => ti(e)) : document.readyState !== "complete" ? addEventListener("load", () => ti(e), !0) : setTimeout(e);
}, ld = (e, t = {}) => {
  ((n, r = {}) => {
    let i = _e("TTFB"), s = ge(n, i, Ls, r.reportAllChanges);
    ti(() => {
      const o = _t();
      o && (i.value = Math.max(o.responseStart - Wt(), 0), i.entries = [o], s(!0), bt(() => {
        i = _e("TTFB", 0), s = ge(n, i, Ls, r.reportAllChanges), s(!0);
      }));
    });
  })((n) => {
    e(((r) => {
      let i = { waitingDuration: 0, cacheDuration: 0, dnsDuration: 0, connectionDuration: 0, requestDuration: 0 };
      if (r.entries.length) {
        const s = r.entries[0], o = s.activationStart || 0, a = Math.max((s.workerStart || s.fetchStart) - o, 0), c = Math.max(s.domainLookupStart - o, 0), u = Math.max(s.connectStart - o, 0), f = Math.max(s.connectEnd - o, 0);
        i = { waitingDuration: a, cacheDuration: c - a, dnsDuration: u - c, connectionDuration: f - u, requestDuration: r.value - f, navigationEntry: s };
      }
      return Object.assign(r, { attribution: i });
    })(n));
  }, t);
}, ni = "com.grafana.faro.lastNavigationId", Sr = "load_state", Ms = "time_to_first_byte";
class dd {
  constructor(t, n) {
    this.corePushMeasurement = t, this.webVitalConfig = n;
  }
  initialize() {
    this.measureCLS(), this.measureFCP(), this.measureINP(), this.measureLCP(), this.measureTTFB();
  }
  measureCLS() {
    var t;
    id((n) => {
      const { loadState: r, largestShiftValue: i, largestShiftTime: s, largestShiftTarget: o } = n.attribution, a = this.buildInitialValues(n);
      this.addIfPresent(a, "largest_shift_value", i), this.addIfPresent(a, "largest_shift_time", s);
      const c = this.buildInitialContext(n);
      this.addIfPresent(c, Sr, r), this.addIfPresent(c, "largest_shift_target", o), this.pushMeasurement(a, c);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureFCP() {
    var t;
    sd((n) => {
      const { firstByteToFCP: r, timeToFirstByte: i, loadState: s } = n.attribution, o = this.buildInitialValues(n);
      this.addIfPresent(o, "first_byte_to_fcp", r), this.addIfPresent(o, Ms, i);
      const a = this.buildInitialContext(n);
      this.addIfPresent(a, Sr, s), this.pushMeasurement(o, a);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureINP() {
    var t;
    cd((n) => {
      const { interactionTime: r, presentationDelay: i, inputDelay: s, processingDuration: o, nextPaintTime: a, loadState: c, interactionTarget: u, interactionType: f } = n.attribution, m = this.buildInitialValues(n);
      this.addIfPresent(m, "interaction_time", r), this.addIfPresent(m, "presentation_delay", i), this.addIfPresent(m, "input_delay", s), this.addIfPresent(m, "processing_duration", o), this.addIfPresent(m, "next_paint_time", a);
      const l = this.buildInitialContext(n);
      this.addIfPresent(l, Sr, c), this.addIfPresent(l, "interaction_target", u), this.addIfPresent(l, "interaction_type", f), this.pushMeasurement(m, l);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureLCP() {
    var t;
    ud((n) => {
      const { elementRenderDelay: r, resourceLoadDelay: i, resourceLoadDuration: s, timeToFirstByte: o, target: a } = n.attribution, c = this.buildInitialValues(n);
      this.addIfPresent(c, "element_render_delay", r), this.addIfPresent(c, "resource_load_delay", i), this.addIfPresent(c, "resource_load_duration", s), this.addIfPresent(c, Ms, o);
      const u = this.buildInitialContext(n);
      this.addIfPresent(u, "element", a), this.pushMeasurement(c, u);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  measureTTFB() {
    var t;
    ld((n) => {
      const { dnsDuration: r, connectionDuration: i, requestDuration: s, waitingDuration: o, cacheDuration: a } = n.attribution, c = this.buildInitialValues(n);
      this.addIfPresent(c, "dns_duration", r), this.addIfPresent(c, "connection_duration", i), this.addIfPresent(c, "request_duration", s), this.addIfPresent(c, "waiting_duration", o), this.addIfPresent(c, "cache_duration", a);
      const u = this.buildInitialContext(n);
      this.pushMeasurement(c, u);
    }, { reportAllChanges: (t = this.webVitalConfig) === null || t === void 0 ? void 0 : t.reportAllChanges });
  }
  buildInitialValues(t) {
    return {
      [t.name.toLowerCase()]: t.value,
      delta: t.delta
    };
  }
  buildInitialContext(t) {
    var n;
    const r = (n = Gn(ni, Ie.session)) !== null && n !== void 0 ? n : Y;
    return {
      id: t.id,
      rating: t.rating,
      navigation_type: t.navigationType,
      navigation_entry_id: r
    };
  }
  pushMeasurement(t, n) {
    const r = "web-vitals";
    this.corePushMeasurement({ type: r, values: t }, { context: n });
  }
  addIfPresent(t, n, r) {
    r && (t[n] = r);
  }
}
class fd extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-web-vitals", this.version = X;
  }
  initialize() {
    this.logDebug("Initializing"), new dd(this.api.pushMeasurement, this.config.webVitalsInstrumentation).initialize();
  }
}
const pd = "navigation", ri = "resource", hd = /^00-[a-f0-9]{32}-[a-f0-9]{16}-[0-9]{1,2}$/;
function fa(e = []) {
  for (const t of e)
    if (t.name === "traceparent") {
      if (!hd.test(t.description))
        continue;
      const [, n, r] = t.description.split("-");
      if (n != null && r != null)
        return { traceId: n, spanId: r };
      break;
    }
}
function md() {
  return "PerformanceObserver" in window;
}
function gd(e) {
  if (document.readyState === "complete")
    e();
  else {
    const t = () => {
      document.readyState === "complete" && (e(), document.removeEventListener("readystatechange", t));
    };
    document.addEventListener("readystatechange", t);
  }
}
function _d(e, t = {}) {
  for (const [n, r] of Object.entries(t)) {
    const i = e[n];
    return i == null ? !1 : at(r) ? r.includes(i) : i === r;
  }
  return !0;
}
function pa(e) {
  const {
    connectEnd: t,
    connectStart: n,
    decodedBodySize: r,
    domainLookupEnd: i,
    domainLookupStart: s,
    duration: o,
    encodedBodySize: a,
    fetchStart: c,
    initiatorType: u,
    name: f,
    nextHopProtocol: m,
    redirectEnd: l,
    redirectStart: d,
    // @ts-expect-error the renderBlockingStatus property is not available in all browsers
    renderBlockingStatus: p,
    requestStart: h,
    responseEnd: g,
    responseStart: S,
    responseStatus: y,
    secureConnectionStart: v,
    transferSize: b,
    workerStart: w
  } = e;
  return {
    name: f,
    duration: B(o),
    tcpHandshakeTime: B(t - n),
    dnsLookupTime: B(i - s),
    tlsNegotiationTime: B(t - v),
    responseStatus: B(y),
    redirectTime: B(l - d),
    requestTime: B(S - h),
    responseTime: B(g - S),
    fetchTime: B(g - c),
    serviceWorkerTime: B(c - w),
    decodedBodySize: B(r),
    encodedBodySize: B(a),
    cacheHitStatus: E(),
    renderBlockingStatus: B(p),
    protocol: m,
    initiatorType: u,
    visibilityState: document.visibilityState,
    ttfb: B(S - h),
    transferSize: B(b)
    // TODO: add in future iteration, ideally after nested objects are supported by the collector.
    // serverTiming: resourceEntryRaw.serverTiming,
  };
  function E() {
    let T = "fullLoad";
    return b === 0 ? r > 0 && (T = "cache") : y != null ? y === 304 && (T = "conditionalFetch") : a > 0 && b < a && (T = "conditionalFetch"), T;
  }
}
function bd(e) {
  const { activationStart: t, domComplete: n, domContentLoadedEventEnd: r, domContentLoadedEventStart: i, domInteractive: s, fetchStart: o, loadEventEnd: a, loadEventStart: c, responseStart: u, type: f } = e, m = vd();
  return Object.assign(Object.assign({}, pa(e)), {
    pageLoadTime: B(n - o),
    documentParsingTime: B(m ? s - m : null),
    domProcessingTime: B(n - s),
    domContentLoadHandlerTime: B(r - i),
    onLoadTime: B(a - c),
    // For navigation entries we can calculate the TTFB based on activationStart. We overwrite the TTFB value coming with the resource entry.
    // For more accuracy on prerendered pages page we calculate relative top the activationStart instead of the start of the navigation.
    // clamp to 0 if activationStart occurs after first byte is received.
    ttfb: B(Math.max(u - (t != null ? t : 0), 0)),
    type: f
  });
}
function vd() {
  var e;
  return ((e = performance.timing) === null || e === void 0 ? void 0 : e.domLoading) != null ? performance.timing.domLoading - performance.timeOrigin : null;
}
function B(e) {
  return e == null ? Y : typeof e == "number" ? Math.round(e > 0 ? e : 0).toString() : e.toString();
}
function Ed(e) {
  let t;
  const n = new Promise((i) => {
    t = i;
  });
  return new PerformanceObserver((i) => {
    var s;
    const [o] = i.getEntries();
    if (o == null || zn(o.name))
      return;
    const a = o.toJSON();
    let c = fa(a == null ? void 0 : a.serverTiming);
    const u = (s = Gn(ni, Ie.session)) !== null && s !== void 0 ? s : Y, f = Object.assign(Object.assign({}, bd(a)), { faroNavigationId: Ke(), faroPreviousNavigationId: u });
    yi(ni, f.faroNavigationId, Ie.session), e("faro.performance.navigation", f, void 0, {
      spanContext: c,
      timestampOverwriteMs: performance.timeOrigin + a.startTime
    }), t(f);
  }).observe({
    type: pd,
    buffered: !0
  }), n;
}
const Sd = { initiatorType: ["xmlhttprequest", "fetch"] };
function Td(e, t, n) {
  const r = U.config.trackResources;
  new PerformanceObserver((s) => {
    const o = s.getEntries();
    for (const a of o) {
      if (zn(a.name))
        continue;
      n == null || n.notify({
        type: ri
      });
      const c = a.toJSON();
      let u = fa(c == null ? void 0 : c.serverTiming);
      if (r == null && _d(c, Sd) || r) {
        const f = Object.assign(Object.assign({}, pa(c)), { faroNavigationId: e, faroResourceId: Ke() });
        t("faro.performance.resource", f, void 0, {
          spanContext: u,
          timestampOverwriteMs: performance.timeOrigin + c.startTime
        });
      }
    }
  }).observe({
    type: ri,
    buffered: !0
  });
}
var yd = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function a(f) {
      try {
        u(r.next(f));
      } catch (m) {
        o(m);
      }
    }
    function c(f) {
      try {
        u(r.throw(f));
      } catch (m) {
        o(m);
      }
    }
    function u(f) {
      f.done ? s(f.value) : i(f.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
};
const ha = new z();
class wd extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-performance", this.version = X;
  }
  initialize() {
    if (!md()) {
      this.logDebug("performance observer not supported. Disable performance instrumentation.");
      return;
    }
    gd(() => yd(this, void 0, void 0, function* () {
      const t = this.api.pushEvent, { faroNavigationId: n } = yield Ed(t);
      n != null && Td(n, t, ha);
    }));
  }
}
const Ad = "faroUserActionName", Od = "data-faro-user-action-name";
let an, Tr;
function ma() {
  return an || (an = new z()), Tr || (Tr = new MutationObserver((e, t) => {
    an.notify({ type: Nl });
  }), Tr.observe(document, {
    attributes: !0,
    childList: !0,
    subtree: !0,
    characterData: !0
  })), an;
}
const yr = "fetch", cn = "xhr";
let Je, ks = !1, wr, Ar;
function ga() {
  if (Je)
    return Je;
  Je = new z();
  function e(n) {
    Je.notify({
      type: Ri,
      request: n
    });
  }
  function t(n) {
    Je.notify({
      type: Pi,
      request: n
    });
  }
  return ks || (Pd({
    onRequestStart: e,
    onRequestEnd: t
  }), Rd({
    onRequestStart: e,
    onRequestEnd: t
  }), ks = !0), Je;
}
function Rd({ onRequestStart: e, onRequestEnd: t }) {
  wr || (wr = XMLHttpRequest.prototype.open), XMLHttpRequest.prototype.open = function() {
    const n = arguments[1], r = zn(n), i = arguments[0], s = Ke();
    this.addEventListener("loadstart", function() {
      r || e({ url: n, method: i, requestId: s, apiType: cn });
    }), this.addEventListener("load", function() {
      r || t({ url: n, method: i, requestId: s, apiType: cn });
    }), this.addEventListener("error", function() {
      r || t({ url: n, method: i, requestId: s, apiType: cn });
    }), this.addEventListener("abort", function() {
      r || t({ url: n, method: i, requestId: s, apiType: cn });
    }), wr.apply(this, arguments);
  };
}
function Pd({ onRequestEnd: e, onRequestStart: t }) {
  Ar || (Ar = window.fetch), window.fetch = function() {
    var n, r;
    const i = (n = Yo(arguments[0])) !== null && n !== void 0 ? n : "", s = zn(i), o = ((r = arguments[1]) !== null && r !== void 0 ? r : {}).method, a = Ke();
    return s || t({ url: i, method: o, requestId: a, apiType: yr }), Ar.apply(this, arguments).then((c) => (s || e({ url: i, method: o, requestId: a, apiType: yr }), c)).catch((c) => {
      throw s || e({ url: i, method: o, requestId: a, apiType: yr }), c;
    });
  };
}
let un, Ds = !1;
function Id() {
  return un || (un = new z()), Ds || (ha.subscribe((e) => {
    e.type === ri && un.notify({ type: Cl });
  }), Ds = !0), un;
}
function Cd(e) {
  const t = e.split("data-")[1], n = t == null ? void 0 : t.replace(/-(.)/g, (r, i) => i.toUpperCase());
  return n == null ? void 0 : n.replace(/-/g, "");
}
function Nd(e, t, n) {
  return e && clearTimeout(e), e = setTimeout(() => {
    t();
  }, n), e;
}
function xd(e) {
  return e.type === Ri;
}
function Or(e) {
  return e.type === Pi;
}
const Ld = 100, Md = 10 * 1e3;
class kd {
  constructor(t) {
    this.userAction = t, this.http = ga(), this.dom = ma(), this.perf = Id(), this.isValid = !1, this.runningRequests = /* @__PURE__ */ new Map();
  }
  attach() {
    this.allMonitorsSub = new z().merge(this.http, this.dom, this.perf).takeWhile(() => [k.Started, k.Halted].includes(this.userAction.getState())).filter((t) => !(this.userAction.getState() === k.Halted && !(Or(t) && this.runningRequests.has(t.request.requestId)))).subscribe((t) => {
      xd(t) && this.runningRequests.set(t.request.requestId, t.request), Or(t) && this.runningRequests.delete(t.request.requestId), Or(t) ? this.userAction.getState() === k.Halted && this.runningRequests.size === 0 && this.endAction() : (this.isValid || (this.isValid = !0), this.scheduleFollowUp());
    }), this.stateSub = this.userAction.filter((t) => [k.Ended, k.Cancelled].includes(t)).first().subscribe(() => this.cleanup()), this.scheduleFollowUp();
  }
  scheduleFollowUp() {
    this.clearTimer(this.followUpTid), this.followUpTid = setTimeout(() => {
      if (this.userAction.getState() === k.Started && this.runningRequests.size > 0) {
        this.haltAction();
        return;
      }
      if (this.isValid) {
        this.endAction();
        return;
      }
      this.cancelAction();
    }, Ld);
  }
  haltAction() {
    this.userAction.getState() === k.Started && (this.userAction.halt(), this.startHaltTimeout());
  }
  startHaltTimeout() {
    this.clearTimer(this.haltTid), this.haltTid = Nd(this.haltTid, () => {
      this.userAction.getState() === k.Halted && this.endAction();
    }, Md);
  }
  endAction() {
    this.userAction.end(), this.cleanup();
  }
  cancelAction() {
    this.userAction.cancel(), this.cleanup();
  }
  cleanup() {
    var t, n;
    this.clearTimer(this.followUpTid), this.clearTimer(this.haltTid), (t = this.allMonitorsSub) === null || t === void 0 || t.unsubscribe(), (n = this.stateSub) === null || n === void 0 || n.unsubscribe(), this.allMonitorsSub = void 0, this.stateSub = void 0, this.runningRequests.clear();
  }
  clearTimer(t) {
    t && clearTimeout(t);
  }
}
function Dd(e) {
  const { api: t, config: n } = e;
  function r(s) {
    var o, a;
    const c = Ud(s.target, (a = (o = n.userActionsInstrumentation) === null || o === void 0 ? void 0 : o.dataAttributeName) !== null && a !== void 0 ? a : Ad);
    if (!c)
      return;
    const u = t.startUserAction(c, {}, { triggerName: s.type });
    u && i(u);
  }
  function i(s) {
    const o = s;
    new kd(o).attach();
  }
  return { processUserEvent: r, processUserActionStarted: i };
}
function Ud(e, t) {
  const n = Cd(t), r = e.dataset;
  for (const i in r)
    if (i === n)
      return r[i];
}
class $d extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-user-action", this.version = X;
  }
  initialize() {
    const { processUserEvent: t, processUserActionStarted: n } = Dd(U);
    window.addEventListener("pointerdown", t), window.addEventListener("keydown", (r) => {
      [" ", "Enter"].includes(r.key) && t(r);
    }), this._userActionSub = Vo.subscribe(({ type: r, userAction: i }) => {
      r === "user_action_start" && n(i);
    });
  }
  destroy() {
    var t;
    (t = this._userActionSub) === null || t === void 0 || t.unsubscribe();
  }
}
class jd extends ve {
  constructor() {
    super(), this.name = "@grafana/faro-web-sdk:instrumentation-csp", this.version = X;
  }
  initialize() {
    document.addEventListener("securitypolicyviolation", this.securitypolicyviolationHandler.bind(this));
  }
  destroy() {
    document.removeEventListener("securitypolicyviolation", this.securitypolicyviolationHandler);
  }
  securitypolicyviolationHandler(t) {
    const n = {
      blockedURI: t.blockedURI,
      columnNumber: t.columnNumber,
      disposition: t.disposition,
      documentURI: t.documentURI,
      effectiveDirective: t.effectiveDirective,
      lineNumber: t.lineNumber,
      originalPolicy: t.originalPolicy,
      referrer: t.referrer,
      sample: t.sample,
      sourceFile: t.sourceFile,
      statusCode: t.statusCode,
      violatedDirective: t.violatedDirective
    };
    this.api.pushEvent("securitypolicyviolation", gt(n));
  }
}
function Bd(e) {
  return e.type === Ri;
}
function Fd(e) {
  return e.type === Pi;
}
class Vd extends z {
  constructor(t, n) {
    var r, i, s, o;
    super(), this._tracking = !1, this.eventsObservable = t, this._options = {
      inactivityMs: (r = n == null ? void 0 : n.inactivityMs) !== null && r !== void 0 ? r : 100,
      drainTimeoutMs: (i = n == null ? void 0 : n.drainTimeoutMs) !== null && i !== void 0 ? i : 10 * 1e3,
      isOperationStart: (s = n == null ? void 0 : n.isOperationStart) !== null && s !== void 0 ? s : () => {
      },
      isOperationEnd: (o = n == null ? void 0 : n.isOperationEnd) !== null && o !== void 0 ? o : () => {
      }
    }, this._initialize();
  }
  _initialize() {
    this.eventsObservable.filter(() => this._tracking).subscribe((t) => {
      var n, r, i;
      this._lastEventTime = Date.now(), (n = this._currentEvents) === null || n === void 0 || n.push(t);
      const s = this._options.isOperationStart(t);
      s && ((r = this._activeOperations) === null || r === void 0 || r.set(s, !0));
      const o = this._options.isOperationEnd(t);
      o && ((i = this._activeOperations) === null || i === void 0 || i.delete(o)), this._scheduleInactivityCheck();
    });
  }
  startTracking() {
    this._tracking || (this._tracking = !0, this._startTime = Date.now(), this._lastEventTime = Date.now(), this.notify({
      message: "tracking-started"
    }), this._currentEvents = [], this._activeOperations = /* @__PURE__ */ new Map(), this._scheduleInactivityCheck());
  }
  stopTracking() {
    this._tracking = !1, this._clearTimer(this._inactivityTid), this._clearTimer(this._drainTid);
    let t;
    this.hasActiveOperations() ? t = Date.now() - this._startTime : t = this._lastEventTime ? this._lastEventTime - this._startTime : 0, this.notify({
      message: "tracking-ended",
      events: this._currentEvents,
      duration: t
    });
  }
  _scheduleInactivityCheck() {
    this._inactivityTid = Us(this._inactivityTid, () => {
      this.hasActiveOperations() ? this._startDrainTimeout() : this.stopTracking();
    }, this._options.inactivityMs);
  }
  _startDrainTimeout() {
    this._drainTid = Us(this._drainTid, () => {
      this.stopTracking();
    }, this._options.drainTimeoutMs);
  }
  hasActiveOperations() {
    return !!this._activeOperations && this._activeOperations.size > 0;
  }
  _clearTimer(t) {
    t && clearTimeout(t);
  }
}
function Us(e, t, n) {
  return e && clearTimeout(e), e = setTimeout(() => {
    t();
  }, n), e;
}
const Hd = "interaction";
let ln;
const $s = /* @__PURE__ */ new Set(), Gd = /* @__PURE__ */ new Map();
function zd(e) {
  return ln || (ln = new z()), e.forEach((t) => {
    if (!$s.has(t)) {
      const n = () => {
        ln.notify({ type: Hd, name: t });
      };
      window.addEventListener(t, n), $s.add(t), Gd.set(t, n);
    }
  }), ln;
}
const qd = "url-change";
let dn, Rr = !1, fn, Pr, Ir, js, Bs, Fs, Cr;
function Kd() {
  dn || (dn = new z(), fn = location.href);
  function e(t, n) {
    const r = n != null ? n : location.href;
    r !== fn && (dn.notify({ type: qd, from: fn, to: r, trigger: t }), fn = r);
  }
  if (!Rr)
    if ("navigation" in window && "NavigateEvent" in window) {
      Fs = (r) => {
        try {
          const i = r == null ? void 0 : r.destination;
          i != null && i.sameDocument && typeof i.url == "string" && e("navigate", i.url);
        } catch (i) {
        }
      }, window.navigation.addEventListener("navigate", Fs);
      const n = window.NavigateEvent;
      n && n.prototype && typeof n.prototype.intercept == "function" && (Cr || (Cr = n.prototype.intercept), n.prototype.intercept = function(r) {
        try {
          const i = !!(!(this === null || this === void 0) && this.canIntercept), s = this === null || this === void 0 ? void 0 : this.destination;
          i && s && s.sameDocument === !1 && typeof s.url == "string" && e("navigate-intercept", s.url);
        } catch (i) {
        }
        return Cr.call(this, r);
      }), Rr = !0;
    } else
      Pr || (Pr = window.history.pushState), window.history.pushState = function(...n) {
        const r = Pr.apply(window.history, n);
        return e("pushState"), r;
      }, Ir || (Ir = window.history.replaceState), window.history.replaceState = function(...n) {
        const r = Ir.apply(window.history, n);
        return e("replaceState"), r;
      }, js = () => e("popstate"), Bs = () => e("hashchange"), window.addEventListener("popstate", js), window.addEventListener("hashchange", Bs), Rr = !0;
  return dn;
}
class Wd extends ve {
  constructor() {
    super(...arguments), this.name = "@grafana/faro-web-sdk:instrumentation-navigation", this.version = X;
  }
  initialize() {
    const t = ga(), n = ma(), r = Kd(), i = zd(["pointerdown", "keydown"]), s = new Vd(new z().merge(t, n, r), {
      inactivityMs: 100,
      drainTimeoutMs: 10 * 1e3,
      isOperationStart: (o) => Bd(o) ? o.request.requestId : void 0,
      isOperationEnd: (o) => Fd(o) ? o.request.requestId : void 0
    });
    s.filter((o) => o.message === "tracking-ended").subscribe((o) => {
      var a, c, u;
      if (!((a = o.events) === null || a === void 0) && a.some((f) => f.type === "url-change") && (!((c = o.events) === null || c === void 0) && c.some((f) => f.type === "dom-mutation"))) {
        const f = (u = o.events) === null || u === void 0 ? void 0 : u.find((m) => m.type === "url-change");
        U.api.pushEvent("faro.navigation", {
          fromUrl: f == null ? void 0 : f.from,
          toUrl: f == null ? void 0 : f.to,
          sameDocument: String(!0),
          duration: o.duration
        });
      }
    }), i.subscribe(() => {
      s.startTracking();
    });
  }
}
function _a(e = {}) {
  const t = [
    new $d(),
    new td(),
    new fd(),
    new Il(),
    new nd(),
    new Wd()
  ];
  return e.enablePerformanceInstrumentation !== !1 && t.unshift(new wd()), e.enableContentSecurityPolicyInstrumentation !== !1 && t.push(new jd()), e.captureConsole !== !1 && t.push(new Ue()), t;
}
const Xd = "browser", Yd = () => {
  const e = window.k6;
  return {
    k6: Object.assign({
      // we only add the k6 meta if Faro is running inside a k6 environment, so this is always true
      isK6Browser: !0
    }, (e == null ? void 0 : e.testRunId) && { testRunId: e == null ? void 0 : e.testRunId })
  };
};
let Vs, Nr;
function Qd({ generatePageId: e, initialPageMeta: t } = {}) {
  return () => {
    const r = location.href;
    return zt(e) && Vs !== r && (Vs = r, Nr = e(location)), {
      page: Object.assign(Object.assign({ url: r }, Nr ? { id: Nr } : {}), t)
    };
  };
}
var xr = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function a(f) {
      try {
        u(r.next(f));
      } catch (m) {
        o(m);
      }
    }
    function c(f) {
      try {
        u(r.throw(f));
      } catch (m) {
        o(m);
      }
    }
    function u(f) {
      f.done ? s(f.value) : i(f.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Jd = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Zd = 30, ef = 5, tf = 5e3, nf = 6e4, rf = 429, sf = 202;
class of extends $u {
  constructor(t) {
    var n, r, i, s;
    super(), this.options = t, this.name = "@grafana/faro-web-sdk:transport-fetch", this.version = X, this.disabledUntil = /* @__PURE__ */ new Date(), this.rateLimitBackoffMs = (n = t.defaultRateLimitBackoffMs) !== null && n !== void 0 ? n : tf, this.getNow = (r = t.getNow) !== null && r !== void 0 ? r : () => Date.now(), this.promiseBuffer = xu({
      size: (i = t.bufferSize) !== null && i !== void 0 ? i : Zd,
      concurrency: (s = t.concurrency) !== null && s !== void 0 ? s : ef
    });
  }
  send(t) {
    return xr(this, void 0, void 0, function* () {
      try {
        if (this.disabledUntil > new Date(this.getNow()))
          return this.logWarn(`Dropping transport item due to too many requests. Backoff until ${this.disabledUntil}`), Promise.resolve();
        yield this.promiseBuffer.add(() => xr(this, void 0, void 0, function* () {
          const n = JSON.stringify(Fu(t)), { url: r, requestOptions: i, apiKey: s } = this.options, o = i != null ? i : {}, { headers: a = {} } = o, c = Jd(o, ["headers"]);
          let u;
          const f = this.metas.value.session;
          f != null && (u = f.id);
          const m = {};
          for (const [l, d] of Object.entries(a))
            m[l] = typeof d == "function" ? yield Promise.resolve(d()) : d;
          return fetch(r, Object.assign({ method: "POST", headers: Object.assign(Object.assign(Object.assign({ "Content-Type": "application/json" }, m), s ? { "x-api-key": s } : {}), u ? { "x-faro-session-id": u } : {}), body: n, keepalive: n.length <= nf }, c != null ? c : {})).then((l) => xr(this, void 0, void 0, function* () {
            return l.status === sf && l.headers.get("X-Faro-Session-Status") === "invalid" && this.extendFaroSession(this.config, this.logDebug), l.status === rf && (this.disabledUntil = this.getRetryAfterDate(l), this.logWarn(`Too many requests, backing off until ${this.disabledUntil}`)), l.text().catch(Ae), l;
          })).catch((l) => {
            this.logError(`Failed sending payload to the receiver
`, JSON.parse(n), l);
          });
        }));
      } catch (n) {
        this.logError(n);
      }
    });
  }
  getIgnoreUrls() {
    var t;
    return [this.options.url].concat((t = this.config.ignoreUrls) !== null && t !== void 0 ? t : []);
  }
  isBatched() {
    return !0;
  }
  getRetryAfterDate(t) {
    const n = this.getNow(), r = t.headers.get("Retry-After");
    if (r) {
      const i = Number(r);
      if (!isNaN(i))
        return new Date(i * 1e3 + n);
      const s = Date.parse(r);
      if (!isNaN(s))
        return new Date(s);
    }
    return new Date(n + this.rateLimitBackoffMs);
  }
  extendFaroSession(t, n) {
    const r = "Session expired", i = t.sessionTracking;
    if (i != null && i.enabled) {
      const { fetchUserSession: s, storeUserSession: o } = na(i);
      Oi({ fetchUserSession: s, storeUserSession: o })({ forceSessionExtend: !0 }), n(`${r} created new session.`);
    } else
      n(`${r}.`);
  }
}
var af = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function cf(e) {
  var t, n, r, i, s;
  const o = [], a = jo(e.unpatchedConsole, e.internalLoggerLevel);
  e.transports ? ((e.url || e.apiKey) && a.error('if "transports" is defined, "url" and "apiKey" should not be defined'), o.push(...e.transports)) : e.url ? o.push(new of({
    url: e.url,
    apiKey: e.apiKey
  })) : a.error('either "url" or "transports" must be defined');
  const {
    // properties with default values
    dedupe: c = !0,
    eventDomain: u = Xd,
    globalObjectKey: f = hl,
    instrumentations: m = _a(),
    internalLoggerLevel: l = $o,
    isolate: d = !1,
    logArgsSerializer: p = Tn,
    metas: h = lf(e),
    paused: g = !1,
    preventGlobalExposure: S = !1,
    unpatchedConsole: y = Kt,
    url: v,
    experimental: b
  } = e, w = af(e, ["dedupe", "eventDomain", "globalObjectKey", "instrumentations", "internalLoggerLevel", "isolate", "logArgsSerializer", "metas", "paused", "preventGlobalExposure", "unpatchedConsole", "url", "experimental"]), E = (t = b == null ? void 0 : b.trackNavigation) !== null && t !== void 0 ? t : !1, T = {
    dataAttributeName: (r = (n = e.userActionsInstrumentation) === null || n === void 0 ? void 0 : n.dataAttributeName) !== null && r !== void 0 ? r : Od,
    excludeItem: (i = e.userActionsInstrumentation) === null || i === void 0 ? void 0 : i.excludeItem
  };
  return Object.assign(Object.assign({}, w), {
    batching: Object.assign(Object.assign({}, ml), e.batching),
    dedupe: c,
    globalObjectKey: f,
    instrumentations: uf(m, e),
    internalLoggerLevel: l,
    isolate: d,
    logArgsSerializer: p,
    metas: h,
    parseStacktrace: Jl,
    paused: g,
    preventGlobalExposure: S,
    transports: o,
    unpatchedConsole: y,
    eventDomain: u,
    ignoreUrls: [
      ...(s = e.ignoreUrls) !== null && s !== void 0 ? s : [],
      // ignore configured cloud collector url by default
      ...v ? [v] : [],
      // Try our best to exclude collector URLs form other Faro instances. By default these are URLs ending with /collect or /collect/ followed by alphanumeric characters.
      /\/collect(?:\/[\w]*)?$/
    ],
    sessionTracking: Object.assign(Object.assign(Object.assign({}, Ol), e.sessionTracking), df({
      trackGeolocation: e.trackGeolocation,
      sessionTracking: e.sessionTracking
    })),
    userActionsInstrumentation: T,
    experimental: {
      trackNavigation: E
    }
  });
}
function uf(e, { experimental: t }) {
  var n;
  const r = (n = t == null ? void 0 : t.trackNavigation) !== null && n !== void 0 ? n : !1;
  return e.filter((i) => !(i.name === "@grafana/faro-web-sdk:instrumentation-navigation" && !r));
}
function lf(e) {
  var t, n;
  const { page: r, generatePageId: i } = (t = e == null ? void 0 : e.pageTracking) !== null && t !== void 0 ? t : {}, s = [
    El,
    Qd({ generatePageId: i, initialPageMeta: r }),
    ...(n = e.metas) !== null && n !== void 0 ? n : [],
    Tl
  ];
  return me(window == null ? void 0 : window.k6) ? [...s, Yd] : s;
}
function df({ trackGeolocation: e, sessionTracking: t }) {
  var n;
  const r = {};
  return Tu(e) && (r.geoLocationTrackingEnabled = e), je(r) ? {} : {
    session: Object.assign(Object.assign({}, (n = t == null ? void 0 : t.session) !== null && n !== void 0 ? n : {}), { overrides: r })
  };
}
function ff(e) {
  const t = cf(e);
  if (t)
    return pl(t);
}
const pf = pu.version;
hf();
function hf() {
  const e = pf.split(".");
  try {
    return e[0] ? parseInt(e[0], 10) : null;
  } catch (t) {
    return null;
  }
}
var ba = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G = typeof Symbol == "function" && Symbol.for, xi = G ? Symbol.for("react.element") : 60103, Li = G ? Symbol.for("react.portal") : 60106, Wn = G ? Symbol.for("react.fragment") : 60107, Xn = G ? Symbol.for("react.strict_mode") : 60108, Yn = G ? Symbol.for("react.profiler") : 60114, Qn = G ? Symbol.for("react.provider") : 60109, Jn = G ? Symbol.for("react.context") : 60110, Mi = G ? Symbol.for("react.async_mode") : 60111, Zn = G ? Symbol.for("react.concurrent_mode") : 60111, er = G ? Symbol.for("react.forward_ref") : 60112, tr = G ? Symbol.for("react.suspense") : 60113, mf = G ? Symbol.for("react.suspense_list") : 60120, nr = G ? Symbol.for("react.memo") : 60115, rr = G ? Symbol.for("react.lazy") : 60116, gf = G ? Symbol.for("react.block") : 60121, _f = G ? Symbol.for("react.fundamental") : 60117, bf = G ? Symbol.for("react.responder") : 60118, vf = G ? Symbol.for("react.scope") : 60119;
function ee(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case xi:
        switch (e = e.type, e) {
          case Mi:
          case Zn:
          case Wn:
          case Yn:
          case Xn:
          case tr:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Jn:
              case er:
              case rr:
              case nr:
              case Qn:
                return e;
              default:
                return t;
            }
        }
      case Li:
        return t;
    }
  }
}
function va(e) {
  return ee(e) === Zn;
}
L.AsyncMode = Mi;
L.ConcurrentMode = Zn;
L.ContextConsumer = Jn;
L.ContextProvider = Qn;
L.Element = xi;
L.ForwardRef = er;
L.Fragment = Wn;
L.Lazy = rr;
L.Memo = nr;
L.Portal = Li;
L.Profiler = Yn;
L.StrictMode = Xn;
L.Suspense = tr;
L.isAsyncMode = function(e) {
  return va(e) || ee(e) === Mi;
};
L.isConcurrentMode = va;
L.isContextConsumer = function(e) {
  return ee(e) === Jn;
};
L.isContextProvider = function(e) {
  return ee(e) === Qn;
};
L.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === xi;
};
L.isForwardRef = function(e) {
  return ee(e) === er;
};
L.isFragment = function(e) {
  return ee(e) === Wn;
};
L.isLazy = function(e) {
  return ee(e) === rr;
};
L.isMemo = function(e) {
  return ee(e) === nr;
};
L.isPortal = function(e) {
  return ee(e) === Li;
};
L.isProfiler = function(e) {
  return ee(e) === Yn;
};
L.isStrictMode = function(e) {
  return ee(e) === Xn;
};
L.isSuspense = function(e) {
  return ee(e) === tr;
};
L.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Wn || e === Zn || e === Yn || e === Xn || e === tr || e === mf || typeof e == "object" && e !== null && (e.$$typeof === rr || e.$$typeof === nr || e.$$typeof === Qn || e.$$typeof === Jn || e.$$typeof === er || e.$$typeof === _f || e.$$typeof === bf || e.$$typeof === vf || e.$$typeof === gf);
};
L.typeOf = ee;
ba.exports = L;
var Ef = ba.exports, Ea = Ef, Sf = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Tf = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Sa = {};
Sa[Ea.ForwardRef] = Sf;
Sa[Ea.Memo] = Tf;
var Hs;
(function(e) {
  e.V4 = "v4", e.V5 = "v5", e.V6 = "v6", e.V6_data_router = "v6_data_router", e.V7 = "v7", e.V7_data_router = "v7_data_router";
})(Hs || (Hs = {}));
var Gs;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Gs || (Gs = {}));
const He = "1.9.1", zs = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function yf(e) {
  const t = /* @__PURE__ */ new Set([e]), n = /* @__PURE__ */ new Set(), r = e.match(zs);
  if (!r)
    return () => !1;
  const i = {
    major: +r[1],
    minor: +r[2],
    patch: +r[3],
    prerelease: r[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function s(a) {
    return n.add(a), !1;
  }
  function o(a) {
    return t.add(a), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (n.has(c))
      return !1;
    const u = c.match(zs);
    if (!u)
      return s(c);
    const f = {
      major: +u[1],
      minor: +u[2],
      patch: +u[3],
      prerelease: u[4]
    };
    return f.prerelease != null || i.major !== f.major ? s(c) : i.major === 0 ? i.minor === f.minor && i.patch <= f.patch ? o(c) : s(c) : i.minor <= f.minor ? o(c) : s(c);
  };
}
const wf = yf(He), Af = He.split(".")[0], $t = Symbol.for(`opentelemetry.js.api.${Af}`), jt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Xt(e, t, n, r = !1) {
  var i;
  const s = jt[$t] = (i = jt[$t]) !== null && i !== void 0 ? i : {
    version: He
  };
  if (!r && s[e]) {
    const o = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${e}`);
    return n.error(o.stack || o.message), !1;
  }
  if (s.version !== He) {
    const o = new Error(`@opentelemetry/api: Registration of version v${s.version} for ${e} does not match previously registered API v${He}`);
    return n.error(o.stack || o.message), !1;
  }
  return s[e] = t, n.debug(`@opentelemetry/api: Registered a global for ${e} v${He}.`), !0;
}
function ze(e) {
  var t, n;
  const r = (t = jt[$t]) === null || t === void 0 ? void 0 : t.version;
  if (!(!r || !wf(r)))
    return (n = jt[$t]) === null || n === void 0 ? void 0 : n[e];
}
function Yt(e, t) {
  t.debug(`@opentelemetry/api: Unregistering a global for ${e} v${He}.`);
  const n = jt[$t];
  n && delete n[e];
}
class Of {
  constructor(t) {
    this._namespace = t.namespace || "DiagComponentLogger";
  }
  debug(...t) {
    return Ct("debug", this._namespace, t);
  }
  error(...t) {
    return Ct("error", this._namespace, t);
  }
  info(...t) {
    return Ct("info", this._namespace, t);
  }
  warn(...t) {
    return Ct("warn", this._namespace, t);
  }
  verbose(...t) {
    return Ct("verbose", this._namespace, t);
  }
}
function Ct(e, t, n) {
  const r = ze("diag");
  if (r)
    return r[e](t, ...n);
}
var F;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(F || (F = {}));
function Rf(e, t) {
  e < F.NONE ? e = F.NONE : e > F.ALL && (e = F.ALL), t = t || {};
  function n(r, i) {
    const s = t[r];
    return typeof s == "function" && e >= i ? s.bind(t) : function() {
    };
  }
  return {
    error: n("error", F.ERROR),
    warn: n("warn", F.WARN),
    info: n("info", F.INFO),
    debug: n("debug", F.DEBUG),
    verbose: n("verbose", F.VERBOSE)
  };
}
const Pf = "diag";
class ie {
  /** Get the singleton instance of the DiagAPI API */
  static instance() {
    return this._instance || (this._instance = new ie()), this._instance;
  }
  /**
   * Private internal constructor
   * @private
   */
  constructor() {
    function t(i) {
      return function(...s) {
        const o = ze("diag");
        if (o)
          return o[i](...s);
      };
    }
    const n = this, r = (i, s = { logLevel: F.INFO }) => {
      var o, a, c;
      if (i === n) {
        const m = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
        return n.error((o = m.stack) !== null && o !== void 0 ? o : m.message), !1;
      }
      typeof s == "number" && (s = {
        logLevel: s
      });
      const u = ze("diag"), f = Rf((a = s.logLevel) !== null && a !== void 0 ? a : F.INFO, i);
      if (u && !s.suppressOverrideMessage) {
        const m = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
        u.warn(`Current logger will be overwritten from ${m}`), f.warn(`Current logger will overwrite one already registered from ${m}`);
      }
      return Xt("diag", f, n, !0);
    };
    n.setLogger = r, n.disable = () => {
      Yt(Pf, n);
    }, n.createComponentLogger = (i) => new Of(i), n.verbose = t("verbose"), n.debug = t("debug"), n.info = t("info"), n.warn = t("warn"), n.error = t("error");
  }
}
class tt {
  constructor(t) {
    this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
  }
  getEntry(t) {
    const n = this._entries.get(t);
    if (n)
      return Object.assign({}, n);
  }
  getAllEntries() {
    return Array.from(this._entries.entries());
  }
  setEntry(t, n) {
    const r = new tt(this._entries);
    return r._entries.set(t, n), r;
  }
  removeEntry(t) {
    const n = new tt(this._entries);
    return n._entries.delete(t), n;
  }
  removeEntries(...t) {
    const n = new tt(this._entries);
    for (const r of t)
      n._entries.delete(r);
    return n;
  }
  clear() {
    return new tt();
  }
}
const If = Symbol("BaggageEntryMetadata"), Cf = ie.instance();
function Nf(e = {}) {
  return new tt(new Map(Object.entries(e)));
}
function Ta(e) {
  return typeof e != "string" && (Cf.error(`Cannot create baggage metadata from unknown type: ${typeof e}`), e = ""), {
    __TYPE__: If,
    toString() {
      return e;
    }
  };
}
function Qt(e) {
  return Symbol.for(e);
}
class An {
  /**
   * Construct a new context which inherits values from an optional parent context.
   *
   * @param parentContext a context from which to inherit values
   */
  constructor(t) {
    const n = this;
    n._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), n.getValue = (r) => n._currentContext.get(r), n.setValue = (r, i) => {
      const s = new An(n._currentContext);
      return s._currentContext.set(r, i), s;
    }, n.deleteValue = (r) => {
      const i = new An(n._currentContext);
      return i._currentContext.delete(r), i;
    };
  }
}
const Ze = new An();
class xf {
  constructor() {
  }
  /**
   * @see {@link Meter.createGauge}
   */
  createGauge(t, n) {
    return Ff;
  }
  /**
   * @see {@link Meter.createHistogram}
   */
  createHistogram(t, n) {
    return Vf;
  }
  /**
   * @see {@link Meter.createCounter}
   */
  createCounter(t, n) {
    return Bf;
  }
  /**
   * @see {@link Meter.createUpDownCounter}
   */
  createUpDownCounter(t, n) {
    return Hf;
  }
  /**
   * @see {@link Meter.createObservableGauge}
   */
  createObservableGauge(t, n) {
    return zf;
  }
  /**
   * @see {@link Meter.createObservableCounter}
   */
  createObservableCounter(t, n) {
    return Gf;
  }
  /**
   * @see {@link Meter.createObservableUpDownCounter}
   */
  createObservableUpDownCounter(t, n) {
    return qf;
  }
  /**
   * @see {@link Meter.addBatchObservableCallback}
   */
  addBatchObservableCallback(t, n) {
  }
  /**
   * @see {@link Meter.removeBatchObservableCallback}
   */
  removeBatchObservableCallback(t) {
  }
}
class ir {
}
class Lf extends ir {
  add(t, n) {
  }
}
class Mf extends ir {
  add(t, n) {
  }
}
class kf extends ir {
  record(t, n) {
  }
}
class Df extends ir {
  record(t, n) {
  }
}
class ki {
  addCallback(t) {
  }
  removeCallback(t) {
  }
}
class Uf extends ki {
}
class $f extends ki {
}
class jf extends ki {
}
const ya = new xf(), Bf = new Lf(), Ff = new kf(), Vf = new Df(), Hf = new Mf(), Gf = new Uf(), zf = new $f(), qf = new jf();
function Kf() {
  return ya;
}
const Wf = {
  get(e, t) {
    if (e != null)
      return e[t];
  },
  keys(e) {
    return e == null ? [] : Object.keys(e);
  }
}, Xf = {
  set(e, t, n) {
    e != null && (e[t] = n);
  }
};
class Yf {
  active() {
    return Ze;
  }
  with(t, n, r, ...i) {
    return n.call(r, ...i);
  }
  bind(t, n) {
    return n;
  }
  enable() {
    return this;
  }
  disable() {
    return this;
  }
}
const Lr = "context", Qf = new Yf();
class vt {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
  }
  /** Get the singleton instance of the Context API */
  static getInstance() {
    return this._instance || (this._instance = new vt()), this._instance;
  }
  /**
   * Set the current context manager.
   *
   * @returns true if the context manager was successfully registered, else false
   */
  setGlobalContextManager(t) {
    return Xt(Lr, t, ie.instance());
  }
  /**
   * Get the currently active context
   */
  active() {
    return this._getContextManager().active();
  }
  /**
   * Execute a function with an active context
   *
   * @param context context to be active during function execution
   * @param fn function to execute in a context
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */
  with(t, n, r, ...i) {
    return this._getContextManager().with(t, n, r, ...i);
  }
  /**
   * Bind a context to a target function or event emitter
   *
   * @param context context to bind to the event emitter or function. Defaults to the currently active context
   * @param target function or event emitter to bind
   */
  bind(t, n) {
    return this._getContextManager().bind(t, n);
  }
  _getContextManager() {
    return ze(Lr) || Qf;
  }
  /** Disable and remove the global context manager */
  disable() {
    this._getContextManager().disable(), Yt(Lr, ie.instance());
  }
}
var be;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(be || (be = {}));
const wa = "0000000000000000", Aa = "00000000000000000000000000000000", Oa = {
  traceId: Aa,
  spanId: wa,
  traceFlags: be.NONE
};
class Dt {
  constructor(t = Oa) {
    this._spanContext = t;
  }
  // Returns a SpanContext.
  spanContext() {
    return this._spanContext;
  }
  // By default does nothing
  setAttribute(t, n) {
    return this;
  }
  // By default does nothing
  setAttributes(t) {
    return this;
  }
  // By default does nothing
  addEvent(t, n) {
    return this;
  }
  addLink(t) {
    return this;
  }
  addLinks(t) {
    return this;
  }
  // By default does nothing
  setStatus(t) {
    return this;
  }
  // By default does nothing
  updateName(t) {
    return this;
  }
  // By default does nothing
  end(t) {
  }
  // isRecording always returns false for NonRecordingSpan.
  isRecording() {
    return !1;
  }
  // By default does nothing
  recordException(t, n) {
  }
}
const Di = Qt("OpenTelemetry Context Key SPAN");
function Ui(e) {
  return e.getValue(Di) || void 0;
}
function Jf() {
  return Ui(vt.getInstance().active());
}
function $i(e, t) {
  return e.setValue(Di, t);
}
function Zf(e) {
  return e.deleteValue(Di);
}
function ep(e, t) {
  return $i(e, new Dt(t));
}
function Ra(e) {
  var t;
  return (t = Ui(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
const pn = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1
]);
function Pa(e, t) {
  if (typeof e != "string" || e.length !== t)
    return !1;
  let n = 0;
  for (let r = 0; r < e.length; r += 4)
    n += (pn[e.charCodeAt(r)] | 0) + (pn[e.charCodeAt(r + 1)] | 0) + (pn[e.charCodeAt(r + 2)] | 0) + (pn[e.charCodeAt(r + 3)] | 0);
  return n === t;
}
function Ia(e) {
  return Pa(e, 32) && e !== Aa;
}
function tp(e) {
  return Pa(e, 16) && e !== wa;
}
function Jt(e) {
  return Ia(e.traceId) && tp(e.spanId);
}
function np(e) {
  return new Dt(e);
}
const Mr = vt.getInstance();
class Ca {
  // startSpan starts a noop span.
  startSpan(t, n, r = Mr.active()) {
    if (!!(n != null && n.root))
      return new Dt();
    const s = r && Ra(r);
    return rp(s) && Jt(s) ? new Dt(s) : new Dt();
  }
  startActiveSpan(t, n, r, i) {
    let s, o, a;
    if (arguments.length < 2)
      return;
    arguments.length === 2 ? a = n : arguments.length === 3 ? (s = n, a = r) : (s = n, o = r, a = i);
    const c = o != null ? o : Mr.active(), u = this.startSpan(t, s, c), f = $i(c, u);
    return Mr.with(f, a, void 0, u);
  }
}
function rp(e) {
  return e !== null && typeof e == "object" && "spanId" in e && typeof e.spanId == "string" && "traceId" in e && typeof e.traceId == "string" && "traceFlags" in e && typeof e.traceFlags == "number";
}
const ip = new Ca();
class sp {
  constructor(t, n, r, i) {
    this._provider = t, this.name = n, this.version = r, this.options = i;
  }
  startSpan(t, n, r) {
    return this._getTracer().startSpan(t, n, r);
  }
  startActiveSpan(t, n, r, i) {
    const s = this._getTracer();
    return Reflect.apply(s.startActiveSpan, s, arguments);
  }
  /**
   * Try to get a tracer from the proxy tracer provider.
   * If the proxy tracer provider has no delegate, return a noop tracer.
   */
  _getTracer() {
    if (this._delegate)
      return this._delegate;
    const t = this._provider.getDelegateTracer(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : ip;
  }
}
class op {
  getTracer(t, n, r) {
    return new Ca();
  }
}
const ap = new op();
class qs {
  /**
   * Get a {@link ProxyTracer}
   */
  getTracer(t, n, r) {
    var i;
    return (i = this.getDelegateTracer(t, n, r)) !== null && i !== void 0 ? i : new sp(this, t, n, r);
  }
  getDelegate() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : ap;
  }
  /**
   * Set the delegate tracer provider
   */
  setDelegate(t) {
    this._delegate = t;
  }
  getDelegateTracer(t, n, r) {
    var i;
    return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, n, r);
  }
}
var On;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(On || (On = {}));
var Bt;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(Bt || (Bt = {}));
var he;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(he || (he = {}));
const j = vt.getInstance(), R = ie.instance();
class cp {
  getMeter(t, n, r) {
    return ya;
  }
}
const up = new cp(), kr = "metrics";
class ji {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
  }
  /** Get the singleton instance of the Metrics API */
  static getInstance() {
    return this._instance || (this._instance = new ji()), this._instance;
  }
  /**
   * Set the current global meter provider.
   * Returns true if the meter provider was successfully registered, else false.
   */
  setGlobalMeterProvider(t) {
    return Xt(kr, t, ie.instance());
  }
  /**
   * Returns the global meter provider.
   */
  getMeterProvider() {
    return ze(kr) || up;
  }
  /**
   * Returns a meter from the global meter provider.
   */
  getMeter(t, n, r) {
    return this.getMeterProvider().getMeter(t, n, r);
  }
  /** Remove the global meter provider */
  disable() {
    Yt(kr, ie.instance());
  }
}
const Na = ji.getInstance();
class lp {
  /** Noop inject function does nothing */
  inject(t, n) {
  }
  /** Noop extract function does nothing and returns the input context */
  extract(t, n) {
    return t;
  }
  fields() {
    return [];
  }
}
const Bi = Qt("OpenTelemetry Baggage Key");
function xa(e) {
  return e.getValue(Bi) || void 0;
}
function dp() {
  return xa(vt.getInstance().active());
}
function fp(e, t) {
  return e.setValue(Bi, t);
}
function pp(e) {
  return e.deleteValue(Bi);
}
const Dr = "propagation", hp = new lp();
class Fi {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
    this.createBaggage = Nf, this.getBaggage = xa, this.getActiveBaggage = dp, this.setBaggage = fp, this.deleteBaggage = pp;
  }
  /** Get the singleton instance of the Propagator API */
  static getInstance() {
    return this._instance || (this._instance = new Fi()), this._instance;
  }
  /**
   * Set the current propagator.
   *
   * @returns true if the propagator was successfully registered, else false
   */
  setGlobalPropagator(t) {
    return Xt(Dr, t, ie.instance());
  }
  /**
   * Inject context into a carrier to be propagated inter-process
   *
   * @param context Context carrying tracing data to inject
   * @param carrier carrier to inject context into
   * @param setter Function used to set values on the carrier
   */
  inject(t, n, r = Xf) {
    return this._getGlobalPropagator().inject(t, n, r);
  }
  /**
   * Extract context from a carrier
   *
   * @param context Context which the newly created context will inherit from
   * @param carrier Carrier to extract context from
   * @param getter Function used to extract keys from a carrier
   */
  extract(t, n, r = Wf) {
    return this._getGlobalPropagator().extract(t, n, r);
  }
  /**
   * Return a list of all fields which may be used by the propagator.
   */
  fields() {
    return this._getGlobalPropagator().fields();
  }
  /** Remove the global propagator */
  disable() {
    Yt(Dr, ie.instance());
  }
  _getGlobalPropagator() {
    return ze(Dr) || hp;
  }
}
const Z = Fi.getInstance(), Ur = "trace";
class Vi {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
    this._proxyTracerProvider = new qs(), this.wrapSpanContext = np, this.isSpanContextValid = Jt, this.deleteSpan = Zf, this.getSpan = Ui, this.getActiveSpan = Jf, this.getSpanContext = Ra, this.setSpan = $i, this.setSpanContext = ep;
  }
  /** Get the singleton instance of the Trace API */
  static getInstance() {
    return this._instance || (this._instance = new Vi()), this._instance;
  }
  /**
   * Set the current global tracer.
   *
   * @returns true if the tracer provider was successfully registered, else false
   */
  setGlobalTracerProvider(t) {
    const n = Xt(Ur, this._proxyTracerProvider, ie.instance());
    return n && this._proxyTracerProvider.setDelegate(t), n;
  }
  /**
   * Returns the global tracer provider.
   */
  getTracerProvider() {
    return ze(Ur) || this._proxyTracerProvider;
  }
  /**
   * Returns a tracer from the global tracer provider.
   */
  getTracer(t, n) {
    return this.getTracerProvider().getTracer(t, n);
  }
  /** Remove the global tracer provider */
  disable() {
    Yt(Ur, ie.instance()), this._proxyTracerProvider = new qs();
  }
}
const V = Vi.getInstance(), La = Qt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function mp(e) {
  return e.setValue(La, !0);
}
function Hi(e) {
  return e.getValue(La) === !0;
}
const gp = "=", Ma = ";", ii = ",", $r = "baggage", _p = 180, bp = 4096, vp = 8192;
function Ep(e) {
  return e.reduce((t, n) => {
    const r = `${t}${t !== "" ? ii : ""}${n}`;
    return r.length > vp ? t : r;
  }, "");
}
function Sp(e) {
  return e.getAllEntries().map(([t, n]) => {
    let r = `${encodeURIComponent(t)}=${encodeURIComponent(n.value)}`;
    return n.metadata !== void 0 && (r += Ma + n.metadata.toString()), r;
  });
}
function Tp(e) {
  if (!e)
    return;
  const t = e.indexOf(Ma), n = t === -1 ? e : e.substring(0, t), r = n.indexOf(gp);
  if (r <= 0)
    return;
  const i = n.substring(0, r).trim(), s = n.substring(r + 1).trim();
  if (!i || !s)
    return;
  let o, a;
  try {
    o = decodeURIComponent(i), a = decodeURIComponent(s);
  } catch (u) {
    return;
  }
  let c;
  if (t !== -1 && t < e.length - 1) {
    const u = e.substring(t + 1);
    c = Ta(u);
  }
  return { key: o, value: a, metadata: c };
}
let yp = class {
  inject(t, n, r) {
    const i = Z.getBaggage(t);
    if (!i || Hi(t))
      return;
    const s = Sp(i).filter((a) => a.length <= bp).slice(0, _p), o = Ep(s);
    o.length > 0 && r.set(n, $r, o);
  }
  extract(t, n, r) {
    const i = r.get(n, $r), s = Array.isArray(i) ? i.join(ii) : i;
    if (!s)
      return t;
    const o = {};
    return s.length === 0 || (s.split(ii).forEach((c) => {
      const u = Tp(c);
      if (u) {
        const f = { value: u.value };
        u.metadata && (f.metadata = u.metadata), o[u.key] = f;
      }
    }), Object.entries(o).length === 0) ? t : Z.setBaggage(t, Z.createBaggage(o));
  }
  fields() {
    return [$r];
  }
};
function Ut(e) {
  const t = {};
  if (typeof e != "object" || e == null)
    return t;
  for (const n in e) {
    if (!Object.prototype.hasOwnProperty.call(e, n))
      continue;
    if (!wp(n)) {
      R.warn(`Invalid attribute key: ${n}`);
      continue;
    }
    const r = e[n];
    if (!ka(r)) {
      R.warn(`Invalid attribute value set for key: ${n}`);
      continue;
    }
    Array.isArray(r) ? t[n] = r.slice() : t[n] = r;
  }
  return t;
}
function wp(e) {
  return typeof e == "string" && e !== "";
}
function ka(e) {
  return e == null ? !0 : Array.isArray(e) ? Ap(e) : Da(typeof e);
}
function Ap(e) {
  let t;
  for (const n of e) {
    if (n == null)
      continue;
    const r = typeof n;
    if (r !== t) {
      if (!t) {
        if (Da(r)) {
          t = r;
          continue;
        }
        return !1;
      }
      return !1;
    }
  }
  return !0;
}
function Da(e) {
  switch (e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Op() {
  return (e) => {
    R.error(Rp(e));
  };
}
function Rp(e) {
  return typeof e == "string" ? e : JSON.stringify(Pp(e));
}
function Pp(e) {
  const t = {};
  let n = e;
  for (; n !== null; )
    Object.getOwnPropertyNames(n).forEach((r) => {
      if (t[r])
        return;
      const i = n[r];
      i && (t[r] = String(i));
    }), n = Object.getPrototypeOf(n);
  return t;
}
let Ip = Op();
function dt(e) {
  try {
    Ip(e);
  } catch (t) {
  }
}
const Cp = "2.6.1", Np = "deployment.environment", xp = Np, si = "error.type", jr = "exception.message", Lp = "exception.stacktrace", Br = "exception.type", Ua = "http.request.method", $a = "http.request.method_original", ja = "http.response.status_code", Ba = "server.address", Fa = "server.port", Va = "service.name", Mp = "service.version", Rn = "telemetry.sdk.language", Ha = "webjs", Pn = "telemetry.sdk.name", In = "telemetry.sdk.version", Ga = "url.full", kp = "user_agent.original", Dp = "process.runtime.name", Fr = {
  [Pn]: "opentelemetry",
  [Dp]: "browser",
  [Rn]: Ha,
  [In]: Cp
}, nt = performance, Up = 9, $p = 6, jp = Math.pow(10, $p), oi = Math.pow(10, Up);
function rt(e) {
  const t = e / 1e3, n = Math.trunc(t), r = Math.round(e % 1e3 * jp);
  return [n, r];
}
function Bp(e) {
  const t = rt(nt.timeOrigin), n = rt(typeof e == "number" ? e : nt.now());
  return qa(t, n);
}
function Fp(e, t) {
  let n = t[0] - e[0], r = t[1] - e[1];
  return r < 0 && (n -= 1, r += oi), [n, r];
}
function za(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Ks(e) {
  return za(e) || typeof e == "number" || e instanceof Date;
}
function qa(e, t) {
  const n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= oi && (n[1] -= oi, n[0] += 1), n;
}
var Cn;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Cn || (Cn = {}));
let Vp = class {
  /**
   * Construct a composite propagator from a list of propagators.
   *
   * @param [config] Configuration object for composite propagator
   */
  constructor(t = {}) {
    _(this, "_propagators");
    _(this, "_fields");
    var n;
    this._propagators = (n = t.propagators) != null ? n : [], this._fields = Array.from(new Set(this._propagators.map((r) => typeof r.fields == "function" ? r.fields() : []).reduce((r, i) => r.concat(i), [])));
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same carrier key, the propagator later in the list
   * will "win".
   *
   * @param context Context to inject
   * @param carrier Carrier into which context will be injected
   */
  inject(t, n, r) {
    for (const i of this._propagators)
      try {
        i.inject(t, n, r);
      } catch (s) {
        R.warn(`Failed to inject with ${i.constructor.name}. Err: ${s.message}`);
      }
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same context key, the propagator later in the list
   * will "win".
   *
   * @param context Context to add values to
   * @param carrier Carrier from which to extract context
   */
  extract(t, n, r) {
    return this._propagators.reduce((i, s) => {
      try {
        return s.extract(i, n, r);
      } catch (o) {
        R.warn(`Failed to extract with ${s.constructor.name}. Err: ${o.message}`);
      }
      return i;
    }, t);
  }
  fields() {
    return this._fields.slice();
  }
};
const ai = "[_0-9a-z-*/]", Hp = `[a-z]${ai}{0,255}`, Gp = `[a-z0-9]${ai}{0,240}@[a-z]${ai}{0,13}`, zp = new RegExp(`^(?:${Hp}|${Gp})$`), qp = /^[ -~]{0,255}[!-~]$/, Kp = /,|=/;
function Wp(e) {
  return zp.test(e);
}
function Xp(e) {
  return qp.test(e) && !Kp.test(e);
}
const Ws = 32, Yp = 512, Xs = ",", Ys = "=";
let Qp = class Ka {
  constructor(t) {
    _(this, "_internalState", /* @__PURE__ */ new Map());
    t && this._parse(t);
  }
  set(t, n) {
    const r = this._clone();
    return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
  }
  unset(t) {
    const n = this._clone();
    return n._internalState.delete(t), n;
  }
  get(t) {
    return this._internalState.get(t);
  }
  serialize() {
    return this._keys().reduce((t, n) => (t.push(n + Ys + this.get(n)), t), []).join(Xs);
  }
  _parse(t) {
    t.length > Yp || (this._internalState = t.split(Xs).reverse().reduce((n, r) => {
      const i = r.trim(), s = i.indexOf(Ys);
      if (s !== -1) {
        const o = i.slice(0, s), a = i.slice(s + 1, r.length);
        Wp(o) && Xp(a) && n.set(o, a);
      }
      return n;
    }, /* @__PURE__ */ new Map()), this._internalState.size > Ws && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Ws))));
  }
  _keys() {
    return Array.from(this._internalState.keys()).reverse();
  }
  _clone() {
    const t = new Ka();
    return t._internalState = new Map(this._internalState), t;
  }
};
const Vr = "traceparent", Hr = "tracestate", Jp = "00", Zp = "(?!ff)[\\da-f]{2}", eh = "(?![0]{32})[\\da-f]{32}", th = "(?![0]{16})[\\da-f]{16}", nh = "[\\da-f]{2}", rh = new RegExp(`^\\s?(${Zp})-(${eh})-(${th})-(${nh})(-.*)?\\s?$`);
function ih(e) {
  const t = rh.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
let Wa = class {
  inject(t, n, r) {
    const i = V.getSpanContext(t);
    if (!i || Hi(t) || !Jt(i))
      return;
    const s = `${Jp}-${i.traceId}-${i.spanId}-0${Number(i.traceFlags || be.NONE).toString(16)}`;
    r.set(n, Vr, s), i.traceState && r.set(n, Hr, i.traceState.serialize());
  }
  extract(t, n, r) {
    const i = r.get(n, Vr);
    if (!i)
      return t;
    const s = Array.isArray(i) ? i[0] : i;
    if (typeof s != "string")
      return t;
    const o = ih(s);
    if (!o)
      return t;
    o.isRemote = !0;
    const a = r.get(n, Hr);
    if (a) {
      const c = Array.isArray(a) ? a.join(",") : a;
      o.traceState = new Qp(typeof c == "string" ? c : void 0);
    }
    return V.setSpanContext(t, o);
  }
  fields() {
    return [Vr, Hr];
  }
};
const sh = "[object Object]", oh = "[object Null]", ah = "[object Undefined]", ch = Function.prototype, Xa = ch.toString, uh = Xa.call(Object), lh = Object.getPrototypeOf, Ya = Object.prototype, Qa = Ya.hasOwnProperty, Be = Symbol ? Symbol.toStringTag : void 0, Ja = Ya.toString;
function Qs(e) {
  if (!dh(e) || fh(e) !== sh)
    return !1;
  const t = lh(e);
  if (t === null)
    return !0;
  const n = Qa.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Xa.call(n) === uh;
}
function dh(e) {
  return e != null && typeof e == "object";
}
function fh(e) {
  return e == null ? e === void 0 ? ah : oh : Be && Be in Object(e) ? ph(e) : hh(e);
}
function ph(e) {
  const t = Qa.call(e, Be), n = e[Be];
  let r = !1;
  try {
    e[Be] = void 0, r = !0;
  } catch (s) {
  }
  const i = Ja.call(e);
  return r && (t ? e[Be] = n : delete e[Be]), i;
}
function hh(e) {
  return Ja.call(e);
}
const mh = 20;
function gh(...e) {
  let t = e.shift();
  const n = /* @__PURE__ */ new WeakMap();
  for (; e.length > 0; )
    t = Za(t, e.shift(), 0, n);
  return t;
}
function Gr(e) {
  return Nn(e) ? e.slice() : e;
}
function Za(e, t, n = 0, r) {
  let i;
  if (!(n > mh)) {
    if (n++, bn(e) || bn(t) || ec(t))
      i = Gr(t);
    else if (Nn(e)) {
      if (i = e.slice(), Nn(t))
        for (let s = 0, o = t.length; s < o; s++)
          i.push(Gr(t[s]));
      else if (Nt(t)) {
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const c = s[o];
          i[c] = Gr(t[c]);
        }
      }
    } else if (Nt(e))
      if (Nt(t)) {
        if (!_h(e, t))
          return t;
        i = Object.assign({}, e);
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const c = s[o], u = t[c];
          if (bn(u))
            typeof u == "undefined" ? delete i[c] : i[c] = u;
          else {
            const f = i[c], m = u;
            if (Js(e, c, r) || Js(t, c, r))
              delete i[c];
            else {
              if (Nt(f) && Nt(m)) {
                const l = r.get(f) || [], d = r.get(m) || [];
                l.push({ obj: e, key: c }), d.push({ obj: t, key: c }), r.set(f, l), r.set(m, d);
              }
              i[c] = Za(i[c], u, n, r);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Js(e, t, n) {
  const r = n.get(e[t]) || [];
  for (let i = 0, s = r.length; i < s; i++) {
    const o = r[i];
    if (o.key === t && o.obj === e)
      return !0;
  }
  return !1;
}
function Nn(e) {
  return Array.isArray(e);
}
function ec(e) {
  return typeof e == "function";
}
function Nt(e) {
  return !bn(e) && !Nn(e) && !ec(e) && typeof e == "object";
}
function bn(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function _h(e, t) {
  return !(!Qs(e) || !Qs(t));
}
let bh = class {
  constructor() {
    _(this, "_promise");
    _(this, "_resolve");
    _(this, "_reject");
    this._promise = new Promise((t, n) => {
      this._resolve = t, this._reject = n;
    });
  }
  get promise() {
    return this._promise;
  }
  resolve(t) {
    this._resolve(t);
  }
  reject(t) {
    this._reject(t);
  }
}, vh = class {
  constructor(t, n) {
    _(this, "_isCalled", !1);
    _(this, "_deferred", new bh());
    _(this, "_callback");
    _(this, "_that");
    this._callback = t, this._that = n;
  }
  get isCalled() {
    return this._isCalled;
  }
  get promise() {
    return this._deferred.promise;
  }
  call(...t) {
    if (!this._isCalled) {
      this._isCalled = !0;
      try {
        Promise.resolve(this._callback.call(this._that, ...t)).then((n) => this._deferred.resolve(n), (n) => this._deferred.reject(n));
      } catch (n) {
        this._deferred.reject(n);
      }
    }
    return this._deferred.promise;
  }
};
var Q = {};
const Gi = Qt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function tc(e) {
  return e.setValue(Gi, !0);
}
function Eh(e) {
  return e.deleteValue(Gi);
}
function zi(e) {
  return e.getValue(Gi) === !0;
}
const Sh = "=", nc = ";", xn = ",", zr = "baggage", Th = 180, yh = 4096, wh = 8192;
function Ah(e) {
  return e.reduce((t, n) => {
    const r = `${t}${t !== "" ? xn : ""}${n}`;
    return r.length > wh ? t : r;
  }, "");
}
function Oh(e) {
  return e.getAllEntries().map(([t, n]) => {
    let r = `${encodeURIComponent(t)}=${encodeURIComponent(n.value)}`;
    return n.metadata !== void 0 && (r += nc + n.metadata.toString()), r;
  });
}
function rc(e) {
  if (!e)
    return;
  const t = e.indexOf(nc), n = t === -1 ? e : e.substring(0, t), r = n.indexOf(Sh);
  if (r <= 0)
    return;
  const i = n.substring(0, r).trim(), s = n.substring(r + 1).trim();
  if (!i || !s)
    return;
  let o, a;
  try {
    o = decodeURIComponent(i), a = decodeURIComponent(s);
  } catch (u) {
    return;
  }
  let c;
  if (t !== -1 && t < e.length - 1) {
    const u = e.substring(t + 1);
    c = Ta(u);
  }
  return { key: o, value: a, metadata: c };
}
function Rh(e) {
  const t = {};
  return typeof e == "string" && e.length > 0 && e.split(xn).forEach((n) => {
    const r = rc(n);
    r !== void 0 && r.value.length > 0 && (t[r.key] = r.value);
  }), t;
}
class Ph {
  inject(t, n, r) {
    const i = Z.getBaggage(t);
    if (!i || zi(t))
      return;
    const s = Oh(i).filter((a) => a.length <= yh).slice(0, Th), o = Ah(s);
    o.length > 0 && r.set(n, zr, o);
  }
  extract(t, n, r) {
    const i = r.get(n, zr), s = Array.isArray(i) ? i.join(xn) : i;
    if (!s)
      return t;
    const o = {};
    return s.length === 0 || (s.split(xn).forEach((c) => {
      const u = rc(c);
      if (u) {
        const f = { value: u.value };
        u.metadata && (f.metadata = u.metadata), o[u.key] = f;
      }
    }), Object.entries(o).length === 0) ? t : Z.setBaggage(t, Z.createBaggage(o));
  }
  fields() {
    return [zr];
  }
}
class Ih {
  /**
   * Create a new AnchoredClock anchored to the current time returned by systemClock.
   *
   * @param systemClock should be a clock that returns the number of milliseconds since January 1 1970 such as Date
   * @param monotonicClock should be a clock that counts milliseconds monotonically such as window.performance or perf_hooks.performance
   */
  constructor(t, n) {
    _(this, "_monotonicClock");
    _(this, "_epochMillis");
    _(this, "_performanceMillis");
    this._monotonicClock = n, this._epochMillis = t.now(), this._performanceMillis = n.now();
  }
  /**
   * Returns the current time by adding the number of milliseconds since the
   * AnchoredClock was created to the creation epoch time
   */
  now() {
    const t = this._monotonicClock.now() - this._performanceMillis;
    return this._epochMillis + t;
  }
}
function Ch(e) {
  const t = {};
  if (typeof e != "object" || e == null)
    return t;
  for (const n in e) {
    if (!Object.prototype.hasOwnProperty.call(e, n))
      continue;
    if (!Nh(n)) {
      R.warn(`Invalid attribute key: ${n}`);
      continue;
    }
    const r = e[n];
    if (!ic(r)) {
      R.warn(`Invalid attribute value set for key: ${n}`);
      continue;
    }
    Array.isArray(r) ? t[n] = r.slice() : t[n] = r;
  }
  return t;
}
function Nh(e) {
  return typeof e == "string" && e !== "";
}
function ic(e) {
  return e == null ? !0 : Array.isArray(e) ? xh(e) : sc(typeof e);
}
function xh(e) {
  let t;
  for (const n of e) {
    if (n == null)
      continue;
    const r = typeof n;
    if (r !== t) {
      if (!t) {
        if (sc(r)) {
          t = r;
          continue;
        }
        return !1;
      }
      return !1;
    }
  }
  return !0;
}
function sc(e) {
  switch (e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function oc() {
  return (e) => {
    R.error(Lh(e));
  };
}
function Lh(e) {
  return typeof e == "string" ? e : JSON.stringify(Mh(e));
}
function Mh(e) {
  const t = {};
  let n = e;
  for (; n !== null; )
    Object.getOwnPropertyNames(n).forEach((r) => {
      if (t[r])
        return;
      const i = n[r];
      i && (t[r] = String(i));
    }), n = Object.getPrototypeOf(n);
  return t;
}
let ac = oc();
function kh(e) {
  ac = e;
}
function Dh(e) {
  try {
    ac(e);
  } catch (t) {
  }
}
function Uh(e) {
}
function $h(e) {
}
function jh(e) {
}
function Bh(e) {
}
const Fh = globalThis, Vh = "2.6.0", Hh = "process.runtime.name", Gh = {
  [Pn]: "opentelemetry",
  [Hh]: "browser",
  [Rn]: Ha,
  [In]: Vh
}, qe = performance, cc = 9, zh = 6, qh = Math.pow(10, zh), Ln = Math.pow(10, cc);
function ft(e) {
  const t = e / 1e3, n = Math.trunc(t), r = Math.round(e % 1e3 * qh);
  return [n, r];
}
function Kh() {
  return qe.timeOrigin;
}
function pt(e) {
  const t = ft(qe.timeOrigin), n = ft(typeof e == "number" ? e : qe.now());
  return uc(t, n);
}
function st(e) {
  if (qi(e))
    return e;
  if (typeof e == "number")
    return e < qe.timeOrigin ? pt(e) : ft(e);
  if (e instanceof Date)
    return ft(e.getTime());
  throw TypeError("Invalid input type");
}
function Wh(e, t) {
  let n = t[0] - e[0], r = t[1] - e[1];
  return r < 0 && (n -= 1, r += Ln), [n, r];
}
function Xh(e) {
  const t = cc, n = `${"0".repeat(t)}${e[1]}Z`, r = n.substring(n.length - t - 1);
  return new Date(e[0] * 1e3).toISOString().replace("000Z", r);
}
function Oe(e) {
  return e[0] * Ln + e[1];
}
function Yh(e) {
  return e[0] * 1e3 + e[1] / 1e6;
}
function Qh(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function qi(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Jh(e) {
  return qi(e) || typeof e == "number" || e instanceof Date;
}
function uc(e, t) {
  const n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= Ln && (n[1] -= Ln, n[0] += 1), n;
}
function Zh(e) {
  typeof e != "number" && e.unref();
}
var ci;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(ci || (ci = {}));
class em {
  /**
   * Construct a composite propagator from a list of propagators.
   *
   * @param [config] Configuration object for composite propagator
   */
  constructor(t = {}) {
    _(this, "_propagators");
    _(this, "_fields");
    var n;
    this._propagators = (n = t.propagators) != null ? n : [], this._fields = Array.from(new Set(this._propagators.map((r) => typeof r.fields == "function" ? r.fields() : []).reduce((r, i) => r.concat(i), [])));
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same carrier key, the propagator later in the list
   * will "win".
   *
   * @param context Context to inject
   * @param carrier Carrier into which context will be injected
   */
  inject(t, n, r) {
    for (const i of this._propagators)
      try {
        i.inject(t, n, r);
      } catch (s) {
        R.warn(`Failed to inject with ${i.constructor.name}. Err: ${s.message}`);
      }
  }
  /**
   * Run each of the configured propagators with the given context and carrier.
   * Propagators are run in the order they are configured, so if multiple
   * propagators write the same context key, the propagator later in the list
   * will "win".
   *
   * @param context Context to add values to
   * @param carrier Carrier from which to extract context
   */
  extract(t, n, r) {
    return this._propagators.reduce((i, s) => {
      try {
        return s.extract(i, n, r);
      } catch (o) {
        R.warn(`Failed to extract with ${s.constructor.name}. Err: ${o.message}`);
      }
      return i;
    }, t);
  }
  fields() {
    return this._fields.slice();
  }
}
const ui = "[_0-9a-z-*/]", tm = `[a-z]${ui}{0,255}`, nm = `[a-z0-9]${ui}{0,240}@[a-z]${ui}{0,13}`, rm = new RegExp(`^(?:${tm}|${nm})$`), im = /^[ -~]{0,255}[!-~]$/, sm = /,|=/;
function om(e) {
  return rm.test(e);
}
function am(e) {
  return im.test(e) && !sm.test(e);
}
const Zs = 32, cm = 512, eo = ",", to = "=";
class sr {
  constructor(t) {
    _(this, "_internalState", /* @__PURE__ */ new Map());
    t && this._parse(t);
  }
  set(t, n) {
    const r = this._clone();
    return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
  }
  unset(t) {
    const n = this._clone();
    return n._internalState.delete(t), n;
  }
  get(t) {
    return this._internalState.get(t);
  }
  serialize() {
    return this._keys().reduce((t, n) => (t.push(n + to + this.get(n)), t), []).join(eo);
  }
  _parse(t) {
    t.length > cm || (this._internalState = t.split(eo).reverse().reduce((n, r) => {
      const i = r.trim(), s = i.indexOf(to);
      if (s !== -1) {
        const o = i.slice(0, s), a = i.slice(s + 1, r.length);
        om(o) && am(a) && n.set(o, a);
      }
      return n;
    }, /* @__PURE__ */ new Map()), this._internalState.size > Zs && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Zs))));
  }
  _keys() {
    return Array.from(this._internalState.keys()).reverse();
  }
  _clone() {
    const t = new sr();
    return t._internalState = new Map(this._internalState), t;
  }
}
const vn = "traceparent", En = "tracestate", um = "00", lm = "(?!ff)[\\da-f]{2}", dm = "(?![0]{32})[\\da-f]{32}", fm = "(?![0]{16})[\\da-f]{16}", pm = "[\\da-f]{2}", hm = new RegExp(`^\\s?(${lm})-(${dm})-(${fm})-(${pm})(-.*)?\\s?$`);
function lc(e) {
  const t = hm.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
class mm {
  inject(t, n, r) {
    const i = V.getSpanContext(t);
    if (!i || zi(t) || !Jt(i))
      return;
    const s = `${um}-${i.traceId}-${i.spanId}-0${Number(i.traceFlags || be.NONE).toString(16)}`;
    r.set(n, vn, s), i.traceState && r.set(n, En, i.traceState.serialize());
  }
  extract(t, n, r) {
    const i = r.get(n, vn);
    if (!i)
      return t;
    const s = Array.isArray(i) ? i[0] : i;
    if (typeof s != "string")
      return t;
    const o = lc(s);
    if (!o)
      return t;
    o.isRemote = !0;
    const a = r.get(n, En);
    if (a) {
      const c = Array.isArray(a) ? a.join(",") : a;
      o.traceState = new sr(typeof c == "string" ? c : void 0);
    }
    return V.setSpanContext(t, o);
  }
  fields() {
    return [vn, En];
  }
}
const Ki = Qt("OpenTelemetry SDK Context Key RPC_METADATA");
var li;
(function(e) {
  e.HTTP = "http";
})(li || (li = {}));
function gm(e, t) {
  return e.setValue(Ki, t);
}
function _m(e) {
  return e.deleteValue(Ki);
}
function bm(e) {
  return e.getValue(Ki);
}
const vm = "[object Object]", Em = "[object Null]", Sm = "[object Undefined]", Tm = Function.prototype, dc = Tm.toString, ym = dc.call(Object), wm = Object.getPrototypeOf, fc = Object.prototype, pc = fc.hasOwnProperty, Fe = Symbol ? Symbol.toStringTag : void 0, hc = fc.toString;
function no(e) {
  if (!Am(e) || Om(e) !== vm)
    return !1;
  const t = wm(e);
  if (t === null)
    return !0;
  const n = pc.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && dc.call(n) === ym;
}
function Am(e) {
  return e != null && typeof e == "object";
}
function Om(e) {
  return e == null ? e === void 0 ? Sm : Em : Fe && Fe in Object(e) ? Rm(e) : Pm(e);
}
function Rm(e) {
  const t = pc.call(e, Fe), n = e[Fe];
  let r = !1;
  try {
    e[Fe] = void 0, r = !0;
  } catch (s) {
  }
  const i = hc.call(e);
  return r && (t ? e[Fe] = n : delete e[Fe]), i;
}
function Pm(e) {
  return hc.call(e);
}
const Im = 20;
function Cm(...e) {
  let t = e.shift();
  const n = /* @__PURE__ */ new WeakMap();
  for (; e.length > 0; )
    t = mc(t, e.shift(), 0, n);
  return t;
}
function qr(e) {
  return Mn(e) ? e.slice() : e;
}
function mc(e, t, n = 0, r) {
  let i;
  if (!(n > Im)) {
    if (n++, Sn(e) || Sn(t) || gc(t))
      i = qr(t);
    else if (Mn(e)) {
      if (i = e.slice(), Mn(t))
        for (let s = 0, o = t.length; s < o; s++)
          i.push(qr(t[s]));
      else if (xt(t)) {
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const c = s[o];
          i[c] = qr(t[c]);
        }
      }
    } else if (xt(e))
      if (xt(t)) {
        if (!Nm(e, t))
          return t;
        i = Object.assign({}, e);
        const s = Object.keys(t);
        for (let o = 0, a = s.length; o < a; o++) {
          const c = s[o], u = t[c];
          if (Sn(u))
            typeof u == "undefined" ? delete i[c] : i[c] = u;
          else {
            const f = i[c], m = u;
            if (ro(e, c, r) || ro(t, c, r))
              delete i[c];
            else {
              if (xt(f) && xt(m)) {
                const l = r.get(f) || [], d = r.get(m) || [];
                l.push({ obj: e, key: c }), d.push({ obj: t, key: c }), r.set(f, l), r.set(m, d);
              }
              i[c] = mc(i[c], u, n, r);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function ro(e, t, n) {
  const r = n.get(e[t]) || [];
  for (let i = 0, s = r.length; i < s; i++) {
    const o = r[i];
    if (o.key === t && o.obj === e)
      return !0;
  }
  return !1;
}
function Mn(e) {
  return Array.isArray(e);
}
function gc(e) {
  return typeof e == "function";
}
function xt(e) {
  return !Sn(e) && !Mn(e) && !gc(e) && typeof e == "object";
}
function Sn(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function Nm(e, t) {
  return !(!no(e) || !no(t));
}
class or extends Error {
  constructor(t) {
    super(t), Object.setPrototypeOf(this, or.prototype);
  }
}
function xm(e, t) {
  let n;
  const r = new Promise(function(s, o) {
    n = setTimeout(function() {
      o(new or("Operation timed out."));
    }, t);
  });
  return Promise.race([e, r]).then((i) => (clearTimeout(n), i), (i) => {
    throw clearTimeout(n), i;
  });
}
function Wi(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Xi(e, t) {
  if (!t)
    return !1;
  for (const n of t)
    if (Wi(e, n))
      return !0;
  return !1;
}
class Lm {
  constructor() {
    _(this, "_promise");
    _(this, "_resolve");
    _(this, "_reject");
    this._promise = new Promise((t, n) => {
      this._resolve = t, this._reject = n;
    });
  }
  get promise() {
    return this._promise;
  }
  resolve(t) {
    this._resolve(t);
  }
  reject(t) {
    this._reject(t);
  }
}
class Mm {
  constructor(t, n) {
    _(this, "_isCalled", !1);
    _(this, "_deferred", new Lm());
    _(this, "_callback");
    _(this, "_that");
    this._callback = t, this._that = n;
  }
  get isCalled() {
    return this._isCalled;
  }
  get promise() {
    return this._deferred.promise;
  }
  call(...t) {
    if (!this._isCalled) {
      this._isCalled = !0;
      try {
        Promise.resolve(this._callback.call(this._that, ...t)).then((n) => this._deferred.resolve(n), (n) => this._deferred.reject(n));
      } catch (n) {
        this._deferred.reject(n);
      }
    }
    return this._deferred.promise;
  }
}
const io = {
  ALL: F.ALL,
  VERBOSE: F.VERBOSE,
  DEBUG: F.DEBUG,
  INFO: F.INFO,
  WARN: F.WARN,
  ERROR: F.ERROR,
  NONE: F.NONE
};
function km(e) {
  if (e == null)
    return;
  const t = io[e.toUpperCase()];
  return t == null ? (R.warn(`Unknown log level "${e}", expected one of ${Object.keys(io)}, using default`), F.INFO) : t;
}
function Dm(e, t) {
  return new Promise((n) => {
    j.with(tc(j.active()), () => {
      e.export(t, n);
    });
  });
}
const Um = {
  _export: Dm
}, $m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnchoredClock: Ih,
  BindOnceFuture: Mm,
  CompositePropagator: em,
  get ExportResultCode() {
    return ci;
  },
  get RPCType() {
    return li;
  },
  SDK_INFO: Gh,
  TRACE_PARENT_HEADER: vn,
  TRACE_STATE_HEADER: En,
  TimeoutError: or,
  TraceState: sr,
  W3CBaggagePropagator: Ph,
  W3CTraceContextPropagator: mm,
  _globalThis: Fh,
  addHrTimes: uc,
  callWithTimeout: xm,
  deleteRPCMetadata: _m,
  diagLogLevelFromString: km,
  getBooleanFromEnv: $h,
  getNumberFromEnv: jh,
  getRPCMetadata: bm,
  getStringFromEnv: Uh,
  getStringListFromEnv: Bh,
  getTimeOrigin: Kh,
  globalErrorHandler: Dh,
  hrTime: pt,
  hrTimeDuration: Wh,
  hrTimeToMicroseconds: Qh,
  hrTimeToMilliseconds: Yh,
  hrTimeToNanoseconds: Oe,
  hrTimeToTimeStamp: Xh,
  internal: Um,
  isAttributeValue: ic,
  isTimeInput: Jh,
  isTimeInputHrTime: qi,
  isTracingSuppressed: zi,
  isUrlIgnored: Xi,
  loggingErrorHandler: oc,
  merge: Cm,
  millisToHrTime: ft,
  otperformance: qe,
  parseKeyPairsIntoRecord: Rh,
  parseTraceParent: lc,
  sanitizeAttributes: Ch,
  setGlobalErrorHandler: kh,
  setRPCMetadata: gm,
  suppressTracing: tc,
  timeInputToHrTime: st,
  unrefTimer: Zh,
  unsuppressTracing: Eh,
  urlMatches: Wi
}, Symbol.toStringTag, { value: "Module" })), jm = /* @__PURE__ */ tu($m);
var ar = {};
Object.defineProperty(ar, "__esModule", { value: !0 });
ar.hexToBinary = void 0;
function so(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Bm(e) {
  const t = new Uint8Array(e.length / 2);
  let n = 0;
  for (let r = 0; r < e.length; r += 2) {
    const i = so(e.charCodeAt(r)), s = so(e.charCodeAt(r + 1));
    t[n++] = i << 4 | s;
  }
  return t;
}
ar.hexToBinary = Bm;
Object.defineProperty(Q, "__esModule", { value: !0 });
var _c = Q.JSON_ENCODER = Q.PROTOBUF_ENCODER = Q.encodeAsString = Q.encodeAsLongBits = Q.toLongBits = Q.hrTimeToNanos = void 0;
const Fm = jm, bc = ar;
function Yi(e) {
  const t = BigInt(1e9);
  return BigInt(Math.trunc(e[0])) * t + BigInt(Math.trunc(e[1]));
}
Q.hrTimeToNanos = Yi;
function vc(e) {
  const t = Number(BigInt.asUintN(32, e)), n = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: n };
}
Q.toLongBits = vc;
function Ec(e) {
  const t = Yi(e);
  return vc(t);
}
Q.encodeAsLongBits = Ec;
function Sc(e) {
  return Yi(e).toString();
}
Q.encodeAsString = Sc;
const Vm = typeof BigInt != "undefined" ? Sc : Fm.hrTimeToNanoseconds;
function di(e) {
  return e;
}
function Hm(e) {
  if (e !== void 0)
    return (0, bc.hexToBinary)(e);
}
Q.PROTOBUF_ENCODER = {
  encodeHrTime: Ec,
  encodeSpanContext: bc.hexToBinary,
  encodeOptionalSpanContext: Hm,
  encodeUint8Array: di
};
_c = Q.JSON_ENCODER = {
  encodeHrTime: Vm,
  encodeSpanContext: di,
  encodeOptionalSpanContext: di,
  encodeUint8Array: (e) => {
    if (typeof Buffer != "undefined")
      return Buffer.from(e).toString("base64");
    const t = new Array(e.length);
    for (let n = 0; n < e.length; n++)
      t[n] = String.fromCharCode(e[n]);
    return btoa(t.join(""));
  }
};
var Re = {}, ne = {};
Object.defineProperty(ne, "__esModule", { value: !0 });
ne.toAnyValue = ne.toKeyValue = ne.toAttributes = ne.createInstrumentationScope = ne.createResource = void 0;
function Gm(e, t) {
  const n = {
    attributes: Tc(e.attributes, t),
    droppedAttributesCount: 0
  }, r = e.schemaUrl;
  return r && r !== "" && (n.schemaUrl = r), n;
}
ne.createResource = Gm;
function zm(e) {
  return {
    name: e.name,
    version: e.version
  };
}
ne.createInstrumentationScope = zm;
function Tc(e, t) {
  return Object.keys(e).map((n) => yc(n, e[n], t));
}
ne.toAttributes = Tc;
function yc(e, t, n) {
  return {
    key: e,
    value: kn(t, n)
  };
}
ne.toKeyValue = yc;
function kn(e, t) {
  const n = typeof e;
  if (n === "string")
    return { stringValue: e };
  if (n === "number")
    return Number.isInteger(e) ? { intValue: e } : { doubleValue: e };
  if (n === "boolean")
    return { boolValue: e };
  if (e instanceof Uint8Array)
    return { bytesValue: t.encodeUint8Array(e) };
  if (Array.isArray(e)) {
    const r = new Array(e.length);
    for (let i = 0; i < e.length; i++)
      r[i] = kn(e[i], t);
    return { arrayValue: { values: r } };
  }
  if (n === "object" && e != null) {
    const r = Object.keys(e), i = new Array(r.length);
    for (let s = 0; s < r.length; s++)
      i[s] = {
        key: r[s],
        value: kn(e[r[s]], t)
      };
    return { kvlistValue: { values: i } };
  }
  return {};
}
ne.toAnyValue = kn;
Object.defineProperty(Re, "__esModule", { value: !0 });
var wc = Re.createExportTraceServiceRequest = Re.toOtlpSpanEvent = Re.toOtlpLink = Re.sdkSpanToOtlpSpan = void 0;
const Ft = ne, qm = 256, Km = 512;
function Ac(e, t) {
  let n = e & 255 | qm;
  return t && (n |= Km), n;
}
function Oc(e, t) {
  var s, o, a, c;
  const n = e.spanContext(), r = e.status, i = (s = e.parentSpanContext) != null && s.spanId ? t.encodeSpanContext((o = e.parentSpanContext) == null ? void 0 : o.spanId) : void 0;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: i,
    traceState: (a = n.traceState) == null ? void 0 : a.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: (0, Ft.toAttributes)(e.attributes, t),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map((u) => Pc(u, t)),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: r.code,
      message: r.message
    },
    links: e.links.map((u) => Rc(u, t)),
    droppedLinksCount: e.droppedLinksCount,
    flags: Ac(n.traceFlags, (c = e.parentSpanContext) == null ? void 0 : c.isRemote)
  };
}
Re.sdkSpanToOtlpSpan = Oc;
function Rc(e, t) {
  var n;
  return {
    attributes: e.attributes ? (0, Ft.toAttributes)(e.attributes, t) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (n = e.context.traceState) == null ? void 0 : n.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0,
    flags: Ac(e.context.traceFlags, e.context.isRemote)
  };
}
Re.toOtlpLink = Rc;
function Pc(e, t) {
  return {
    attributes: e.attributes ? (0, Ft.toAttributes)(e.attributes, t) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
Re.toOtlpSpanEvent = Pc;
function Wm(e, t) {
  return {
    resourceSpans: Ym(e, t)
  };
}
wc = Re.createExportTraceServiceRequest = Wm;
function Xm(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e) {
    let r = t.get(n.resource);
    r || (r = /* @__PURE__ */ new Map(), t.set(n.resource, r));
    const i = `${n.instrumentationScope.name}@${n.instrumentationScope.version || ""}:${n.instrumentationScope.schemaUrl || ""}`;
    let s = r.get(i);
    s || (s = [], r.set(i, s)), s.push(n);
  }
  return t;
}
function Ym(e, t) {
  const n = Xm(e), r = [], i = n.entries();
  let s = i.next();
  for (; !s.done; ) {
    const [o, a] = s.value, c = [], u = a.values();
    let f = u.next();
    for (; !f.done; ) {
      const d = f.value;
      if (d.length > 0) {
        const p = d.map((h) => Oc(h, t));
        c.push({
          scope: (0, Ft.createInstrumentationScope)(d[0].instrumentationScope),
          spans: p,
          schemaUrl: d[0].instrumentationScope.schemaUrl
        });
      }
      f = u.next();
    }
    const m = (0, Ft.createResource)(o, t), l = {
      resource: m,
      scopeSpans: c,
      schemaUrl: m.schemaUrl
    };
    r.push(l), s = i.next();
  }
  return r;
}
var Ic = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.EStatusCode = e.ESpanKind = void 0, function(t) {
    t[t.SPAN_KIND_UNSPECIFIED = 0] = "SPAN_KIND_UNSPECIFIED", t[t.SPAN_KIND_INTERNAL = 1] = "SPAN_KIND_INTERNAL", t[t.SPAN_KIND_SERVER = 2] = "SPAN_KIND_SERVER", t[t.SPAN_KIND_CLIENT = 3] = "SPAN_KIND_CLIENT", t[t.SPAN_KIND_PRODUCER = 4] = "SPAN_KIND_PRODUCER", t[t.SPAN_KIND_CONSUMER = 5] = "SPAN_KIND_CONSUMER";
  }(e.ESpanKind || (e.ESpanKind = {})), function(t) {
    t[t.STATUS_CODE_UNSET = 0] = "STATUS_CODE_UNSET", t[t.STATUS_CODE_OK = 1] = "STATUS_CODE_OK", t[t.STATUS_CODE_ERROR = 2] = "STATUS_CODE_ERROR";
  }(e.EStatusCode || (e.EStatusCode = {}));
})(Ic);
const Qm = "duration_ns";
function Jm(e = [], t) {
  var n, r;
  for (const i of e) {
    const { scopeSpans: s } = i;
    for (const o of s) {
      const { scope: a, spans: c = [] } = o;
      for (const u of c) {
        if (u.kind !== Ic.ESpanKind.SPAN_KIND_CLIENT)
          continue;
        const f = {
          traceId: u.traceId.toString(),
          spanId: u.spanId.toString()
        }, m = {};
        for (const p of u.attributes)
          m[p.key] = String(Object.values(p.value)[0]);
        !Number.isNaN(u.endTimeUnixNano) && !Number.isNaN(u.startTimeUnixNano) && (m[Qm] = String(Number(u.endTimeUnixNano) - Number(u.startTimeUnixNano)));
        const l = ((n = a == null ? void 0 : a.name) !== null && n !== void 0 ? n : "").indexOf("-");
        let d = Y;
        a != null && a.name && (l === -1 && (d = (r = a.name.split("/")[1]) !== null && r !== void 0 ? r : a.name), l > -1 && (d = a == null ? void 0 : a.name.substring(l + 1))), t.pushEvent(`faro.tracing.${d}`, m, void 0, {
          spanContext: f,
          // Convert nanoseconds to milliseconds
          timestampOverwriteMs: Number(u.endTimeUnixNano) / 1e6,
          customPayloadTransformer: (p) => {
            var h, g;
            return m["faro.action.user.name"] != null && m["faro.action.user.parentId"] != null && (p.action = {
              name: m["faro.action.user.name"],
              parentId: m["faro.action.user.parentId"]
            }, (h = p.attributes) === null || h === void 0 || delete h["faro.action.user.name"], (g = p.attributes) === null || g === void 0 || delete g["faro.action.user.parentId"]), p;
          }
        });
      }
    }
  }
}
class Zm {
  constructor(t) {
    this.config = t;
  }
  export(t, n) {
    const r = wc(t, _c);
    this.config.api.pushTraces(r), Jm(r.resourceSpans, this.config.api), n({ code: Cn.SUCCESS });
  }
  shutdown() {
    return Promise.resolve(void 0);
  }
}
class Cc {
  emit(t) {
  }
}
const eg = new Cc(), hn = Symbol.for("io.opentelemetry.js.api.logs"), Lt = globalThis;
function tg(e, t, n) {
  return (r) => r === e ? t : n;
}
const oo = 1;
class ng {
  getLogger(t, n, r) {
    return new Cc();
  }
}
const Nc = new ng();
class rg {
  constructor(t, n, r, i) {
    this._provider = t, this.name = n, this.version = r, this.options = i;
  }
  /**
   * Emit a log record. This method should only be used by log appenders.
   *
   * @param logRecord
   */
  emit(t) {
    this._getLogger().emit(t);
  }
  /**
   * Try to get a logger from the proxy logger provider.
   * If the proxy logger provider has no delegate, return a noop logger.
   */
  _getLogger() {
    if (this._delegate)
      return this._delegate;
    const t = this._provider._getDelegateLogger(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : eg;
  }
}
class ao {
  getLogger(t, n, r) {
    var i;
    return (i = this._getDelegateLogger(t, n, r)) !== null && i !== void 0 ? i : new rg(this, t, n, r);
  }
  /**
   * Get the delegate logger provider.
   * Used by tests only.
   * @internal
   */
  _getDelegate() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : Nc;
  }
  /**
   * Set the delegate logger provider
   * @internal
   */
  _setDelegate(t) {
    this._delegate = t;
  }
  /**
   * @internal
   */
  _getDelegateLogger(t, n, r) {
    var i;
    return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, n, r);
  }
}
class Qi {
  constructor() {
    this._proxyLoggerProvider = new ao();
  }
  static getInstance() {
    return this._instance || (this._instance = new Qi()), this._instance;
  }
  setGlobalLoggerProvider(t) {
    return Lt[hn] ? this.getLoggerProvider() : (Lt[hn] = tg(oo, t, Nc), this._proxyLoggerProvider._setDelegate(t), t);
  }
  /**
   * Returns the global logger provider.
   *
   * @returns LoggerProvider
   */
  getLoggerProvider() {
    var t, n;
    return (n = (t = Lt[hn]) === null || t === void 0 ? void 0 : t.call(Lt, oo)) !== null && n !== void 0 ? n : this._proxyLoggerProvider;
  }
  /**
   * Returns a logger from the global logger provider.
   *
   * @returns Logger
   */
  getLogger(t, n, r) {
    return this.getLoggerProvider().getLogger(t, n, r);
  }
  /** Remove the global logger provider */
  disable() {
    delete Lt[hn], this._proxyLoggerProvider = new ao();
  }
}
const xc = Qi.getInstance();
function ig(e, t, n, r) {
  for (let i = 0, s = e.length; i < s; i++) {
    const o = e[i];
    t && o.setTracerProvider(t), n && o.setMeterProvider(n), r && o.setLoggerProvider && o.setLoggerProvider(r), o.getConfig().enabled || o.enable();
  }
}
function sg(e) {
  e.forEach((t) => t.disable());
}
function og(e) {
  var s, o;
  const t = e.tracerProvider || V.getTracerProvider(), n = e.meterProvider || Na.getMeterProvider(), r = e.loggerProvider || xc.getLoggerProvider(), i = (o = (s = e.instrumentations) == null ? void 0 : s.flat()) != null ? o : [];
  return ig(i, t, n, r), () => {
    sg(i);
  };
}
let J = console.error.bind(console);
function Mt(e, t, n) {
  const r = !!e[t] && Object.prototype.propertyIsEnumerable.call(e, t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: r,
    writable: !0,
    value: n
  });
}
const Lc = (e, t, n) => {
  if (!e || !e[t]) {
    J("no original function " + String(t) + " to wrap");
    return;
  }
  if (!n) {
    J("no wrapper function"), J(new Error().stack);
    return;
  }
  const r = e[t];
  if (typeof r != "function" || typeof n != "function") {
    J("original object and wrapper must be functions");
    return;
  }
  const i = n(r, t);
  return Mt(i, "__original", r), Mt(i, "__unwrap", () => {
    e[t] === i && Mt(e, t, r);
  }), Mt(i, "__wrapped", !0), Mt(e, t, i), i;
}, ag = (e, t, n) => {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    J("must provide one or more modules to patch"), J(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    J("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach((r) => {
    t.forEach((i) => {
      Lc(r, i, n);
    });
  });
}, Mc = (e, t) => {
  if (!e || !e[t]) {
    J("no function to unwrap."), J(new Error().stack);
    return;
  }
  const n = e[t];
  if (!n.__unwrap)
    J("no original to unwrap to -- has " + String(t) + " already been unwrapped?");
  else {
    n.__unwrap();
    return;
  }
}, cg = (e, t) => {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    J("must provide one or more modules to patch"), J(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    J("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach((n) => {
    t.forEach((r) => {
      Mc(n, r);
    });
  });
};
class ug {
  constructor(t, n, r) {
    _(this, "_config", {});
    _(this, "_tracer");
    _(this, "_meter");
    _(this, "_logger");
    _(this, "_diag");
    _(this, "instrumentationName");
    _(this, "instrumentationVersion");
    /* Api to wrap instrumented method */
    _(this, "_wrap", Lc);
    /* Api to unwrap instrumented methods */
    _(this, "_unwrap", Mc);
    /* Api to mass wrap instrumented method */
    _(this, "_massWrap", ag);
    /* Api to mass unwrap instrumented methods */
    _(this, "_massUnwrap", cg);
    this.instrumentationName = t, this.instrumentationVersion = n, this.setConfig(r), this._diag = R.createComponentLogger({
      namespace: t
    }), this._tracer = V.getTracer(t, n), this._meter = Na.getMeter(t, n), this._logger = xc.getLogger(t, n), this._updateMetricInstruments();
  }
  /* Returns meter */
  get meter() {
    return this._meter;
  }
  /**
   * Sets MeterProvider to this plugin
   * @param meterProvider
   */
  setMeterProvider(t) {
    this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
  }
  /* Returns logger */
  get logger() {
    return this._logger;
  }
  /**
   * Sets LoggerProvider to this plugin
   * @param loggerProvider
   */
  setLoggerProvider(t) {
    this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
  }
  /**
   * @experimental
   *
   * Get module definitions defined by {@link init}.
   * This can be used for experimental compile-time instrumentation.
   *
   * @returns an array of {@link InstrumentationModuleDefinition}
   */
  getModuleDefinitions() {
    var n;
    const t = (n = this.init()) != null ? n : [];
    return Array.isArray(t) ? t : [t];
  }
  /**
   * Sets the new metric instruments with the current Meter.
   */
  _updateMetricInstruments() {
  }
  /* Returns InstrumentationConfig */
  getConfig() {
    return this._config;
  }
  /**
   * Sets InstrumentationConfig to this plugin
   * @param config
   */
  setConfig(t) {
    this._config = It({
      enabled: !0
    }, t);
  }
  /**
   * Sets TraceProvider to this plugin
   * @param tracerProvider
   */
  setTracerProvider(t) {
    this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
  }
  /* Returns tracer */
  get tracer() {
    return this._tracer;
  }
  /**
   * Execute span customization hook, if configured, and log any errors.
   * Any semantics of the trigger and info are defined by the specific instrumentation.
   * @param hookHandler The optional hook handler which the user has configured via instrumentation config
   * @param triggerName The name of the trigger for executing the hook for logging purposes
   * @param span The span to which the hook should be applied
   * @param info The info object to be passed to the hook, with useful data the hook may use
   */
  _runSpanCustomizationHook(t, n, r, i) {
    if (t)
      try {
        t(r, i);
      } catch (s) {
        this._diag.error("Error running span customization hook due to exception in handler", { triggerName: n }, s);
      }
  }
}
class kc extends ug {
  constructor(t, n, r) {
    super(t, n, r), this._config.enabled && this.enable();
  }
}
function fi(e, t, n) {
  let r, i;
  try {
    i = e();
  } catch (s) {
    r = s;
  } finally {
    if (t(r, i), r && !n)
      throw r;
    return i;
  }
}
function pi(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var $;
(function(e) {
  e[e.STABLE = 1] = "STABLE", e[e.OLD = 2] = "OLD", e[e.DUPLICATE = 3] = "DUPLICATE";
})($ || ($ = {}));
function Dc(e, t) {
  let n = $.OLD;
  const r = t == null ? void 0 : t.split(",").map((i) => i.trim()).filter((i) => i !== "");
  for (const i of r != null ? r : [])
    if (i.toLowerCase() === e + "/dup") {
      n = $.DUPLICATE;
      break;
    } else
      i.toLowerCase() === e && (n = $.STABLE);
  return n;
}
var M;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.START_TIME = "startTime", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(M || (M = {}));
const lg = "http.response_content_length", dg = "http.response_content_length_uncompressed";
let Kr;
function fg() {
  return Kr || (Kr = document.createElement("a")), Kr;
}
function pg(e, t) {
  return t in e;
}
function Te(e, t, n, r = !0) {
  if (pg(n, t) && typeof n[t] == "number" && !(r && n[t] === 0))
    return e.addEvent(t, n[t]);
}
function Dn(e, t, n = !1, r, i) {
  if (r === void 0 && (r = t[M.START_TIME] !== 0), n || (Te(e, M.FETCH_START, t, r), Te(e, M.DOMAIN_LOOKUP_START, t, r), Te(e, M.DOMAIN_LOOKUP_END, t, r), Te(e, M.CONNECT_START, t, r), Te(e, M.SECURE_CONNECTION_START, t, r), Te(e, M.CONNECT_END, t, r), Te(e, M.REQUEST_START, t, r), Te(e, M.RESPONSE_START, t, r), Te(e, M.RESPONSE_END, t, r)), !i) {
    const s = t[M.ENCODED_BODY_SIZE];
    s !== void 0 && e.setAttribute(lg, s);
    const o = t[M.DECODED_BODY_SIZE];
    o !== void 0 && s !== o && e.setAttribute(dg, o);
  }
}
function hg(e) {
  return e.slice().sort((t, n) => {
    const r = t[M.FETCH_START], i = n[M.FETCH_START];
    return r > i ? 1 : r < i ? -1 : 0;
  });
}
function Uc() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function $c(e, t, n, r, i = /* @__PURE__ */ new WeakSet(), s) {
  const o = we(e);
  e = o.toString();
  const a = gg(e, t, n, r, i, s);
  if (a.length === 0)
    return {
      mainRequest: void 0
    };
  if (a.length === 1)
    return {
      mainRequest: a[0]
    };
  const c = hg(a);
  if (o.origin !== Uc() && c.length > 1) {
    let u = c[0], f = mg(c, u[M.RESPONSE_END], n);
    const m = u[M.RESPONSE_END];
    return f[M.FETCH_START] < m && (f = u, u = void 0), {
      corsPreFlightRequest: u,
      mainRequest: f
    };
  } else
    return {
      mainRequest: a[0]
    };
}
function mg(e, t, n) {
  const r = Oe(n), i = Oe(st(t));
  let s = e[1], o;
  const a = e.length;
  for (let c = 1; c < a; c++) {
    const u = e[c], f = Oe(st(u[M.FETCH_START])), m = Oe(st(u[M.RESPONSE_END])), l = r - m;
    f >= i && (!o || l < o) && (o = l, s = u);
  }
  return s;
}
function gg(e, t, n, r, i, s) {
  const o = Oe(t), a = Oe(n);
  let c = r.filter((u) => {
    const f = Oe(st(u[M.FETCH_START])), m = Oe(st(u[M.RESPONSE_END]));
    return u.initiatorType.toLowerCase() === (s || "xmlhttprequest") && u.name === e && f >= o && m <= a;
  });
  return c.length > 0 && (c = c.filter((u) => !i.has(u))), c;
}
function we(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  const t = fg();
  return t.href = e, t;
}
function jc(e, t) {
  let n = t || [];
  return (typeof n == "string" || n instanceof RegExp) && (n = [n]), we(e).origin === Uc() ? !0 : n.some((i) => Wi(e, i));
}
var Un;
(function(e) {
  e.COMPONENT = "component", e.HTTP_STATUS_TEXT = "http.status_text";
})(Un || (Un = {}));
const _g = "http.host", bg = "http.method", vg = "http.request.body.size", Eg = "http.request_content_length_uncompressed", Sg = "http.scheme", Tg = "http.status_code", yg = "http.url", wg = "http.user_agent", Bc = R.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Ag(...e) {
  if (e[0] instanceof URL || typeof e[0] == "string") {
    const t = e[1];
    if (!(t != null && t.body))
      return Promise.resolve();
    if (t.body instanceof ReadableStream) {
      const { body: n, length: r } = Og(t.body);
      return t.body = n, r;
    } else
      return Promise.resolve(Pg(t.body));
  } else {
    const t = e[0];
    return t != null && t.body ? t.clone().text().then((n) => hi(n)) : Promise.resolve();
  }
}
function Og(e) {
  if (!e.pipeThrough)
    return Bc.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  let t = 0, n;
  const r = new Promise((o) => {
    n = o;
  }), i = new TransformStream({
    start() {
    },
    transform(o, a) {
      return tn(this, null, function* () {
        const c = yield o;
        t += c.byteLength, a.enqueue(o);
      });
    },
    flush() {
      n(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: r
  };
}
function Rg(e) {
  return typeof Document != "undefined" && e instanceof Document;
}
function Pg(e) {
  if (Rg(e))
    return new XMLSerializer().serializeToString(document).length;
  if (typeof e == "string")
    return hi(e);
  if (e instanceof Blob)
    return e.size;
  if (e instanceof FormData)
    return Cg(e);
  if (e instanceof URLSearchParams)
    return hi(e.toString());
  if (e.byteLength !== void 0)
    return e.byteLength;
  Bc.warn("unknown body type");
}
const Ig = new TextEncoder();
function hi(e) {
  return Ig.encode(e).byteLength;
}
function Cg(e) {
  let t = 0;
  for (const [n, r] of e.entries())
    t += n.length, r instanceof Blob ? t += r.size : t += r.length;
  return t;
}
function Ng(e) {
  const t = Lg(), n = e.toUpperCase();
  return n in t ? n : "_OTHER";
}
const xg = {
  CONNECT: !0,
  DELETE: !0,
  GET: !0,
  HEAD: !0,
  OPTIONS: !0,
  PATCH: !0,
  POST: !0,
  PUT: !0,
  TRACE: !0,
  // QUERY from https://datatracker.ietf.org/doc/draft-ietf-httpbis-safe-method-w-body/
  QUERY: !0
};
let Wr;
function Lg() {
  return Wr === void 0 && (Wr = xg), Wr;
}
const Mg = {
  "https:": "443",
  "http:": "80"
};
function kg(e) {
  const t = Number(e.port || Mg[e.protocol]);
  if (t && !isNaN(t))
    return t;
}
const co = "0.213.0", Dg = 300, uo = typeof PerformanceObserver != "undefined";
class Ug extends kc {
  constructor(n = {}) {
    super("@opentelemetry/instrumentation-fetch", co, n);
    _(this, "component", "fetch");
    _(this, "version", co);
    _(this, "moduleName", this.component);
    _(this, "_usedResources", /* @__PURE__ */ new WeakSet());
    _(this, "_tasksCount", 0);
    _(this, "_semconvStability");
    this._semconvStability = Dc("http", n == null ? void 0 : n.semconvStabilityOptIn);
  }
  init() {
  }
  /**
   * Add cors pre flight child span
   * @param span
   * @param corsPreFlightRequest
   */
  _addChildSpan(n, r) {
    const i = this.tracer.startSpan("CORS Preflight", {
      startTime: r[M.FETCH_START]
    }, V.setSpan(j.active(), n)), s = !(this._semconvStability & $.OLD);
    Dn(i, r, this.getConfig().ignoreNetworkEvents, void 0, s), i.end(r[M.RESPONSE_END]);
  }
  /**
   * Adds more attributes to span just before ending it
   * @param span
   * @param response
   */
  _addFinalSpanAttributes(n, r) {
    const i = we(r.url);
    if (this._semconvStability & $.OLD && (n.setAttribute(Tg, r.status), r.statusText != null && n.setAttribute(Un.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(_g, i.host), n.setAttribute(Sg, i.protocol.replace(":", "")), typeof navigator != "undefined" && n.setAttribute(wg, navigator.userAgent)), this._semconvStability & $.STABLE) {
      n.setAttribute(ja, r.status), n.setAttribute(Ba, i.hostname);
      const s = kg(i);
      s && n.setAttribute(Fa, s);
    }
  }
  /**
   * Add headers
   * @param options
   * @param spanUrl
   */
  _addHeaders(n, r) {
    if (!jc(r, this.getConfig().propagateTraceHeaderCorsUrls)) {
      const i = {};
      Z.inject(j.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
      return;
    }
    if (n instanceof Request)
      Z.inject(j.active(), n.headers, {
        set: (i, s, o) => i.set(s, typeof o == "string" ? o : String(o))
      });
    else {
      const i = new Headers(n.headers);
      Z.inject(j.active(), i, {
        set: (s, o, a) => s.set(o, typeof a == "string" ? a : String(a))
      }), n.headers = i;
    }
  }
  /**
   * Clears the resource timings and all resources assigned with spans
   *     when {@link FetchPluginConfig.clearTimingResources} is
   *     set to true (default false)
   * @private
   */
  _clearResources() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
  /**
   * Creates a new span
   * @param url
   * @param options
   */
  _createSpan(n, r = {}) {
    if (Xi(n, this.getConfig().ignoreUrls)) {
      this._diag.debug("ignoring span as url matches ignored url");
      return;
    }
    let i = "";
    const s = {};
    if (this._semconvStability & $.OLD) {
      const o = (r.method || "GET").toUpperCase();
      i = `HTTP ${o}`, s[Un.COMPONENT] = this.moduleName, s[bg] = o, s[yg] = n;
    }
    if (this._semconvStability & $.STABLE) {
      const o = r.method, a = Ng(r.method || "GET");
      i || (i = a), s[Ua] = a, a !== o && (s[$a] = o), s[Ga] = n;
    }
    return this.tracer.startSpan(i, {
      kind: Bt.CLIENT,
      attributes: s
    });
  }
  /**
   * Finds appropriate resource and add network events to the span
   * @param span
   * @param resourcesObserver
   * @param endTime
   */
  _findResourceAndAddNetworkEvents(n, r, i) {
    let s = r.entries;
    if (!s.length) {
      if (!performance.getEntriesByType)
        return;
      s = performance.getEntriesByType("resource");
    }
    const o = $c(r.spanUrl, r.startTime, i, s, this._usedResources, "fetch");
    if (o.mainRequest) {
      const a = o.mainRequest;
      this._markResourceAsUsed(a);
      const c = o.corsPreFlightRequest;
      c && (this._addChildSpan(n, c), this._markResourceAsUsed(c));
      const u = !(this._semconvStability & $.OLD);
      Dn(n, a, this.getConfig().ignoreNetworkEvents, void 0, u);
    }
  }
  /**
   * Marks certain [resource]{@link PerformanceResourceTiming} when information
   * from this is used to add events to span.
   * This is done to avoid reusing the same resource again for next span
   * @param resource
   */
  _markResourceAsUsed(n) {
    this._usedResources.add(n);
  }
  /**
   * Finish span, add attributes, network events etc.
   * @param span
   * @param spanData
   * @param response
   */
  _endSpan(n, r, i) {
    const s = ft(Date.now()), o = pt();
    this._addFinalSpanAttributes(n, i), this._semconvStability & $.STABLE && i.status >= 400 && (n.setStatus({ code: he.ERROR }), n.setAttribute(si, String(i.status))), setTimeout(() => {
      var a;
      (a = r.observer) == null || a.disconnect(), this._findResourceAndAddNetworkEvents(n, r, o), this._tasksCount--, this._clearResources(), n.end(s);
    }, Dg);
  }
  /**
   * Patches the constructor of fetch
   */
  _patchConstructor() {
    return (n) => {
      const r = this, i = /* @__PURE__ */ new Set(["url", "type", "redirected"]);
      function s(o, a) {
        return new Proxy(o, {
          get(c, u, f) {
            if (typeof u == "string" && i.has(u))
              return Reflect.get(a, u);
            if (u === "clone")
              return function() {
                return s(c.clone(), a);
              };
            const m = Reflect.get(c, u, c);
            return typeof m == "function" ? m.bind(c) : m;
          }
        });
      }
      return function(...a) {
        const c = this, u = we(a[0] instanceof Request ? a[0].url : String(a[0])).href, f = a[0] instanceof Request ? a[0] : a[1] || {}, m = r._createSpan(u, f);
        if (!m)
          return n.apply(this, a);
        const l = r._prepareSpanData(u);
        r.getConfig().measureRequestSize && Ag(...a).then((y) => {
          y && (r._semconvStability & $.OLD && m.setAttribute(Eg, y), r._semconvStability & $.STABLE && m.setAttribute(vg, y));
        }).catch((y) => {
          r._diag.warn("getFetchBodyLength", y);
        });
        function d(y, v) {
          r._applyAttributesAfterFetch(y, f, v), r._endSpan(y, l, {
            status: v.status || 0,
            statusText: v.message,
            url: u
          });
        }
        function p(y, v) {
          r._applyAttributesAfterFetch(y, f, v), v.status >= 200 && v.status < 400 ? r._endSpan(y, l, v) : r._endSpan(y, l, {
            status: v.status,
            statusText: v.statusText,
            url: u
          });
        }
        function h(y, v) {
          if (!y)
            return null;
          const b = y.getReader();
          return new ReadableStream({
            pull(E) {
              return tn(this, null, function* () {
                try {
                  const { value: T, done: I } = yield b.read();
                  I ? (b.releaseLock(), E.close()) : E.enqueue(T);
                } catch (T) {
                  E.error(T), b.cancel(T).catch((I) => {
                  });
                  try {
                    b.releaseLock();
                  } catch (I) {
                  }
                }
              });
            },
            cancel(E) {
              return v.cancel(E).catch((T) => {
              }), b.cancel(E);
            }
          });
        }
        function g(y, v, b) {
          let w = null;
          try {
            const T = b.clone().body;
            if (T) {
              const I = T.getReader(), se = /* 101 responses and protocol upgrading is handled internally by the browser */ b.status === 204 || b.status === 205 || b.status === 304 ? null : h(b.body, I), Ne = new Response(se, {
                status: b.status,
                statusText: b.statusText,
                headers: b.headers
              });
              w = s(Ne, b);
              const Ee = () => {
                I.read().then(({ done: te }) => {
                  te ? p(y, b) : Ee();
                }, (te) => {
                  d(y, te);
                });
              };
              Ee();
            } else
              p(y, b);
          } finally {
            v(w != null ? w : b);
          }
        }
        function S(y, v, b) {
          try {
            d(y, b);
          } finally {
            v(b);
          }
        }
        return new Promise((y, v) => j.with(V.setSpan(j.active(), m), () => (r._callRequestHook(m, f), r._addHeaders(f, u), r._tasksCount++, n.apply(c, f instanceof Request ? [f] : [u, f]).then(g.bind(c, m, y), S.bind(c, m, v)))));
      };
    };
  }
  _applyAttributesAfterFetch(n, r, i) {
    const s = this.getConfig().applyCustomAttributesOnSpan;
    s && fi(() => s(n, r, i), (o) => {
      o && this._diag.error("applyCustomAttributesOnSpan", o);
    }, !0);
  }
  _callRequestHook(n, r) {
    const i = this.getConfig().requestHook;
    i && fi(() => i(n, r), (s) => {
      s && this._diag.error("requestHook", s);
    }, !0);
  }
  /**
   * Prepares a span data - needed later for matching appropriate network
   *     resources
   * @param spanUrl
   */
  _prepareSpanData(n) {
    const r = pt(), i = [];
    if (typeof PerformanceObserver != "function")
      return { entries: i, startTime: r, spanUrl: n };
    const s = new PerformanceObserver((o) => {
      o.getEntries().forEach((c) => {
        c.initiatorType === "fetch" && c.name === n && i.push(c);
      });
    });
    return s.observe({
      entryTypes: ["resource"]
    }), { entries: i, observer: s, startTime: r, spanUrl: n };
  }
  /**
   * implements enable function
   */
  enable() {
    if (!uo) {
      this._diag.warn("this instrumentation is intended for web usage only, it does not instrument server-side fetch()");
      return;
    }
    pi(fetch) && (this._unwrap(globalThis, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(globalThis, "fetch", this._patchConstructor());
  }
  /**
   * implements unpatch function
   */
  disable() {
    uo && (this._unwrap(globalThis, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
}
const $g = "http.host", jg = "http.method", Bg = "http.request.body.size", Fg = "http.request_content_length_uncompressed", Vg = "http.scheme", Hg = "http.status_code", Gg = "http.url", zg = "http.user_agent";
var ye;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(ye || (ye = {}));
const qg = R.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Kg(e) {
  return typeof Document != "undefined" && e instanceof Document;
}
function Wg(e) {
  if (Kg(e))
    return new XMLSerializer().serializeToString(document).length;
  if (typeof e == "string")
    return lo(e);
  if (e instanceof Blob)
    return e.size;
  if (e instanceof FormData)
    return Yg(e);
  if (e instanceof URLSearchParams)
    return lo(e.toString());
  if (e.byteLength !== void 0)
    return e.byteLength;
  qg.warn("unknown body type");
}
const Xg = new TextEncoder();
function lo(e) {
  return Xg.encode(e).byteLength;
}
function Yg(e) {
  let t = 0;
  for (const [n, r] of e.entries())
    t += n.length, r instanceof Blob ? t += r.size : t += r.length;
  return t;
}
function Qg(e) {
  const t = Zg(), n = e.toUpperCase();
  return n in t ? n : "_OTHER";
}
const Jg = {
  CONNECT: !0,
  DELETE: !0,
  GET: !0,
  HEAD: !0,
  OPTIONS: !0,
  PATCH: !0,
  POST: !0,
  PUT: !0,
  TRACE: !0,
  // QUERY from https://datatracker.ietf.org/doc/draft-ietf-httpbis-safe-method-w-body/
  QUERY: !0
};
let Xr;
function Zg() {
  return Xr === void 0 && (Xr = Jg), Xr;
}
const e_ = {
  "https:": "443",
  "http:": "80"
};
function t_(e) {
  const t = Number(e.port || e_[e.protocol]);
  if (t && !isNaN(t))
    return t;
}
const fo = "0.213.0";
var mi;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(mi || (mi = {}));
const n_ = 300;
class r_ extends kc {
  constructor(n = {}) {
    super("@opentelemetry/instrumentation-xml-http-request", fo, n);
    _(this, "component", "xml-http-request");
    _(this, "version", fo);
    _(this, "moduleName", this.component);
    _(this, "_tasksCount", 0);
    _(this, "_xhrMem", /* @__PURE__ */ new WeakMap());
    _(this, "_usedResources", /* @__PURE__ */ new WeakSet());
    _(this, "_semconvStability");
    this._semconvStability = Dc("http", n == null ? void 0 : n.semconvStabilityOptIn);
  }
  init() {
  }
  /**
   * Adds custom headers to XMLHttpRequest
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addHeaders(n, r) {
    const i = we(r).href;
    if (!jc(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
      const o = {};
      Z.inject(j.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
      return;
    }
    const s = {};
    Z.inject(j.active(), s), Object.keys(s).forEach((o) => {
      n.setRequestHeader(o, String(s[o]));
    });
  }
  /**
   * Add cors pre flight child span
   * @param span
   * @param corsPreFlightRequest
   * @private
   */
  _addChildSpan(n, r) {
    j.with(V.setSpan(j.active(), n), () => {
      const i = this.tracer.startSpan("CORS Preflight", {
        startTime: r[M.FETCH_START]
      }), s = !(this._semconvStability & $.OLD);
      Dn(i, r, this.getConfig().ignoreNetworkEvents, void 0, s), i.end(r[M.RESPONSE_END]);
    });
  }
  /**
   * Add attributes when span is going to end
   * @param span
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addFinalSpanAttributes(n, r, i) {
    if (this._semconvStability & $.OLD) {
      if (r.status !== void 0 && n.setAttribute(Hg, r.status), r.statusText !== void 0 && n.setAttribute(mi.HTTP_STATUS_TEXT, r.statusText), typeof i == "string") {
        const s = we(i);
        n.setAttribute($g, s.host), n.setAttribute(Vg, s.protocol.replace(":", ""));
      }
      n.setAttribute(zg, navigator.userAgent);
    }
    this._semconvStability & $.STABLE && r.status && n.setAttribute(ja, r.status);
  }
  _applyAttributesAfterXHR(n, r) {
    const i = this.getConfig().applyCustomAttributesOnSpan;
    typeof i == "function" && fi(() => i(n, r), (s) => {
      s && this._diag.error("applyCustomAttributesOnSpan", s);
    }, !0);
  }
  /**
   * will collect information about all resources created
   * between "send" and "end" with additional waiting for main resource
   * @param xhr
   * @param spanUrl
   * @private
   */
  _addResourceObserver(n, r) {
    const i = this._xhrMem.get(n);
    !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
      observer: new PerformanceObserver((s) => {
        const o = s.getEntries(), a = we(r);
        o.forEach((c) => {
          c.initiatorType === "xmlhttprequest" && c.name === a.href && i.createdResources && i.createdResources.entries.push(c);
        });
      }),
      entries: []
    }, i.createdResources.observer.observe({
      entryTypes: ["resource"]
    }));
  }
  /**
   * Clears the resource timings and all resources assigned with spans
   *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
   *     set to true (default false)
   * @private
   */
  _clearResources() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (qe.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }
  /**
   * Finds appropriate resource and add network events to the span
   * @param span
   */
  _findResourceAndAddNetworkEvents(n, r, i, s, o) {
    if (!i || !s || !o || !n.createdResources)
      return;
    let a = n.createdResources.entries;
    (!a || !a.length) && (a = qe.getEntriesByType("resource"));
    const c = $c(we(i).href, s, o, a, this._usedResources);
    if (c.mainRequest) {
      const u = c.mainRequest;
      this._markResourceAsUsed(u);
      const f = c.corsPreFlightRequest;
      f && (this._addChildSpan(r, f), this._markResourceAsUsed(f));
      const m = !(this._semconvStability & $.OLD);
      Dn(r, u, this.getConfig().ignoreNetworkEvents, void 0, m);
    }
  }
  /**
   * Removes the previous information about span.
   * This might happened when the same xhr is used again.
   * @param xhr
   * @private
   */
  _cleanPreviousSpanInformation(n) {
    const r = this._xhrMem.get(n);
    if (r) {
      const i = r.callbackToRemoveEvents;
      i && i(), this._xhrMem.delete(n);
    }
  }
  /**
   * Creates a new span when method "open" is called
   * @param xhr
   * @param url
   * @param method
   * @private
   */
  _createSpan(n, r, i) {
    if (Xi(r, this.getConfig().ignoreUrls)) {
      this._diag.debug("ignoring span as url matches ignored url");
      return;
    }
    let s = "";
    const o = we(r), a = {};
    if (this._semconvStability & $.OLD && (s = i.toUpperCase(), a[jg] = i, a[Gg] = o.toString()), this._semconvStability & $.STABLE) {
      const u = i, f = Qg(i);
      s || (s = f), a[Ua] = f, f !== u && (a[$a] = u), a[Ga] = o.toString(), a[Ba] = o.hostname;
      const m = t_(o);
      m && (a[Fa] = m);
    }
    const c = this.tracer.startSpan(s, {
      kind: Bt.CLIENT,
      attributes: a
    });
    return c.addEvent(ye.METHOD_OPEN), this._cleanPreviousSpanInformation(n), this._xhrMem.set(n, {
      span: c,
      spanUrl: r
    }), c;
  }
  /**
   * Marks certain [resource]{@link PerformanceResourceTiming} when information
   * from this is used to add events to span.
   * This is done to avoid reusing the same resource again for next span
   * @param resource
   * @private
   */
  _markResourceAsUsed(n) {
    this._usedResources.add(n);
  }
  /**
   * Patches the method open
   * @private
   */
  _patchOpen() {
    return (n) => {
      const r = this;
      return function(...s) {
        const o = s[0], a = s[1];
        return r._createSpan(this, a, o), n.apply(this, s);
      };
    };
  }
  /**
   * Patches the method send
   * @private
   */
  _patchSend() {
    const n = this;
    function r(f, m, l, d) {
      const p = m.callbackToRemoveEvents;
      typeof p == "function" && p();
      const { span: h, spanUrl: g, sendStartTime: S } = m;
      h && (n._findResourceAndAddNetworkEvents(m, h, g, S, l), h.addEvent(f, d), n._addFinalSpanAttributes(h, m, g), h.end(d), n._tasksCount--), n._clearResources();
    }
    function i(f, m, l, d) {
      const p = n._xhrMem.get(m);
      if (!p)
        return;
      if (p.status = m.status, p.statusText = m.statusText, n._xhrMem.delete(m), p.span) {
        const S = p.span;
        n._applyAttributesAfterXHR(S, m), n._semconvStability & $.STABLE && (l ? d && (S.setStatus({
          code: he.ERROR,
          message: d
        }), S.setAttribute(si, d)) : p.status && p.status >= 400 && (S.setStatus({ code: he.ERROR }), S.setAttribute(si, String(p.status))));
      }
      const h = pt(), g = Date.now();
      setTimeout(() => {
        r(f, p, h, g);
      }, n_);
    }
    function s() {
      i(ye.EVENT_ERROR, this, !0, "error");
    }
    function o() {
      i(ye.EVENT_ABORT, this, !1);
    }
    function a() {
      i(ye.EVENT_TIMEOUT, this, !0, "timeout");
    }
    function c() {
      this.status < 299 ? i(ye.EVENT_LOAD, this, !1) : i(ye.EVENT_ERROR, this, !1);
    }
    function u(f) {
      f.removeEventListener("abort", o), f.removeEventListener("error", s), f.removeEventListener("load", c), f.removeEventListener("timeout", a);
      const m = n._xhrMem.get(f);
      m && (m.callbackToRemoveEvents = void 0);
    }
    return (f) => function(...l) {
      const d = n._xhrMem.get(this);
      if (!d)
        return f.apply(this, l);
      const p = d.span, h = d.spanUrl;
      if (p && h) {
        if (n.getConfig().measureRequestSize && (l != null && l[0])) {
          const g = l[0], S = Wg(g);
          S !== void 0 && (n._semconvStability & $.OLD && p.setAttribute(Fg, S), n._semconvStability & $.STABLE && p.setAttribute(Bg, S));
        }
        j.with(V.setSpan(j.active(), p), () => {
          n._tasksCount++, d.sendStartTime = pt(), p.addEvent(ye.METHOD_SEND), this.addEventListener("abort", o), this.addEventListener("error", s), this.addEventListener("load", c), this.addEventListener("timeout", a), d.callbackToRemoveEvents = () => {
            u(this), d.createdResources && d.createdResources.observer.disconnect();
          }, n._addHeaders(this, h), n._addResourceObserver(this, h);
        });
      }
      return f.apply(this, l);
    };
  }
  /**
   * implements enable function
   */
  enable() {
    this._diag.debug("applying patch to", this.moduleName, this.version), pi(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), pi(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
  }
  /**
   * implements disable function
   */
  disable() {
    this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
  }
}
class i_ extends r_ {
  constructor(t = {}) {
    super(t);
    const n = this;
    this.parentCreateSpan = n._createSpan.bind(this);
  }
  // Patching the parent's private method to handle url type string or URL
  _patchOpen() {
    return (t) => {
      const n = this;
      return function(...i) {
        let s;
        try {
          const a = i[0];
          let c = Yo(i[1]);
          s = n.parentCreateSpan(this, c, a);
        } catch (a) {
          U.internalLogger.error(a);
        }
        const o = U.api.getActiveUserAction();
        return s && o && (o == null ? void 0 : o.getState()) === k.Started && (s.setAttribute("faro.action.user.name", o.name), s.setAttribute("faro.action.user.parentId", o.parentId)), t.apply(this, i);
      };
    };
  }
}
function s_(e, t, n) {
  const r = n instanceof Error ? 0 : n.status;
  Fc(e, r);
}
function o_(e, t) {
  Fc(e, t.status);
}
function Fc(e, t) {
  if (t == null)
    return;
  const n = t === 0, r = t >= 400 && t < 600;
  (n || r) && e.setStatus({ code: he.ERROR });
}
function a_(e) {
  return (t, n, r) => {
    s_(t, n, r), e == null || e(t, n, r);
  };
}
function c_(e) {
  return (t, n) => {
    o_(t, n), e == null || e(t, n);
  };
}
var u_ = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function l_(e = {}) {
  const { fetchInstrumentationOptions: t, xhrInstrumentationOptions: n } = e, r = u_(e, ["fetchInstrumentationOptions", "xhrInstrumentationOptions"]), i = d_(t, r), s = f_(n, r);
  return [new Ug(i), new i_(s)];
}
function d_(e, t) {
  return Object.assign(Object.assign(Object.assign(Object.assign({}, t), { ignoreNetworkEvents: !0 }), e), {
    // always keep this function
    applyCustomAttributesOnSpan: a_(e == null ? void 0 : e.applyCustomAttributesOnSpan),
    requestHook: (n, r) => {
      const i = U.api.getActiveUserAction();
      i && (i == null ? void 0 : i.getState()) === k.Started && (n.setAttribute("faro.action.user.name", i.name), n.setAttribute("faro.action.user.parentId", i.parentId));
    }
  });
}
function f_(e, t) {
  return Object.assign(Object.assign(Object.assign(Object.assign({}, t), { ignoreNetworkEvents: !0 }), e), {
    // always keep this function
    applyCustomAttributesOnSpan: c_(e == null ? void 0 : e.applyCustomAttributesOnSpan)
  });
}
let mn;
function p_() {
  if (mn === void 0)
    try {
      const e = globalThis.process.argv0;
      mn = e ? `unknown_service:${e}` : "unknown_service";
    } catch (e) {
      mn = "unknown_service";
    }
  return mn;
}
const kt = (e) => e !== null && typeof e == "object" && typeof e.then == "function";
class $n {
  constructor(t, n) {
    _(this, "_rawAttributes");
    _(this, "_asyncAttributesPending", !1);
    _(this, "_schemaUrl");
    _(this, "_memoizedAttributes");
    var i;
    const r = (i = t.attributes) != null ? i : {};
    this._rawAttributes = Object.entries(r).map(([s, o]) => (kt(o) && (this._asyncAttributesPending = !0), [s, o])), this._rawAttributes = po(this._rawAttributes), this._schemaUrl = h_(n == null ? void 0 : n.schemaUrl);
  }
  static FromAttributeList(t, n) {
    const r = new $n({}, n);
    return r._rawAttributes = po(t), r._asyncAttributesPending = t.filter(([i, s]) => kt(s)).length > 0, r;
  }
  get asyncAttributesPending() {
    return this._asyncAttributesPending;
  }
  waitForAsyncAttributes() {
    return tn(this, null, function* () {
      if (this.asyncAttributesPending) {
        for (let t = 0; t < this._rawAttributes.length; t++) {
          const [n, r] = this._rawAttributes[t];
          this._rawAttributes[t] = [n, kt(r) ? yield r : r];
        }
        this._asyncAttributesPending = !1;
      }
    });
  }
  get attributes() {
    var n;
    if (this.asyncAttributesPending && R.error("Accessing resource attributes before async attributes settled"), this._memoizedAttributes)
      return this._memoizedAttributes;
    const t = {};
    for (const [r, i] of this._rawAttributes) {
      if (kt(i)) {
        R.debug(`Unsettled resource attribute ${r} skipped`);
        continue;
      }
      i != null && ((n = t[r]) != null || (t[r] = i));
    }
    return this._asyncAttributesPending || (this._memoizedAttributes = t), t;
  }
  getRawAttributes() {
    return this._rawAttributes;
  }
  get schemaUrl() {
    return this._schemaUrl;
  }
  merge(t) {
    if (t == null)
      return this;
    const n = m_(this, t), r = n ? { schemaUrl: n } : void 0;
    return $n.FromAttributeList([...t.getRawAttributes(), ...this.getRawAttributes()], r);
  }
}
function Vc(e, t) {
  return $n.FromAttributeList(Object.entries(e), t);
}
function Hc() {
  return Vc({
    [Va]: p_(),
    [Rn]: Fr[Rn],
    [Pn]: Fr[Pn],
    [In]: Fr[In]
  });
}
function po(e) {
  return e.map(([t, n]) => kt(n) ? [
    t,
    n.catch((r) => {
      R.debug("promise rejection for resource attribute: %s - %s", t, r);
    })
  ] : [t, n]);
}
function h_(e) {
  if (typeof e == "string" || e === void 0)
    return e;
  R.warn("Schema URL must be string or undefined, got %s. Schema URL will be ignored.", e);
}
function m_(e, t) {
  const n = e == null ? void 0 : e.schemaUrl, r = t == null ? void 0 : t.schemaUrl, i = n === void 0 || n === "", s = r === void 0 || r === "";
  if (i)
    return r;
  if (s || n === r)
    return n;
  R.warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', n, r);
}
const g_ = "exception";
class __ {
  /**
   * Constructs a new SpanImpl instance.
   */
  constructor(t) {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _(this, "_spanContext");
    _(this, "kind");
    _(this, "parentSpanContext");
    _(this, "attributes", {});
    _(this, "links", []);
    _(this, "events", []);
    _(this, "startTime");
    _(this, "resource");
    _(this, "instrumentationScope");
    _(this, "_droppedAttributesCount", 0);
    _(this, "_droppedEventsCount", 0);
    _(this, "_droppedLinksCount", 0);
    _(this, "_attributesCount", 0);
    _(this, "name");
    _(this, "status", {
      code: he.UNSET
    });
    _(this, "endTime", [0, 0]);
    _(this, "_ended", !1);
    _(this, "_duration", [-1, -1]);
    _(this, "_spanProcessor");
    _(this, "_spanLimits");
    _(this, "_attributeValueLengthLimit");
    _(this, "_recordEndMetrics");
    _(this, "_performanceStartTime");
    _(this, "_performanceOffset");
    _(this, "_startTimeProvided");
    var r, i;
    const n = Date.now();
    if (this._spanContext = t.spanContext, this._performanceStartTime = nt.now(), this._performanceOffset = n - (this._performanceStartTime + nt.timeOrigin), this._startTimeProvided = t.startTime != null, this._spanLimits = t.spanLimits, this._attributeValueLengthLimit = (r = this._spanLimits.attributeValueLengthLimit) != null ? r : 0, this._spanProcessor = t.spanProcessor, this.name = t.name, this.parentSpanContext = t.parentSpanContext, this.kind = t.kind, t.links)
      for (const s of t.links)
        this.addLink(s);
    this.startTime = this._getTime((i = t.startTime) != null ? i : n), this.resource = t.resource, this.instrumentationScope = t.scope, this._recordEndMetrics = t.recordEndMetrics, t.attributes != null && this.setAttributes(t.attributes), this._spanProcessor.onStart(this, t.context);
  }
  spanContext() {
    return this._spanContext;
  }
  setAttribute(t, n) {
    if (n == null || this._isSpanEnded())
      return this;
    if (t.length === 0)
      return R.warn(`Invalid attribute key: ${t}`), this;
    if (!ka(n))
      return R.warn(`Invalid attribute value set for key: ${t}`), this;
    const { attributeCountLimit: r } = this._spanLimits, i = !Object.prototype.hasOwnProperty.call(this.attributes, t);
    return r !== void 0 && this._attributesCount >= r && i ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(n), i && this._attributesCount++, this);
  }
  setAttributes(t) {
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && this.setAttribute(n, t[n]);
    return this;
  }
  /**
   *
   * @param name Span Name
   * @param [attributesOrStartTime] Span attributes or start time
   *     if type is {@type TimeInput} and 3rd param is undefined
   * @param [timeStamp] Specified time stamp for the event
   */
  addEvent(t, n, r) {
    if (this._isSpanEnded())
      return this;
    const { eventCountLimit: i } = this._spanLimits;
    if (i === 0)
      return R.warn("No events allowed."), this._droppedEventsCount++, this;
    i !== void 0 && this.events.length >= i && (this._droppedEventsCount === 0 && R.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Ks(n) && (Ks(r) || (r = n), n = void 0);
    const s = Ut(n), { attributePerEventCountLimit: o } = this._spanLimits, a = {};
    let c = 0, u = 0;
    for (const f in s) {
      if (!Object.prototype.hasOwnProperty.call(s, f))
        continue;
      const m = s[f];
      if (o !== void 0 && u >= o) {
        c++;
        continue;
      }
      a[f] = this._truncateToSize(m), u++;
    }
    return this.events.push({
      name: t,
      attributes: a,
      time: this._getTime(r),
      droppedAttributesCount: c
    }), this;
  }
  addLink(t) {
    if (this._isSpanEnded())
      return this;
    const { linkCountLimit: n } = this._spanLimits;
    if (n === 0)
      return this._droppedLinksCount++, this;
    n !== void 0 && this.links.length >= n && (this._droppedLinksCount === 0 && R.debug("Dropping extra links."), this.links.shift(), this._droppedLinksCount++);
    const { attributePerLinkCountLimit: r } = this._spanLimits, i = Ut(t.attributes), s = {};
    let o = 0, a = 0;
    for (const u in i) {
      if (!Object.prototype.hasOwnProperty.call(i, u))
        continue;
      const f = i[u];
      if (r !== void 0 && a >= r) {
        o++;
        continue;
      }
      s[u] = this._truncateToSize(f), a++;
    }
    const c = { context: t.context };
    return a > 0 && (c.attributes = s), o > 0 && (c.droppedAttributesCount = o), this.links.push(c), this;
  }
  addLinks(t) {
    for (const n of t)
      this.addLink(n);
    return this;
  }
  setStatus(t) {
    if (this._isSpanEnded())
      return this;
    if (t.code === he.UNSET)
      return this;
    if (this.status.code === he.OK)
      return this;
    const n = { code: t.code };
    return t.code === he.ERROR && (typeof t.message == "string" ? n.message = t.message : t.message != null && R.warn(`Dropping invalid status.message of type '${typeof t.message}', expected 'string'`)), this.status = n, this;
  }
  updateName(t) {
    return this._isSpanEnded() ? this : (this.name = t, this);
  }
  end(t) {
    var n;
    if (this._isSpanEnded()) {
      R.error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
      return;
    }
    this.endTime = this._getTime(t), this._duration = Fp(this.startTime, this.endTime), this._duration[0] < 0 && (R.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && R.warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`), this._droppedLinksCount > 0 && R.warn(`Dropped ${this._droppedLinksCount} links because linkCountLimit reached`), this._spanProcessor.onEnding && this._spanProcessor.onEnding(this), (n = this._recordEndMetrics) == null || n.call(this), this._ended = !0, this._spanProcessor.onEnd(this);
  }
  _getTime(t) {
    if (typeof t == "number" && t <= nt.now())
      return Bp(t + this._performanceOffset);
    if (typeof t == "number")
      return rt(t);
    if (t instanceof Date)
      return rt(t.getTime());
    if (za(t))
      return t;
    if (this._startTimeProvided)
      return rt(Date.now());
    const n = nt.now() - this._performanceStartTime;
    return qa(this.startTime, rt(n));
  }
  isRecording() {
    return this._ended === !1;
  }
  recordException(t, n) {
    const r = {};
    typeof t == "string" ? r[jr] = t : t && (t.code ? r[Br] = t.code.toString() : t.name && (r[Br] = t.name), t.message && (r[jr] = t.message), t.stack && (r[Lp] = t.stack)), r[Br] || r[jr] ? this.addEvent(g_, r, n) : R.warn(`Failed to record an exception ${t}`);
  }
  get duration() {
    return this._duration;
  }
  get ended() {
    return this._ended;
  }
  get droppedAttributesCount() {
    return this._droppedAttributesCount;
  }
  get droppedEventsCount() {
    return this._droppedEventsCount;
  }
  get droppedLinksCount() {
    return this._droppedLinksCount;
  }
  _isSpanEnded() {
    if (this._ended) {
      const t = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
      R.warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, t);
    }
    return this._ended;
  }
  // Utility function to truncate given value within size
  // for value type of string, will truncate to given limit
  // for type of non-string, will return same value
  _truncateToLimitUtil(t, n) {
    return t.length <= n ? t : t.substring(0, n);
  }
  /**
   * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
   * return string with truncated to {@code attributeValueLengthLimit} characters
   *
   * If the given attribute value is array of strings then
   * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
   *
   * Otherwise return same Attribute {@code value}
   *
   * @param value Attribute value
   * @returns truncated attribute value if required, otherwise same value
   */
  _truncateToSize(t) {
    const n = this._attributeValueLengthLimit;
    return n <= 0 ? (R.warn(`Attribute value limit must be positive, got ${n}`), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map((r) => typeof r == "string" ? this._truncateToLimitUtil(r, n) : r) : t;
  }
}
var re;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(re || (re = {}));
class jn {
  shouldSample() {
    return {
      decision: re.NOT_RECORD
    };
  }
  toString() {
    return "AlwaysOffSampler";
  }
}
class ot {
  shouldSample() {
    return {
      decision: re.RECORD_AND_SAMPLED
    };
  }
  toString() {
    return "AlwaysOnSampler";
  }
}
class gn {
  constructor(t) {
    _(this, "_root");
    _(this, "_remoteParentSampled");
    _(this, "_remoteParentNotSampled");
    _(this, "_localParentSampled");
    _(this, "_localParentNotSampled");
    var n, r, i, s;
    this._root = t.root, this._root || (dt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new ot()), this._remoteParentSampled = (n = t.remoteParentSampled) != null ? n : new ot(), this._remoteParentNotSampled = (r = t.remoteParentNotSampled) != null ? r : new jn(), this._localParentSampled = (i = t.localParentSampled) != null ? i : new ot(), this._localParentNotSampled = (s = t.localParentNotSampled) != null ? s : new jn();
  }
  shouldSample(t, n, r, i, s, o) {
    const a = V.getSpanContext(t);
    return !a || !Jt(a) ? this._root.shouldSample(t, n, r, i, s, o) : a.isRemote ? a.traceFlags & be.SAMPLED ? this._remoteParentSampled.shouldSample(t, n, r, i, s, o) : this._remoteParentNotSampled.shouldSample(t, n, r, i, s, o) : a.traceFlags & be.SAMPLED ? this._localParentSampled.shouldSample(t, n, r, i, s, o) : this._localParentNotSampled.shouldSample(t, n, r, i, s, o);
  }
  toString() {
    return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
  }
}
class ho {
  constructor(t = 0) {
    _(this, "_ratio");
    _(this, "_upperBound");
    this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
  }
  shouldSample(t, n) {
    return {
      decision: Ia(n) && this._accumulate(n) < this._upperBound ? re.RECORD_AND_SAMPLED : re.NOT_RECORD
    };
  }
  toString() {
    return `TraceIdRatioBased{${this._ratio}}`;
  }
  _normalize(t) {
    return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
  }
  _accumulate(t) {
    let n = 0;
    for (let r = 0; r < t.length / 8; r++) {
      const i = r * 8, s = parseInt(t.slice(i, i + 8), 16);
      n = (n ^ s) >>> 0;
    }
    return n;
  }
}
var fe;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(fe || (fe = {}));
const mo = 1;
function Gc() {
  return {
    sampler: zc(),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: 1 / 0,
      attributeCountLimit: 128
    },
    spanLimits: {
      attributeValueLengthLimit: 1 / 0,
      attributeCountLimit: 128,
      linkCountLimit: 128,
      eventCountLimit: 128,
      attributePerEventCountLimit: 128,
      attributePerLinkCountLimit: 128
    }
  };
}
function zc() {
  const e = fe.ParentBasedAlwaysOn;
  switch (e) {
    case fe.AlwaysOn:
      return new ot();
    case fe.AlwaysOff:
      return new jn();
    case fe.ParentBasedAlwaysOn:
      return new gn({
        root: new ot()
      });
    case fe.ParentBasedAlwaysOff:
      return new gn({
        root: new jn()
      });
    case fe.TraceIdRatio:
      return new ho(go());
    case fe.ParentBasedTraceIdRatio:
      return new gn({
        root: new ho(go())
      });
    default:
      return R.error(`OTEL_TRACES_SAMPLER value "${e}" invalid, defaulting to "${fe.ParentBasedAlwaysOn}".`), new gn({
        root: new ot()
      });
  }
}
function go() {
  return R.error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${mo}.`), mo;
}
const b_ = 128, v_ = 1 / 0;
function E_(e) {
  const t = {
    sampler: zc()
  }, n = Gc(), r = Object.assign({}, n, t, e);
  return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
}
function S_(e) {
  var n, r, i, s, o, a, c, u, f, m, l, d;
  const t = Object.assign({}, e.spanLimits);
  return t.attributeCountLimit = (a = (o = (s = (i = (n = e.spanLimits) == null ? void 0 : n.attributeCountLimit) != null ? i : (r = e.generalLimits) == null ? void 0 : r.attributeCountLimit) != null ? s : void 0) != null ? o : void 0) != null ? a : b_, t.attributeValueLengthLimit = (d = (l = (m = (f = (c = e.spanLimits) == null ? void 0 : c.attributeValueLengthLimit) != null ? f : (u = e.generalLimits) == null ? void 0 : u.attributeValueLengthLimit) != null ? m : void 0) != null ? l : void 0) != null ? d : v_, Object.assign({}, e, { spanLimits: t });
}
class T_ {
  constructor(t, n) {
    _(this, "_maxExportBatchSize");
    _(this, "_maxQueueSize");
    _(this, "_scheduledDelayMillis");
    _(this, "_exportTimeoutMillis");
    _(this, "_exporter");
    _(this, "_isExporting", !1);
    _(this, "_finishedSpans", []);
    _(this, "_timer");
    _(this, "_shutdownOnce");
    _(this, "_droppedSpansCount", 0);
    this._exporter = t, this._maxExportBatchSize = typeof (n == null ? void 0 : n.maxExportBatchSize) == "number" ? n.maxExportBatchSize : 512, this._maxQueueSize = typeof (n == null ? void 0 : n.maxQueueSize) == "number" ? n.maxQueueSize : 2048, this._scheduledDelayMillis = typeof (n == null ? void 0 : n.scheduledDelayMillis) == "number" ? n.scheduledDelayMillis : 5e3, this._exportTimeoutMillis = typeof (n == null ? void 0 : n.exportTimeoutMillis) == "number" ? n.exportTimeoutMillis : 3e4, this._shutdownOnce = new vh(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (R.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
  }
  forceFlush() {
    return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
  }
  // does nothing.
  onStart(t, n) {
  }
  onEnd(t) {
    this._shutdownOnce.isCalled || t.spanContext().traceFlags & be.SAMPLED && this._addToBuffer(t);
  }
  shutdown() {
    return this._shutdownOnce.call();
  }
  _shutdown() {
    return Promise.resolve().then(() => this.onShutdown()).then(() => this._flushAll()).then(() => this._exporter.shutdown());
  }
  /** Add a span in the buffer. */
  _addToBuffer(t) {
    if (this._finishedSpans.length >= this._maxQueueSize) {
      this._droppedSpansCount === 0 && R.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
      return;
    }
    this._droppedSpansCount > 0 && (R.warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
  }
  /**
   * Send all spans to the exporter respecting the batch size limit
   * This function is used only on forceFlush or shutdown,
   * for all other cases _flush should be used
   * */
  _flushAll() {
    return new Promise((t, n) => {
      const r = [], i = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
      for (let s = 0, o = i; s < o; s++)
        r.push(this._flushOneBatch());
      Promise.all(r).then(() => {
        t();
      }).catch(n);
    });
  }
  _flushOneBatch() {
    return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise((t, n) => {
      const r = setTimeout(() => {
        n(new Error("Timeout"));
      }, this._exportTimeoutMillis);
      j.with(mp(j.active()), () => {
        let i;
        this._finishedSpans.length <= this._maxExportBatchSize ? (i = this._finishedSpans, this._finishedSpans = []) : i = this._finishedSpans.splice(0, this._maxExportBatchSize);
        const s = () => this._exporter.export(i, (a) => {
          var c;
          clearTimeout(r), a.code === Cn.SUCCESS ? t() : n((c = a.error) != null ? c : new Error("BatchSpanProcessor: span export failed"));
        });
        let o = null;
        for (let a = 0, c = i.length; a < c; a++) {
          const u = i[a];
          u.resource.asyncAttributesPending && u.resource.waitForAsyncAttributes && (o != null || (o = []), o.push(u.resource.waitForAsyncAttributes()));
        }
        o === null ? s() : Promise.all(o).then(s, (a) => {
          dt(a), n(a);
        });
      });
    });
  }
  _maybeStartTimer() {
    if (this._isExporting)
      return;
    const t = () => {
      this._isExporting = !0, this._flushOneBatch().finally(() => {
        this._isExporting = !1, this._finishedSpans.length > 0 && (this._clearTimer(), this._maybeStartTimer());
      }).catch((n) => {
        this._isExporting = !1, dt(n);
      });
    };
    if (this._finishedSpans.length >= this._maxExportBatchSize)
      return t();
    this._timer === void 0 && (this._timer = setTimeout(() => t(), this._scheduledDelayMillis), typeof this._timer != "number" && this._timer.unref());
  }
  _clearTimer() {
    this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
  }
}
class y_ extends T_ {
  constructor(n, r) {
    super(n, r);
    _(this, "_visibilityChangeListener");
    _(this, "_pageHideListener");
    this.onInit(r);
  }
  onInit(n) {
    (n == null ? void 0 : n.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = () => {
      document.visibilityState === "hidden" && this.forceFlush().catch((r) => {
        dt(r);
      });
    }, this._pageHideListener = () => {
      this.forceFlush().catch((r) => {
        dt(r);
      });
    }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
  }
  onShutdown() {
    typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
  }
}
const w_ = 16, A_ = 8, _o = new Uint8Array(w_), bo = new Uint8Array(A_), O_ = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function vo(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = Math.random() * 256 >>> 0;
  for (let t = 0; t < e.length; t++)
    if (e[t] > 0)
      return;
  e[e.length - 1] = 1;
}
function Eo(e) {
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += O_[e[n]];
  return t;
}
class R_ {
  /**
   * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
   * characters corresponding to 128 bits.
   */
  generateTraceId() {
    return vo(_o), Eo(_o);
  }
  /**
   * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
   * characters corresponding to 64 bits.
   */
  generateSpanId() {
    return vo(bo), Eo(bo);
  }
}
const P_ = "otel.span.parent.origin", So = "otel.span.sampling_result", I_ = "otel.sdk.span.live", C_ = "otel.sdk.span.started";
class N_ {
  constructor(t) {
    _(this, "startedSpans");
    _(this, "liveSpans");
    this.startedSpans = t.createCounter(C_, {
      unit: "{span}",
      description: "The number of created spans."
    }), this.liveSpans = t.createUpDownCounter(I_, {
      unit: "{span}",
      description: "The number of currently live spans."
    });
  }
  startSpan(t, n) {
    const r = L_(n);
    if (this.startedSpans.add(1, {
      [P_]: x_(t),
      [So]: r
    }), n === re.NOT_RECORD)
      return () => {
      };
    const i = {
      [So]: r
    };
    return this.liveSpans.add(1, i), () => {
      this.liveSpans.add(-1, i);
    };
  }
}
function x_(e) {
  return e ? e.isRemote ? "remote" : "local" : "none";
}
function L_(e) {
  switch (e) {
    case re.RECORD_AND_SAMPLED:
      return "RECORD_AND_SAMPLE";
    case re.RECORD:
      return "RECORD_ONLY";
    case re.NOT_RECORD:
      return "DROP";
  }
}
const M_ = "2.6.1";
class k_ {
  /**
   * Constructs a new Tracer instance.
   */
  constructor(t, n, r, i) {
    _(this, "_sampler");
    _(this, "_generalLimits");
    _(this, "_spanLimits");
    _(this, "_idGenerator");
    _(this, "instrumentationScope");
    _(this, "_resource");
    _(this, "_spanProcessor");
    _(this, "_tracerMetrics");
    const s = E_(n);
    this._sampler = s.sampler, this._generalLimits = s.generalLimits, this._spanLimits = s.spanLimits, this._idGenerator = n.idGenerator || new R_(), this._resource = r, this._spanProcessor = i, this.instrumentationScope = t;
    const o = s.meterProvider ? s.meterProvider.getMeter("@opentelemetry/sdk-trace", M_) : Kf();
    this._tracerMetrics = new N_(o);
  }
  /**
   * Starts a new Span or returns the default NoopSpan based on the sampling
   * decision.
   */
  startSpan(t, n = {}, r = j.active()) {
    var v, b, w;
    n.root && (r = V.deleteSpan(r));
    const i = V.getSpan(r);
    if (Hi(r))
      return R.debug("Instrumentation suppressed, returning Noop Span"), V.wrapSpanContext(Oa);
    const s = i == null ? void 0 : i.spanContext(), o = this._idGenerator.generateSpanId();
    let a, c, u;
    !s || !V.isSpanContextValid(s) ? c = this._idGenerator.generateTraceId() : (c = s.traceId, u = s.traceState, a = s);
    const f = (v = n.kind) != null ? v : Bt.INTERNAL, m = ((b = n.links) != null ? b : []).map((E) => ({
      context: E.context,
      attributes: Ut(E.attributes)
    })), l = Ut(n.attributes), d = this._sampler.shouldSample(r, c, t, f, l, m), p = this._tracerMetrics.startSpan(s, d.decision);
    u = (w = d.traceState) != null ? w : u;
    const h = d.decision === On.RECORD_AND_SAMPLED ? be.SAMPLED : be.NONE, g = { traceId: c, spanId: o, traceFlags: h, traceState: u };
    if (d.decision === On.NOT_RECORD)
      return R.debug("Recording is off, propagating context in a non-recording span"), V.wrapSpanContext(g);
    const S = Ut(Object.assign(l, d.attributes));
    return new __({
      resource: this._resource,
      scope: this.instrumentationScope,
      context: r,
      spanContext: g,
      name: t,
      kind: f,
      links: m,
      parentSpanContext: a,
      attributes: S,
      startTime: n.startTime,
      spanProcessor: this._spanProcessor,
      spanLimits: this._spanLimits,
      recordEndMetrics: p
    });
  }
  startActiveSpan(t, n, r, i) {
    let s, o, a;
    if (arguments.length < 2)
      return;
    arguments.length === 2 ? a = n : arguments.length === 3 ? (s = n, a = r) : (s = n, o = r, a = i);
    const c = o != null ? o : j.active(), u = this.startSpan(t, s, c), f = V.setSpan(c, u);
    return j.with(f, a, void 0, u);
  }
  /** Returns the active {@link GeneralLimits}. */
  getGeneralLimits() {
    return this._generalLimits;
  }
  /** Returns the active {@link SpanLimits}. */
  getSpanLimits() {
    return this._spanLimits;
  }
}
class D_ {
  constructor(t) {
    _(this, "_spanProcessors");
    this._spanProcessors = t;
  }
  forceFlush() {
    const t = [];
    for (const n of this._spanProcessors)
      t.push(n.forceFlush());
    return new Promise((n) => {
      Promise.all(t).then(() => {
        n();
      }).catch((r) => {
        dt(r || new Error("MultiSpanProcessor: forceFlush failed")), n();
      });
    });
  }
  onStart(t, n) {
    for (const r of this._spanProcessors)
      r.onStart(t, n);
  }
  onEnding(t) {
    for (const n of this._spanProcessors)
      n.onEnding && n.onEnding(t);
  }
  onEnd(t) {
    for (const n of this._spanProcessors)
      n.onEnd(t);
  }
  shutdown() {
    const t = [];
    for (const n of this._spanProcessors)
      t.push(n.shutdown());
    return new Promise((n, r) => {
      Promise.all(t).then(() => {
        n();
      }, r);
    });
  }
}
var Ve;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Ve || (Ve = {}));
class U_ {
  constructor(t = {}) {
    _(this, "_config");
    _(this, "_tracers", /* @__PURE__ */ new Map());
    _(this, "_resource");
    _(this, "_activeSpanProcessor");
    var i, s;
    const n = gh({}, Gc(), S_(t));
    this._resource = (i = n.resource) != null ? i : Hc(), this._config = Object.assign({}, n, {
      resource: this._resource
    });
    const r = [];
    (s = t.spanProcessors) != null && s.length && r.push(...t.spanProcessors), this._activeSpanProcessor = new D_(r);
  }
  getTracer(t, n, r) {
    const i = `${t}@${n || ""}:${(r == null ? void 0 : r.schemaUrl) || ""}`;
    return this._tracers.has(i) || this._tracers.set(i, new k_({ name: t, version: n, schemaUrl: r == null ? void 0 : r.schemaUrl }, this._config, this._resource, this._activeSpanProcessor)), this._tracers.get(i);
  }
  forceFlush() {
    const t = this._config.forceFlushTimeoutMillis, n = this._activeSpanProcessor._spanProcessors.map((r) => new Promise((i) => {
      let s;
      const o = setTimeout(() => {
        i(new Error(`Span processor did not completed within timeout period of ${t} ms`)), s = Ve.timeout;
      }, t);
      r.forceFlush().then(() => {
        clearTimeout(o), s !== Ve.timeout && (s = Ve.resolved, i(s));
      }).catch((a) => {
        clearTimeout(o), s = Ve.error, i(a);
      });
    }));
    return new Promise((r, i) => {
      Promise.all(n).then((s) => {
        const o = s.filter((a) => a !== Ve.resolved);
        o.length > 0 ? i(o) : r();
      }).catch((s) => i([s]));
    });
  }
  shutdown() {
    return this._activeSpanProcessor.shutdown();
  }
}
class $_ {
  constructor() {
    /**
     * whether the context manager is enabled or not
     */
    _(this, "_enabled", !1);
    /**
     * Keeps the reference to current context
     */
    _(this, "_currentContext", Ze);
  }
  /**
   *
   * @param context
   * @param target Function to be executed within the context
   */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  _bindFunction(t = Ze, n) {
    const r = this, i = function(...s) {
      return r.with(t, () => n.apply(this, s));
    };
    return Object.defineProperty(i, "length", {
      enumerable: !1,
      configurable: !0,
      writable: !1,
      value: n.length
    }), i;
  }
  /**
   * Returns the active context
   */
  active() {
    return this._currentContext;
  }
  /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */
  bind(t, n) {
    return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : n;
  }
  /**
   * Disable the context manager (clears the current context)
   */
  disable() {
    return this._currentContext = Ze, this._enabled = !1, this;
  }
  /**
   * Enables the context manager and creates a default(root) context
   */
  enable() {
    return this._enabled ? this : (this._enabled = !0, this._currentContext = Ze, this);
  }
  /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */
  with(t, n, r, ...i) {
    const s = this._currentContext;
    this._currentContext = t || Ze;
    try {
      return n.call(r, ...i);
    } finally {
      this._currentContext = s;
    }
  }
}
function j_(e) {
  if (e !== null) {
    if (e === void 0) {
      const t = new $_();
      t.enable(), j.setGlobalContextManager(t);
      return;
    }
    e.enable(), j.setGlobalContextManager(e);
  }
}
function B_(e) {
  if (e !== null) {
    if (e === void 0) {
      Z.setGlobalPropagator(new Vp({
        propagators: [
          new Wa(),
          new yp()
        ]
      }));
      return;
    }
    Z.setGlobalPropagator(e);
  }
}
class F_ extends U_ {
  /**
   * Constructs a new Tracer instance.
   * @param config Web Tracer config
   */
  constructor(t = {}) {
    super(t);
  }
  /**
   * Register this TracerProvider for use with the OpenTelemetry API.
   * Undefined values may be replaced with defaults, and
   * null values will be skipped.
   *
   * @param config Configuration object for SDK registration
   */
  register(t = {}) {
    V.setGlobalTracerProvider(this), B_(t.propagator), j_(t.contextManager);
  }
}
const V_ = "session.id", H_ = "deployment.environment.name", G_ = "service.namespace", z_ = "process.runtime.name", q_ = "process.runtime.version", K_ = "telemetry.distro.name", W_ = "telemetry.distro.version", X_ = "browser.brands", Y_ = "browser.language", Q_ = "browser.mobile", J_ = "browser.platform";
class Z_ {
  constructor(t, n) {
    this.processor = t, this.metas = n;
  }
  forceFlush() {
    return this.processor.forceFlush();
  }
  onStart(t, n) {
    var r;
    const i = this.metas.value.session;
    i != null && i.id && (t.attributes[V_] = i.id);
    const s = (r = this.metas.value.user) !== null && r !== void 0 ? r : {};
    s.email && (t.attributes["user.email"] = s.email), s.id && (t.attributes["user.id"] = s.id), s.username && (t.attributes["user.name"] = s.username), s.fullName && (t.attributes["user.full_name"] = s.fullName), s.roles && (t.attributes["user.roles"] = s.roles.split(",").map((o) => o.trim())), s.hash && (t.attributes["user.hash"] = s.hash), this.processor.onStart(t, n);
  }
  onEnd(t) {
    this.processor.onEnd(t);
  }
  shutdown() {
    return this.processor.shutdown();
  }
}
function eb(e = {}) {
  var t;
  return ((t = e.attributes) === null || t === void 0 ? void 0 : t.isSampled) === "true" ? re.RECORD_AND_SAMPLED : re.NOT_RECORD;
}
class cr extends ve {
  constructor(t = {}) {
    super(), this.options = t, this.name = "@grafana/faro-web-tracing", this.version = X;
  }
  initialize() {
    var t, n, r, i, s;
    const o = this.options, a = {};
    this.config.app.name && (a[Va] = this.config.app.name), this.config.app.namespace && (a[G_] = this.config.app.namespace), this.config.app.version && (a[Mp] = this.config.app.version), this.config.app.environment && (a[H_] = this.config.app.environment, a[xp] = this.config.app.environment);
    const c = this.metas.value.browser;
    at(c == null ? void 0 : c.brands) && (a[X_] = c.brands.map((p) => p.brand)), c != null && c.language && (a[Y_] = c.language), typeof (c == null ? void 0 : c.mobile) == "boolean" && (a[Q_] = !!c.mobile), c != null && c.os && (a[J_] = c.os), c != null && c.userAgent && (a[kp] = c.userAgent), a[z_] = "browser", a[q_] = (t = this.metas.value.browser) === null || t === void 0 ? void 0 : t.userAgent, a[K_] = "faro-web-sdk", a[W_] = X, Object.assign(a, o.resourceAttributes);
    const u = Hc().merge(Vc(a));
    new F_({
      resource: u,
      sampler: {
        shouldSample: () => ({
          decision: eb(this.api.getSession())
        })
      },
      spanProcessors: [
        (n = o.spanProcessor) !== null && n !== void 0 ? n : new Z_(new y_(new Zm({ api: this.api }), {
          scheduledDelayMillis: cr.SCHEDULED_BATCH_DELAY_MS,
          maxExportBatchSize: 30
        }), this.metas)
      ]
    }).register({
      propagator: (r = o.propagator) !== null && r !== void 0 ? r : new Wa(),
      contextManager: o.contextManager
    });
    const { propagateTraceHeaderCorsUrls: m, fetchInstrumentationOptions: l, xhrInstrumentationOptions: d } = (i = this.options.instrumentationOptions) !== null && i !== void 0 ? i : {};
    og({
      instrumentations: (s = o.instrumentations) !== null && s !== void 0 ? s : l_({
        ignoreUrls: this.getIgnoreUrls(),
        propagateTraceHeaderCorsUrls: m,
        fetchInstrumentationOptions: l,
        xhrInstrumentationOptions: d
      })
    }), this.api.initOTEL(V, j);
  }
  getIgnoreUrls() {
    return this.transports.transports.flatMap((t) => t.getIgnoreUrls());
  }
}
cr.SCHEDULED_BATCH_DELAY_MS = 1e3;
const tb = "https://faro-api-prod-us-central-0.grafana.net/faro/api/v1", bb = {
  dev: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: ""
  },
  integ: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: ""
  },
  staging: {
    appId: "2648",
    collectorKey: "31fe883638ce2949dae5fb9394a4af36",
    stackId: "460827",
    apiKey: ""
  },
  prod: {
    appId: "2654",
    collectorKey: "cea6cabaf330b91f743edac5a9591a5a",
    stackId: "406974",
    apiKey: ""
  }
}, vb = {
  dev: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: ""
  },
  integ: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: ""
  },
  staging: {
    appId: "2649",
    collectorKey: "264fd5022f4b2f6f4041445211f703b1",
    stackId: "460827",
    apiKey: ""
  },
  prod: {
    appId: "2653",
    collectorKey: "9ad053e4209158dd63e46a89d2583082",
    stackId: "406974",
    apiKey: ""
  }
};
function Eb(e, t) {
  return e[t] || e.integ;
}
const nb = "https://faro-collector-prod-us-central-0.grafana.net/collect";
function rb(e) {
  return {
    url: `${nb}/${e.collectorKey}`,
    app: {
      name: e.name,
      version: e.version,
      environment: e.environment || "production"
    },
    sessionTracking: e.sessionTracking ? { enabled: !0, persistent: !0, samplingRate: 0.1 } : void 0
  };
}
function ib(e) {
  return !!e && e !== "local" && e !== "dev";
}
function Sb(e) {
  const { additionalInstrumentations: t = [] } = e;
  if (!ib(e.environment))
    return null;
  const n = rb({
    name: e.name,
    version: e.version,
    collectorKey: e.collectorKey,
    appId: e.appId,
    environment: e.environment,
    sessionTracking: e.sessionTracking
  });
  return ff(mr(It({}, n), {
    instrumentations: [..._a(), new cr(), ...t]
  }));
}
function sb(e) {
  return !!e;
}
function Tb(e, t, n) {
  const r = t[n] || t.integ;
  return sb(r.apiKey) ? {
    appName: e,
    appId: r.appId,
    endpoint: `${tb}/app/${r.appId}/sourcemaps`,
    apiKey: r.apiKey,
    stackId: r.stackId,
    gzipContents: !0
  } : null;
}
const yb = "foobar";
export {
  tb as FARO_API_ENDPOINT,
  nb as FARO_COLLECTOR_BASE,
  rb as createFaroConfig,
  ab as filterTokensFromPerformance,
  yb as foobar,
  Eb as getFaroConfig,
  Tb as getFaroPluginOptions,
  cb as getUrlParam,
  Sb as initializeFaroForApp,
  bb as senderFaroConfig,
  ib as shouldEnableFaro,
  sb as shouldIncludeFaroPlugin,
  vb as signerFaroConfig,
  ub as tokenInUrl,
  lb as validateInput
};
//# sourceMappingURL=index.es.js.map
